var _polygon, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccineDevelopmentAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-156",
    d: "M78.11,441.57c-94.94-54.81-94.94-143.68,0-198.49s248.85-54.81,343.78,0,94.94,143.68,0,198.49S173,496.38,78.11,441.57Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-156",
    d: "M43.33,385.45l2.41,1.39a4.13,4.13,0,0,0,3.75,0l5-2.91a4.13,4.13,0,0,1,3.75,0l38.46,22.2a1.15,1.15,0,0,1,0,2.17l-5,2.91a1.14,1.14,0,0,0,0,2.16l75.4,43.53a4.13,4.13,0,0,0,3.75,0l.64-.37a4.13,4.13,0,0,1,3.75,0l5.05,2.91a4.13,4.13,0,0,0,3.75,0l.65-.37a4.13,4.13,0,0,1,3.75,0l5,2.91a4.13,4.13,0,0,0,3.75,0l.65-.37a1.15,1.15,0,0,0,0-2.17l-5.05-2.91a1.15,1.15,0,0,1,0-2.17l.65-.37a1.14,1.14,0,0,0,0-2.16l-5-2.92a1.14,1.14,0,0,1,0-2.16l.64-.37a1.14,1.14,0,0,0,0-2.17l-75.39-43.53a4.13,4.13,0,0,0-3.75,0l-.65.38a4.19,4.19,0,0,1-3.75,0L67.08,378.85a1.14,1.14,0,0,1,0-2.16l5-2.91a1.14,1.14,0,0,0,0-2.17l-2.41-1.39a4.13,4.13,0,0,0-3.75,0L43.33,383.29A1.14,1.14,0,0,0,43.33,385.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-156",
    cx: 257.41,
    cy: 244.39,
    rx: 43.68,
    ry: 25.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-156",
    cx: 398.74,
    cy: 386.44,
    rx: 48.15,
    ry: 27.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-156",
    cx: 294.72,
    cy: 441.98,
    rx: 45.74,
    ry: 26.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-156",
    d: "M19.26,318.69l73.61,42.52a5.66,5.66,0,0,0,5.13,0l132.75-76.63c1.42-.82,1.42-2.15,0-3l-73.6-42.52a5.68,5.68,0,0,0-5.14,0L19.26,315.72C17.84,316.54,17.84,317.87,19.26,318.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-156",
    cx: 202.96,
    cy: 383.72,
    rx: 49.38,
    ry: 24.26,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microscope--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.35,121.06c-2.36-1.47-5.67-1.31-9.33.81a22.44,22.44,0,0,0-5.57,4.66c-.42.46-.81.94-1.18,1.43a.22.22,0,0,1-.07.07,31.68,31.68,0,0,0-4.89,9.1,23,23,0,0,0-1.25,7.16c0,4,1.38,6.89,3.62,8.28l4.32,2.5a6.46,6.46,0,0,1-1.74-1.61,10.93,10.93,0,0,1-1.88-6.67c0-8.26,5.8-18.3,13-22.44a10.93,10.93,0,0,1,6.76-1.69,6.25,6.25,0,0,1,2.49.85h0Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.35,121.06c-2.36-1.47-5.67-1.31-9.33.81a22.44,22.44,0,0,0-5.57,4.66c-.42.46-.81.94-1.18,1.43a.22.22,0,0,1-.07.07,31.68,31.68,0,0,0-4.89,9.1,23,23,0,0,0-1.25,7.16c0,4,1.38,6.89,3.62,8.28l4.32,2.5a6.46,6.46,0,0,1-1.74-1.61,10.93,10.93,0,0,1-1.88-6.67c0-8.26,5.8-18.3,13-22.44a10.93,10.93,0,0,1,6.76-1.69,6.25,6.25,0,0,1,2.49.85h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,123.51a6.25,6.25,0,0,0-2.49-.85,10.93,10.93,0,0,0-6.76,1.69c-7.15,4.14-13,14.18-13,22.44a10.93,10.93,0,0,0,1.88,6.67A6.46,6.46,0,0,0,81,155.07l.21.11a6.48,6.48,0,0,0,3.56.84,11.86,11.86,0,0,0,5.56-1.76c7.15-4.12,13-14.17,13-22.42C103.29,127.77,101.87,124.89,99.58,123.51Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,123.51a6.25,6.25,0,0,0-2.49-.85,10.93,10.93,0,0,0-6.76,1.69c-7.15,4.14-13,14.18-13,22.44a10.93,10.93,0,0,0,1.88,6.67A6.46,6.46,0,0,0,81,155.07l.21.11a6.48,6.48,0,0,0,3.56.84,11.86,11.86,0,0,0,5.56-1.76c7.15-4.12,13-14.17,13-22.42C103.29,127.77,101.87,124.89,99.58,123.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.33,133.29c2.88-1.67,5.22-.32,5.22,3a11.55,11.55,0,0,1-5.22,9c-2.88,1.66-5.22.31-5.22-3A11.53,11.53,0,0,1,90.33,133.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.76,180V142.14l20.2.06v37.87h0c0,1.5-1,3-3,4.12a15.79,15.79,0,0,1-14.28-.05C167.74,183,166.76,181.5,166.76,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,174c0,1.49-1,3-3,4.11a15.76,15.76,0,0,1-14.28,0c-2-1.15-3-2.64-3-4.13v6c0,1.49,1,3,3,4.13a15.79,15.79,0,0,0,14.28.05c2-1.14,3-2.63,3-4.12h0v-6Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,174c0,1.49-1,3-3,4.11a15.76,15.76,0,0,1-14.28,0c-2-1.15-3-2.64-3-4.13v6c0,1.49,1,3,3,4.13a15.79,15.79,0,0,0,14.28.05c2-1.14,3-2.63,3-4.12h0v-6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,180V142.14l-20.2.06v37.87h0c0,1.5,1,3,3,4.12a15.81,15.81,0,0,0,14.29-.05C141.63,183,142.61,181.5,142.6,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,174c0,1.49,1,3,3,4.11a15.78,15.78,0,0,0,14.29,0c2-1.15,3-2.64,2.94-4.13v6c0,1.49-1,3-2.94,4.13a15.81,15.81,0,0,1-14.29.05c-2-1.14-3-2.63-3-4.12h0v-6Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,174c0,1.49,1,3,3,4.11a15.78,15.78,0,0,0,14.29,0c2-1.15,3-2.64,2.94-4.13v6c0,1.49-1,3-2.94,4.13a15.81,15.81,0,0,1-14.29.05c-2-1.14-3-2.63-3-4.12h0v-6Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,192.81V154.93l20.2.07v37.87h0c0,1.49-1,3-3,4.11a15.76,15.76,0,0,1-14.28,0C145.53,195.79,144.55,194.3,144.56,192.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,186.81c0,1.5-1,3-3,4.12a15.79,15.79,0,0,1-14.28-.05c-2-1.14-2.95-2.64-2.94-4.13v6.06c0,1.49,1,3,2.94,4.13a15.76,15.76,0,0,0,14.28,0c2-1.13,3-2.62,3-4.11h0v-6.06Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,135.43c.41,5.16-2.8,10.41-9.62,14.37l-23.36,13.5c-12.91,7.5-33.87,7.57-46.82.15-6.46-3.7-9.7-8.56-9.74-13.44,0-2.45,0-6.52,0-10.58,0-6.92,0-19.26,0-24.77a12.1,12.1,0,0,1,1.86-6.32,14.81,14.81,0,0,1,13.56-6.87l1.13.07a81.45,81.45,0,0,0,25.93-2.93C154,95.3,169,96.53,179.16,102.32c6.49,3.73,9.73,8.63,9.73,13.53,0,7.62,0,11.63,0,15.88,0,.26,0,.53,0,.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,115.85a12.13,12.13,0,0,1-1.84,6.31A14.83,14.83,0,0,1,173.48,129l-1.13-.07a81.48,81.48,0,0,0-25.93,2.93c-12.23,3.32-27.24,2.09-37.36-3.71-6.49-3.72-9.74-8.61-9.74-13.52a12.1,12.1,0,0,1,1.86-6.32,14.81,14.81,0,0,1,13.56-6.87l1.13.07a81.45,81.45,0,0,0,25.93-2.93C154,95.3,169,96.53,179.16,102.32,185.65,106.05,188.89,111,188.89,115.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.66 150.39 153.58 155.06 153.58 150.39 161.66 145.73 161.66 150.39",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06,159.4c13,7.43,33.91,7.36,46.82-.14l23.36-13.5c6.45-3.75,9.67-8.65,9.65-13.55v4c0,4.89-3.2,9.79-9.65,13.54l-23.36,13.5c-12.91,7.51-33.87,7.57-46.82.15-6.46-3.7-9.7-8.56-9.74-13.44v-4C99.36,150.84,102.6,155.7,109.06,159.4Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54,114.48l0-23-66.21.2v23h0c0,4.89,3.26,9.77,9.74,13.49,13,7.42,33.91,7.35,46.81-.15C162.34,124.28,165.55,119.37,165.54,114.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.31,91.72l66.21-.2s0,.21,0,5.1-3.19,9.8-9.65,13.55c-12.9,7.51-33.87,7.57-46.82.15-6.47-3.72-9.72-8.6-9.74-13.49S99.31,91.72,99.31,91.72Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,78.18c12.9-7.51,33.86-7.57,46.81-.15s13,19.53.09,27-33.87,7.57-46.82.15S96.06,85.68,109,78.18Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,78.18c12.9-7.51,33.86-7.57,46.81-.15s13,19.53.09,27-33.87,7.57-46.82.15S96.06,85.68,109,78.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.74,89.68V48.56l-28.62.09V89.77h0c0,2.12,1.41,4.23,4.21,5.83,5.59,3.21,14.65,3.18,20.23-.06C145.36,93.92,146.75,91.8,146.74,89.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.12,48.65l28.62-.09s0,3.91,0,6-1.38,4.23-4.17,5.85c-5.58,3.25-14.64,3.27-20.23.06-2.8-1.6-4.21-3.71-4.21-5.82S118.12,48.65,118.12,48.65Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,42.8c5.58-3.25,14.64-3.27,20.24-.07s5.61,8.44,0,11.69-14.63,3.27-20.23.06S116.71,46,122.29,42.8Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,42.8c5.58-3.25,14.64-3.27,20.24-.07s5.61,8.44,0,11.69-14.63,3.27-20.23.06S116.71,46,122.29,42.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,44.43a16.08,16.08,0,0,1,14.55,0c4,2.31,4,6.07,0,8.41a16.1,16.1,0,0,1-14.56,0C121.14,50.52,121.13,46.76,125.14,44.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.69,50.32a7.82,7.82,0,0,1,1.64,1.24,8.11,8.11,0,0,1-1.61,1.23,16.1,16.1,0,0,1-14.56,0,8,8,0,0,1-1.63-1.23,7.56,7.56,0,0,1,1.61-1.23A16.11,16.11,0,0,1,139.69,50.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,50.89c-.12.56.41,1.14,1.17,1.31a1.28,1.28,0,0,0,1.62-.7c.12-.55-.41-1.14-1.18-1.31A1.28,1.28,0,0,0,135.66,50.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85,50.11a.56.56,0,0,0,.43.66.55.55,0,0,0,.66-.42.57.57,0,0,0-.43-.67A.56.56,0,0,0,133.85,50.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.61,270.06V280L95.35,355.74v-9.91c0-5.46,5.46-13.05,12.19-16.94l106.87-61.7c4.06-2.34,7.65-2.8,9.86-1.62A4.75,4.75,0,0,1,226.61,270.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,224.19l-.17-.09v0c-2.22-1.27-5.86-.83-10,1.55L35.56,287.33c-6.73,3.89-12.19,11.48-12.19,16.94v9.91l72,41.56v-9.91c0-5.46,5.46-13.05,12.19-16.94l106.87-61.7c4.06-2.34,7.65-2.8,9.86-1.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,244.35c-14.51-8.38-38-8.38-52.52,0-8.42,4.85-11.94,11.46-10.59,17.79h0L71.5,288.24l32.32,18.66L149,280.79l0,0c11,.79,22.42-1.23,30.85-6.09C194.34,266.29,194.34,252.72,179.84,244.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.45,235.73V225.24c0-5.49,3.61-11,10.87-15.17,14.5-8.37,38-8.37,52.52,0,7.25,4.19,10.87,9.68,10.86,15.16h0v10.5h0c.1,5.56-3.51,11.13-10.85,15.37-14.51,8.38-38,8.38-52.52,0-7.35-4.24-11-9.81-10.86-15.37Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.45,235.73V225.24c0-5.49,3.61-11,10.87-15.17,14.5-8.37,38-8.37,52.52,0,7.25,4.19,10.87,9.68,10.86,15.16h0v10.5h0c.1,5.56-3.51,11.13-10.85,15.37-14.51,8.38-38,8.38-52.52,0-7.35-4.24-11-9.81-10.86-15.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.58,
    cy: 225.23,
    rx: 37.14,
    ry: 21.44,
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 284.06 103.82 272.62 71.5 253.97 71.5 265.4 103.82 284.06",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 284.06 103.82 272.62 71.5 253.97 71.5 265.4 103.82 284.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 284.06 150.18 257.29 149.03 246.52 103.82 272.62 103.82 284.06",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 284.06 150.18 257.29 149.03 246.52 103.82 272.62 103.82 284.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.5 253.97 116.71 227.86 149.03 246.52 103.82 272.62 71.5 253.97",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,224.66V216.8c0-4.12,2.71-8.24,8.15-11.38,10.87-6.28,28.5-6.28,39.38,0,5.44,3.14,8.15,7.26,8.15,11.37h0v7.87h0c.07,4.17-2.63,8.35-8.14,11.53-10.88,6.28-28.51,6.28-39.38,0-5.51-3.18-8.22-7.36-8.15-11.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.58,
    cy: 216.79,
    rx: 27.85,
    ry: 16.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.58,
    cy: 216.79,
    rx: 26.26,
    ry: 15.16,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,213.35c10.25-5.92,26.88-5.92,37.13,0,3.52,2,5.82,4.49,6.93,7.08-1.11,2.6-3.41,5-6.93,7.08-10.25,5.92-26.88,5.92-37.13,0-3.51-2-5.82-4.48-6.93-7.08C129.19,217.84,131.5,215.38,135,213.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,217.6a10.38,10.38,0,0,0-9.43,0c-2.6,1.5-2.6,3.94,0,5.44a10.44,10.44,0,0,0,9.43,0C160.6,221.54,160.6,219.1,158,217.6Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,223.11a3.26,3.26,0,0,0-2.92,0,.89.89,0,0,0,0,1.69,3.26,3.26,0,0,0,2.92,0A.89.89,0,0,0,146.06,223.11Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,219c0,.71,1,1.3,2.29,1.3s2.28-.59,2.28-1.3-1-1.3-2.28-1.3S148.71,218.3,148.71,219Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,223.54c0,.23.32.41.71.41s.71-.18.71-.41-.32-.4-.71-.4S143.39,223.32,143.39,223.54Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,285.55v16.5L88.14,318.57V302.05c0-9.11,6.4-20.2,14.3-24.76,4-2.31,7.6-2.51,10.19-1S116.73,281.05,116.73,285.55Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,285.55v16.5L88.14,318.57V302.05c0-9.11,6.4-20.2,14.3-24.76,4-2.31,7.6-2.51,10.19-1S116.73,281.05,116.73,285.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.42,256.59l-.22-.14c-2.58-1.46-6.14-1.24-10.07,1-7.9,4.56-14.3,15.64-14.3,24.76v16.52l34.31,19.81V302.05c0-9.11,6.4-20.2,14.3-24.76,3.79-2.19,7.22-2.48,9.77-1.19Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.42,256.59l-.22-.14c-2.58-1.46-6.14-1.24-10.07,1-7.9,4.56-14.3,15.64-14.3,24.76v16.52l34.31,19.81V302.05c0-9.11,6.4-20.2,14.3-24.76,3.79-2.19,7.22-2.48,9.77-1.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.43,288.07c3.16-1.83,5.72-.35,5.72,3.3a12.63,12.63,0,0,1-5.72,9.9c-3.16,1.83-5.72.35-5.72-3.3A12.62,12.62,0,0,1,102.43,288.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7,165.64c-5.25,4.31-12.91,10.49-19.15,19.71A80.76,80.76,0,0,0,89.33,228c0,29.22,16.63,44.32,17.15,44.79-2.54-1.29-6-1-9.76,1.18-7.9,4.57-14.3,15.66-14.3,24.77h0c-.36-.49-8.85-11.85-13.74-33.84a147.85,147.85,0,0,1-3.38-32.17c0-18.38,4.13-34,9.65-45.65,3.48-7.34,6.34-12,12.82-20.35S99.58,151.4,109.08,145a13.1,13.1,0,0,1,7.42-2.45C119.86,148.18,126.55,161.67,121.7,165.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89,143.66a9.62,9.62,0,0,0-4.39-1.07,13.67,13.67,0,0,0-1.7-2.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,130.77a8,8,0,0,0-3.42-1.19,11.12,11.12,0,0,0-3.94.21,17.75,17.75,0,0,0-5,2.05c-12,7.08-25.93,25-32.15,37.77a113.46,113.46,0,0,0-11.65,49.9c0,43.77,17.15,66,17.15,66l22.87,13.18c-.37-.49-8.86-11.86-13.75-33.85a148.21,148.21,0,0,1-3.39-32.17c0-18.37,4.14-34,9.66-45.64,3.48-7.34,6.34-12,12.82-20.35S99.58,151.4,109.07,145c4.66-3.12,9.24-3,12.36-1.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,138.17c-2.36-1.47-5.67-1.31-9.34.81a22.8,22.8,0,0,0-5.56,4.66c-.42.46-.81.94-1.18,1.43a.45.45,0,0,1-.07.07,31.68,31.68,0,0,0-4.89,9.1,23,23,0,0,0-1.25,7.16c0,4,1.38,6.89,3.62,8.28l4.32,2.5a6.31,6.31,0,0,1-1.74-1.61A10.93,10.93,0,0,1,107,163.9c0-8.26,5.81-18.3,13-22.43a10.8,10.8,0,0,1,6.76-1.69,6,6,0,0,1,2.49.85h0Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,138.17c-2.36-1.47-5.67-1.31-9.34.81a22.8,22.8,0,0,0-5.56,4.66c-.42.46-.81.94-1.18,1.43a.45.45,0,0,1-.07.07,31.68,31.68,0,0,0-4.89,9.1,23,23,0,0,0-1.25,7.16c0,4,1.38,6.89,3.62,8.28l4.32,2.5a6.31,6.31,0,0,1-1.74-1.61A10.93,10.93,0,0,1,107,163.9c0-8.26,5.81-18.3,13-22.43a10.8,10.8,0,0,1,6.76-1.69,6,6,0,0,1,2.49.85h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22,140.63a6,6,0,0,0-2.49-.85,10.8,10.8,0,0,0-6.76,1.69c-7.15,4.13-13,14.17-13,22.43a10.93,10.93,0,0,0,1.89,6.67,6.31,6.31,0,0,0,1.74,1.61l.21.12a6.66,6.66,0,0,0,3.56.84,12,12,0,0,0,5.56-1.77c7.15-4.12,12.95-14.16,12.95-22.42C132.92,144.88,131.51,142,129.22,140.63Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22,140.63a6,6,0,0,0-2.49-.85,10.8,10.8,0,0,0-6.76,1.69c-7.15,4.13-13,14.17-13,22.43a10.93,10.93,0,0,0,1.89,6.67,6.31,6.31,0,0,0,1.74,1.61l.21.12a6.66,6.66,0,0,0,3.56.84,12,12,0,0,0,5.56-1.77c7.15-4.12,12.95-14.16,12.95-22.42C132.92,144.88,131.51,142,129.22,140.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,150.4c2.88-1.66,5.22-.32,5.22,3a11.53,11.53,0,0,1-5.22,9c-2.88,1.66-5.22.32-5.22-3A11.53,11.53,0,0,1,120,150.4Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Syringe--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--syringe--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.51,434.85c0,6.35-4.45,14.07-9.94,17.25-2.75,1.59-5.24,1.74-7,.7h0L97.45,410.1l0,0c-1.57-1.12-2.53-3.24-2.53-6.17,0-6.35,4.44-14.07,9.94-17.25,2.54-1.47,4.86-1.7,6.61-.9l0,0,74.08,42.71C187.39,429.45,188.51,431.68,188.51,434.85Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.51,434.85c0,6.35-4.45,14.07-9.94,17.25-2.75,1.59-5.24,1.74-7,.7h0L97.45,410.1l0,0c-1.57-1.12-2.53-3.24-2.53-6.17,0-6.35,4.44-14.07,9.94-17.25,2.54-1.47,4.86-1.7,6.61-.9l0,0,74.08,42.71C187.39,429.45,188.51,431.68,188.51,434.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,446.36c0,6.34,4.46,8.91,10,5.74s9.94-10.9,9.94-17.25-4.46-8.92-10-5.74S168.61,440,168.61,446.36Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,446.36c0,6.34,4.46,8.91,10,5.74s9.94-10.9,9.94-17.25-4.46-8.92-10-5.74S168.61,440,168.61,446.36Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93,374.48c0,6.35,4.46,8.92,10,5.74s9.95-10.9,9.95-17.25-4.46-8.92-10-5.74S43.92,368.13,43.93,374.48Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93,374.48c0,6.35,4.46,8.92,10,5.74s9.95-10.9,9.95-17.25-4.46-8.92-10-5.74S43.92,368.13,43.93,374.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8,373a20.24,20.24,0,0,1-6.92,7.23c-5.49,3.18-10,.61-10-5.74a20.25,20.25,0,0,1,2.79-9.61Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37,375.31c0,6.35,4.46,8.92,10,5.74s9.94-10.9,9.94-17.25-4.46-8.91-10-5.74S45.36,369,45.37,375.31Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37,375.31c0,6.35,4.46,8.92,10,5.74s9.94-10.9,9.94-17.25-4.46-8.91-10-5.74S45.36,369,45.37,375.31Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,393.78a2.2,2.2,0,0,1,1.13,2.2,7.33,7.33,0,0,1-3.31,5.75,2.36,2.36,0,0,1-2.35.24h0L53,373.62h0a2.31,2.31,0,0,1-1-2.15,7.3,7.3,0,0,1,3.32-5.74,2.2,2.2,0,0,1,2.47-.13Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,393.78a2.2,2.2,0,0,1,1.13,2.2,7.33,7.33,0,0,1-3.31,5.75,2.36,2.36,0,0,1-2.35.24h0L53,373.62h0a2.31,2.31,0,0,1-1-2.15,7.3,7.3,0,0,1,3.32-5.74,2.2,2.2,0,0,1,2.47-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.76,395.47a2.85,2.85,0,0,1,0,.51,5.09,5.09,0,0,1,0,.55L54.87,366a2.77,2.77,0,0,1,.45-.31,3.19,3.19,0,0,1,.45-.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,397.43a7.73,7.73,0,0,1-.51,1.33l-53.8-31h0a5.52,5.52,0,0,1,.4-.55l.06-.07c.14-.17.28-.33.43-.48h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,371.17c.56,1,3.74,2.56,7,4.46l44.49,25.64a5.26,5.26,0,0,1-.66.46,2.36,2.36,0,0,1-2.35.24h0L53,373.62a2.31,2.31,0,0,1-1-2.15,7.3,7.3,0,0,1,3.32-5.74l.21-.12c.53-.2.88-.3.88-.3C54.84,366.05,52.81,369.75,53.62,371.17Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,396a7.33,7.33,0,0,1-3.31,5.75,2.36,2.36,0,0,1-2.35.24h0l-6.23-3.6a24.06,24.06,0,0,1,4.67-8.1l6.09,3.51A2.2,2.2,0,0,1,107.8,396Z",
    style: {
      fill: "#396CF0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.76,395.47a2.85,2.85,0,0,1,0,.51,5.09,5.09,0,0,1,0,.55l-8.35-4.81c.19-.25.37-.5.57-.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,393.6c.25-.4.5-.79.77-1.18l8.68,5a7.73,7.73,0,0,1-.51,1.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,401.27a5.26,5.26,0,0,1-.66.46,2.36,2.36,0,0,1-2.35.24h0l-6.23-3.6c.22-.66.49-1.32.77-2Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,399.52a2.2,2.2,0,0,1,1.13,2.2,7.32,7.32,0,0,1-3.32,5.75,2.34,2.34,0,0,1-2.34.24h0l-10-5.75h0a2.31,2.31,0,0,1-1-2.14,7.33,7.33,0,0,1,3.31-5.75,2.24,2.24,0,0,1,2.48-.13Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,399.52a2.2,2.2,0,0,1,1.13,2.2,7.32,7.32,0,0,1-3.32,5.75,2.34,2.34,0,0,1-2.34.24h0l-10-5.75h0a2.31,2.31,0,0,1-1-2.14,7.33,7.33,0,0,1,3.31-5.75,2.24,2.24,0,0,1,2.48-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,399.52a2.2,2.2,0,0,1,1.13,2.2,7.32,7.32,0,0,1-3.32,5.75,2.34,2.34,0,0,1-2.34.24h0l-10-5.75h0a2.31,2.31,0,0,1-1-2.14,7.33,7.33,0,0,1,3.31-5.75,2.24,2.24,0,0,1,2.48-.13Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104,394.38c.15-.11.3-.22.45-.31a3.81,3.81,0,0,1,.46-.22l9.45,5.45-.46.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34,395l9.65,5.56-.7,1.22-9.85-5.68A7.43,7.43,0,0,1,103.34,395Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.17,399.82a5.49,5.49,0,0,1,.06-.8l11.65,6.71a6.58,6.58,0,0,1-.66.46,2.33,2.33,0,0,1-2.35.23L102.14,402h0A2.31,2.31,0,0,1,101.17,399.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,413.22c-4.58,2.65-8.3.51-8.3-4.78s3.7-11.72,8.28-14.37,8.3-.51,8.3,4.78S119,410.57,114.45,413.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,413.73c-4.58,2.65-8.3.51-8.3-4.78s3.7-11.72,8.28-14.37,8.3-.51,8.3,4.78S119.92,411.08,115.34,413.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,430.44c1.38.8,2.19,2.58,2.1,5.18-.19,5.18-3.9,11.61-8.29,14.37-2.2,1.38-4.15,1.57-5.53.78h0l-62.46-36h0c-1.5-.86-2.43-2.72-2.43-5.36,0-5.29,3.7-11.73,8.28-14.38,2.29-1.32,4.37-1.45,5.87-.58Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,446.36c0-6.35,4.45-14.07,9.94-17.25a11.78,11.78,0,0,1,2-.91l3.9,2.24c1.38.8,2.19,2.58,2.1,5.18-.19,5.18-3.9,11.61-8.29,14.37-2.2,1.38-4.15,1.57-5.53.78l-3.89-2.25A11.17,11.17,0,0,1,168.61,446.36Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,446.36c0-6.35,4.45-14.07,9.94-17.25a11.78,11.78,0,0,1,2-.91l3.9,2.24c1.38.8,2.19,2.58,2.1,5.18-.19,5.18-3.9,11.61-8.29,14.37-2.2,1.38-4.15,1.57-5.53.78l-3.89-2.25A11.17,11.17,0,0,1,168.61,446.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.05,414.14c-2.29,1.33-4.36,1.45-5.87.59s-2.43-2.72-2.43-5.37c0-5.29,3.7-11.72,8.28-14.37,2.29-1.33,4.37-1.45,5.87-.59s2.43,2.72,2.43,5.37,1.51,7,0,9.58S118.34,412.82,116.05,414.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,411.41c2.22.81,4.71-1.17,8.17-1.17s4.85-.71,5.56-2.06a4.75,4.75,0,0,1-.46,1.17c-1.5,2.6-6,3.47-8.29,4.79s-4.36,1.45-5.87.59-2.43-2.72-2.43-5.37c0-5.29,3.67-11.73,8.32-14.39C107,403,108.74,410.56,111.07,411.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.05,414.14c-2.29,1.33-4.36,1.45-5.87.59s-2.43-2.72-2.43-5.37c0-5.29,3.7-11.72,8.28-14.37,2.29-1.33,4.37-1.45,5.87-.59s2.43,2.72,2.43,5.37,1.51,7,0,9.58S118.34,412.82,116.05,414.14Z",
    style: {
      fill: "#396CF0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.58,396.06a13.12,13.12,0,0,1,1.51-1,9.56,9.56,0,0,1,1.89-.83l65.87,38L182.19,435Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,398.47a15.86,15.86,0,0,1,1.24-1.34l66.9,38.57-.88,1.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,396.13c-5.79,6.17-3.64,13.21-.41,15.07l59.13,34.08,2.39,5.83a4.06,4.06,0,0,1-2.9-.34l-62.46-36c-1.5-.86-2.43-2.72-2.43-5.36C107.8,404.74,110.65,399.18,114.49,396.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.23,450c-4.39,2.75-7.81.79-7.63-4.39s3.89-11.62,8.29-14.38,7.81-.79,7.63,4.4S182.62,447.23,178.23,450Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.23,450c-4.39,2.75-7.81.79-7.63-4.39s3.89-11.62,8.29-14.38,7.81-.79,7.63,4.4S182.62,447.23,178.23,450Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,438.33a3.5,3.5,0,0,1,1.46,3.22,11,11,0,0,1-5,8.63,3.51,3.51,0,0,1-3.52.35h0L175,446.7h0a3.51,3.51,0,0,1-1.46-3.22,11,11,0,0,1,5-8.62,3.47,3.47,0,0,1,3.51-.35h0l6.64,3.82Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,438.33a3.5,3.5,0,0,1,1.46,3.22,11,11,0,0,1-5,8.63,3.51,3.51,0,0,1-3.52.35h0L175,446.7h0a3.51,3.51,0,0,1-1.46-3.22,11,11,0,0,1,5-8.62,3.47,3.47,0,0,1,3.51-.35h0l6.64,3.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2,435.1c.12-.07.23-.17.36-.24a6,6,0,0,1,1.11-.5l9.49,5.48-.69,1.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,436.34a10.14,10.14,0,0,1,.76-.71l10,5.77-.5.87Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.12,444.4l5.17,3,3,3.24a3,3,0,0,1-2.56-.09L175,446.7a3.51,3.51,0,0,1-1.46-3.22,11,11,0,0,1,5-8.62,6,6,0,0,1,1.11-.5C175.24,437,174.09,443.23,176.12,444.4Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,450.18c-2.75,1.59-5,.3-5-2.87a11,11,0,0,1,5-8.63c2.75-1.58,5-.3,5,2.87A11,11,0,0,1,185.2,450.18Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,450.18c-2.75,1.59-5,.3-5-2.87a11,11,0,0,1,5-8.63c2.75-1.58,5-.3,5,2.87A11,11,0,0,1,185.2,450.18Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,446.9a5.2,5.2,0,0,1-2.34,4.07,1.65,1.65,0,0,1-1.66.16h0l-6.64-3.82a1.67,1.67,0,0,1-.69-1.52,5.19,5.19,0,0,1,2.35-4.07,1.65,1.65,0,0,1,1.66-.16h0l6.63,3.82h0A1.64,1.64,0,0,1,194.18,446.9Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,446.9a5.2,5.2,0,0,1-2.34,4.07,1.65,1.65,0,0,1-1.66.16h0l-6.64-3.82a1.67,1.67,0,0,1-.69-1.52,5.19,5.19,0,0,1,2.35-4.07,1.65,1.65,0,0,1,1.66-.16h0l6.63,3.82h0A1.64,1.64,0,0,1,194.18,446.9Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,442.33a3.74,3.74,0,0,1,.78-.61l.17-.08,7.3,4.21-.54.93Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,443.47a5.58,5.58,0,0,1,.44-.64l7.37,4.25-.39.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.93,441.45a3.58,3.58,0,0,0-2,3.3c.08,1.34.85,1.66,2,2.33l5.16,3,.36,1.1a1.41,1.41,0,0,1-1.23,0h0l-6.64-3.82a1.67,1.67,0,0,1-.69-1.52,5.19,5.19,0,0,1,2.35-4.07A2.11,2.11,0,0,1,185.93,441.45Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,451c-1.3.75-2.35.14-2.35-1.36a5.2,5.2,0,0,1,2.34-4.06c1.3-.75,2.35-.14,2.35,1.35A5.2,5.2,0,0,1,191.84,451Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,451c-1.3.75-2.35.14-2.35-1.36a5.2,5.2,0,0,1,2.34-4.06c1.3-.75,2.35-.14,2.35,1.35A5.2,5.2,0,0,1,191.84,451Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,448.83a6.52,6.52,0,0,0,.93.58l3.39,1.94c1.41.8,3,1.75,4.8,2.73l5.53,3.1L217,462.93l3.41,1.9,1,.53c.22.13.36.16.38.12h0s-.07-.14-.29-.27l-.94-.56-3.35-2L207,456.56l-5.45-3.23c-1.73-1-3.37-2-4.77-2.78l-3.37-2a7,7,0,0,0-1-.52A.62.62,0,0,0,192,448.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.51,435.1c-.45-4.66-4-5.16-7.8-2.89s-7.22,8.44-7.77,10.9c1-4.61,4.24-9.56,7.95-11.89C183.13,428.56,186.45,430.31,186.51,435.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,387.7c-4.74,3.62-8.38,10.45-8.38,16.18,0,2.94,1,5.06,2.54,6.18l0,0,74.08,42.7c-1.8-1-2.92-3.27-2.92-6.44l-68.17-39.3C96.68,404.89,95.58,397.28,103.31,387.7Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,440.06c1.69-4.51,4.95-8.78,8.69-10.95,5.5-3.18,10-.61,10,5.74a14,14,0,0,1-.11,1.69c.21-3.26-1.09-7.37-4.9-7.91S173.56,432,169.86,440.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.59,428.41l-74.08-42.7,0,0c-1.75-.8-4.07-.57-6.61.9l-.35.22c4.57-2.14,6.87,0,10.9,2.28l67,38.64A5.33,5.33,0,0,1,185.59,428.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,441.55c0,.1,0,.2,0,.29-.1-1.62-1.07-3.54-3.31-3.14s-6.51,4.22-6.4,10.15a5.15,5.15,0,0,1-.22-1.54,11,11,0,0,1,5-8.63C187.94,437.1,190.17,438.38,190.17,441.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,446.9a4,4,0,0,1-.13,1c.08-1-.28-2.17-1.25-2.23s-2.94,1.11-3.28,4.26a2.23,2.23,0,0,1,0-.27,5.2,5.2,0,0,1,2.34-4.06C193.13,444.8,194.18,445.41,194.18,446.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,363.8a14.21,14.21,0,0,1-.08,1.44C66,356,57.52,355.85,52,361.75s-6.74,14.09-6.21,16.62a10.53,10.53,0,0,1-.42-3.06c0-6.35,4.45-14.07,9.94-17.25S65.26,357.46,65.27,363.8Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glass-flasks--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flask--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.6,375.09a10.85,10.85,0,0,0-2-6.19L214.8,322.4V282.07l-23.68.05V322.4l-31.77,46.5a10.92,10.92,0,0,0-2,6.19c0,.1,0,.19,0,.29h0c0,.24,0,.48,0,.72a11.52,11.52,0,0,0,.16,1.65c.91,5.94,5.3,11.75,13.18,16.3,17.83,10.29,46.73,10.29,64.55,0,9-5.17,13.41-12,13.36-18.75C248.59,375.23,248.6,375.16,248.6,375.09Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.6,375.09a10.85,10.85,0,0,0-2-6.19L214.8,322.4V282.07l-23.68.05V322.4l-31.77,46.5a10.92,10.92,0,0,0-2,6.19c0,.1,0,.19,0,.29h0c0,.24,0,.48,0,.72a11.52,11.52,0,0,0,.16,1.65c.91,5.94,5.3,11.75,13.18,16.3,17.83,10.29,46.73,10.29,64.55,0,9-5.17,13.41-12,13.36-18.75C248.59,375.23,248.6,375.16,248.6,375.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,372.85l-8.25-12.08-11.77-17.44-40.27-.05-11.79,17.48-8.26,12.09a5.88,5.88,0,0,0-.4,2,5.68,5.68,0,0,0,.23,1.73.44.44,0,0,0,0,.1c1,4.76,4.86,9.38,11.63,13,15.84,8.56,41.53,8.56,57.39,0,6.74-3.64,10.62-8.24,11.62-13a.08.08,0,0,1,0,0,5.37,5.37,0,0,0,.24-1.91,0,0,0,0,0,0-.05A5.94,5.94,0,0,0,243.13,372.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.58 285.64 213.29 285.11 213.13 323.39 232.85 354.22 211.58 323.86 211.58 285.64",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,289.37s-2.39,2.16-11.83,2.16-11.85-2.11-11.85-2.11v-7.3l23.68-.05Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,285.76S211,287.91,203,287.91s-11.85-2.1-11.85-2.1v-3.69l23.68-.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.7,337.48c-7.37-1-15.82-.37-21.57,2-8,3.31-8,8.69,0,12s21.19,3.31,29.47,0,8.27-8.69,0-12a34.71,34.71,0,0,0-7.9-2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,274.37c-5.81-2.33-15.08-2.33-20.7,0s-5.62,6.1,0,8.43,14.89,2.33,20.7,0S219.05,276.7,213.24,274.37Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,274.37c-5.81-2.33-15.08-2.33-20.7,0s-5.62,6.1,0,8.43,14.89,2.33,20.7,0S219.05,276.7,213.24,274.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,278.79c1,.79,4.4,2.52,13,1.53,7.58-.87,6.54-4.7.44-5.14S194.72,278.79,194.72,278.79Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62,275.52a28.67,28.67,0,0,0-13.41,0c-3.64,1.06-3.64,2.78,0,3.84a28.67,28.67,0,0,0,13.41,0C213.39,278.3,213.39,276.58,209.62,275.52Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62,275.52a28.67,28.67,0,0,0-13.41,0c-3.64,1.06-3.64,2.78,0,3.84a28.67,28.67,0,0,0,13.41,0C213.39,278.3,213.39,276.58,209.62,275.52Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,350.23c-10.17,5-26.4,2-30.87-2.3s1.78-8.76,6.59-10.44a32.92,32.92,0,0,0-7.77,2c-8,3.31-8,8.69,0,12s21.19,3.31,29.47,0A18.82,18.82,0,0,0,220.18,350.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,282.8a8.31,8.31,0,0,0,3.82-2.63c-5.06,4-17.45,3.41-22.6,1.66s-5.31-5.19-3.27-6.8c-4.21,2.33-3.77,5.65,1.35,7.77C198.16,285.13,207.43,285.13,213.24,282.8Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62,275.52a25.86,25.86,0,0,0-6.65-.79v5.42a26.31,26.31,0,0,0,6.65-.79C213.39,278.3,213.39,276.58,209.62,275.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,274.37c-4.58-1.83-11.29-2.21-16.68-1.16.55,0,11-1.18,16.5,1.64,4.8,2.46,4.57,4.65,3.31,6.1C218.72,278.77,217.68,276.15,213.24,274.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.72,326.39V284.31a25.46,25.46,0,0,1-5.19-1.14v40.69l-32.08,46.85c-2.05,3.07-.57,7.51,1.15,11.12,1.43,3,6,6.94,9.19,8.78a51,51,0,0,0,19.09,6.89s-13.17-6.89-15.78-12.08c-1.94-3.85-.21-9.7,2.59-14.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-156"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.72,
    cy: 441.83,
    rx: 32,
    ry: 18.48,
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.72,
    cy: 441.83,
    rx: 32,
    ry: 18.48,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,359.68V315l-27.9.06v44.61a49.33,49.33,0,1,0,27.92,0Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,359.68V315l-27.9.06v44.61a49.33,49.33,0,1,0,27.92,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.98 360.07 306.89 318.6 304.88 319.23 304.88 360.07 305.98 360.07",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,323.63s-2.81,2.53-13.94,2.53-14-2.48-14-2.48v-8.61l27.9-.06Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,319s-4.42,2.53-13.94,2.53-14-2.48-14-2.48v-4l27.9-.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,305.94c-6.86-2.75-17.78-2.75-24.41,0s-6.63,7.19,0,9.94,17.55,2.74,24.41,0S313.69,308.68,306.84,305.94Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,305.94c-6.86-2.75-17.78-2.75-24.41,0s-6.63,7.19,0,9.94,17.55,2.74,24.41,0S313.69,308.68,306.84,305.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,311.15c1.2.92,5.19,3,15.31,1.81,8.95-1,7.72-5.55.52-6.07S285,311.15,285,311.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,307.29a33.79,33.79,0,0,0-15.81,0c-4.3,1.25-4.3,3.28,0,4.53a33.79,33.79,0,0,0,15.81,0C307,310.57,307,308.54,302.57,307.29Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,307.29a33.79,33.79,0,0,0-15.81,0c-4.3,1.25-4.3,3.28,0,4.53a33.79,33.79,0,0,0,15.81,0C307,310.57,307,308.54,302.57,307.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,315.87a9.68,9.68,0,0,0,4.5-3.1c-6,4.67-20.57,4-26.64,2s-6.26-6.13-3.86-8c-5,2.75-4.45,6.67,1.59,9.17C289.06,318.62,300,318.62,306.84,315.87Z",
    style: {
      fill: "#396CF0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,307.29a31,31,0,0,0-7.84-.93v6.39a31,31,0,0,0,7.84-.93C307,310.57,307,308.54,302.57,307.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,305.94c-5.4-2.16-13.31-2.61-19.67-1.37.65,0,13-1.39,19.46,1.93,5.65,2.9,5.39,5.48,3.89,7.2C313.3,311.13,312.08,308,306.84,305.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,407a43.53,43.53,0,1,1-83.48-17.27c1.72-4.08,5.35-8,10.87-11.14,16.06-9.27,42.1-9.27,58.17,0,5.52,3.18,9.14,7.06,10.87,11.14A43.41,43.41,0,0,1,338.25,407Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,407a43.28,43.28,0,0,0-3.49-17.06c-3.39,5.89-13.57,23.63-13.57,23.63,0,15.83-11.4,36.95-26.47,36.95A43.53,43.53,0,0,0,338.25,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81,412.17c-16.07,9.27-42.11,9.27-58.17,0-10.55-6.09-14.18-14.66-10.87-22.45,1.72-4.08,5.35-8,10.87-11.14,16.06-9.27,42.1-9.27,58.17,0,5.52,3.18,9.14,7.06,10.87,11.14C338,397.51,334.35,406.08,323.81,412.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,404.78c-10.34-10.52-2.12-25.44,5-28.86a44.43,44.43,0,0,0-5.55,2.66c-5.52,3.18-9.15,7.06-10.87,11.14-3.31,7.79.32,16.36,10.87,22.45,13.6,7.85,34.35,9,50.15,3.58C298,418.44,276.33,415.13,266.16,404.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,366.11V317.93a34.07,34.07,0,0,1-9.4-1.18V362c-21.14,3.9-36.7,23.23-36.7,44.13C248.3,430.36,264,453,294.72,453,253.14,439.34,252,381.65,294.4,366.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.54,379.85l.15-1.36c.5,0,.71.56.91,1.75a25.56,25.56,0,0,0,2.38,7.29,36.13,36.13,0,0,0,5.4,8.2,37.29,37.29,0,0,1,2.88,3.31c.56,1,.75,3.77-.2,4.4-3.49,2.33-8.8,2.4-12.56,1.3a7.22,7.22,0,0,1-5.45-6.13c-.61-3.42-.93-5.53-2.67-8.12-.64-.94-1.67-1.71-2.1-2.77-.78-1.9-.16-4,.34-5.93.43-1.64.89-3.44,1.45-3.29v1c.67.75,3,1.49,5.12,1.57C379.55,381.13,382.55,380.88,382.54,379.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,365.82c.23.16.78.79,1.74,1.67a32.93,32.93,0,0,0,3.08,2.39,57,57,0,0,0,6.87,4.31c2.84,1.56,5.4,2.51,8.79,4a2.82,2.82,0,0,1,.95.63,2.06,2.06,0,0,1,.42.85,3.54,3.54,0,0,1-1.42,3.39,9.59,9.59,0,0,1-3.55,1.51,18.26,18.26,0,0,1-8.84.26,24.83,24.83,0,0,1-7.11-3.28A15.68,15.68,0,0,0,407,379c-1.9-.28-4.24-.19-5.9-1.32-1.83-1.27-1.1-4-.58-6.29.57-2.54.7-6.41,1.85-6.32l.09,1c.1,1.09,2.75,1.6,4.8,1.6,1.7,0,4.92-.44,4.9-1.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.17,257c-.18,8.69-2,66.2-2,66.2A130.84,130.84,0,0,0,370,337.36c-.24,11.49.9,43.41.9,43.41,2.27,3.2,11.22,3.44,14.43,1.27,0,0,2.92-44.23,4.36-55.6,1.25-9.93,5.38-42.37,5.38-42.37l3.2,31.86a97.38,97.38,0,0,0,.25,11.16c.37,5.26,1.41,41.32,1.41,41.32,2.29,2.79,14.42,2.51,16-.35,0,0-.1-49.3,0-54.12.11-5.5-.66-57.57-.66-57.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,271.89a29.1,29.1,0,0,0,9.77-6.27s-1.56,4.55-7.95,8.3l.42,39.68-3.22-29.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.18,199.48c-.22.51,0,.86,1.74.6,3.42-.54,9.55-5.25,11.07-6.15s1.77,1.06,1.18,2.44.05,4.94-1,7.22-1.7,3.49-4.68,5.42c-2.77,1.8-8.95,3.4-11.78,5.93-2.23,3.08-7.37,10.3-10.45,14.36-5,6.53-7.76,11.49-12.53,7.39-3.67-3.15-7.45-6.89-9.3-8.8-5-5.13-13.26-17.11-13.26-17.11L406.1,193.1c-.12.05,2.6.06,3.43,0,5.51.37,7.14.83,10.57,4.59,2.72,3,12.8,18.64,16.41,23.42l11.42-11.63c3-2.91,3.44-6.79,5.21-9.3",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,193c4.22.39,6.49,1.35,10.67,6.87s14,20.08,14,20.08l9.43-9.3s6.56,4.39,8.39,11.24c0,0-8.64,11.08-11.91,14.53s-5.82,3.74-10.28,0-17.37-17.93-17.37-17.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.41,219.93c-1.92,2.77-3.16,7.28-2.82,9.54,0,0-2.66-3.08,1.83-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.6,191.36c-1.63.39-7,.65-11.14,2.12a11.75,11.75,0,0,0-5.29,4c-3,4.44-.11,15.42,2.12,34-.17,12-.51,26.9-.51,26.9,5.51,4,31.23,6.74,42.83-1.73,0,0,.38-45-.39-50.85-1.46-11.19-5.85-14.19-14.9-14.71Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.6,191.36c-1.63.39-7,.65-11.14,2.12a11.75,11.75,0,0,0-5.29,4c-3,4.44-.11,15.42,2.12,34-.17,12-.51,26.9-.51,26.9,5.51,4,31.23,6.74,42.83-1.73,0,0,.38-45-.39-50.85-1.46-11.19-5.85-14.19-14.9-14.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.4,204.51c.82,2.8,5.62,22.48,5,29.41a42.79,42.79,0,0,1-2.86,10.34c-2.09,4.94-3.48.52-4.64-2.39a37,37,0,0,1-2-8.42c-.38-3.71,1.11-15,.54-28.27A2.84,2.84,0,0,1,403.4,204.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.58,198.19c1.91,1.63-.18,6.32-.18,6.32a5.36,5.36,0,0,0-4,.67s-3.8-1.62-3.81-4.43c0-2.56,2.72-1.74,4.66-2.08S403.35,196.82,403.58,198.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.4,204.51c-.31-1.1-1.81-1-3-1.38a3.23,3.23,0,0,1-1.61-1.38c-.61-1.06,0-2.83.86-3h0c-1.85.13-4-.29-4,2,0,2.81,3.81,4.43,3.81,4.43A5.36,5.36,0,0,1,403.4,204.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,159.07c-1.91-5.16-7.54-7.44-13-7.44-7.49,0-11.81,2.82-13.46,4.72-2.32,2.68-3.43,4.63-3.43,9.2a23,23,0,0,0,4.7,14.59h0c.37.82.72,1.56,1,2.1.72,1.49,1.5,3.77,1.5,3.77l-.28-6.27-1-1.16c0-.18,0-.32,0-.32.83,1-.15-2.56,1.25-3.12,1.13-.44,1.06-6.71,1.06-9.7,1.81.06,4.12-3.07,3.85-4.43,1.25.61,4.13,1.56,11.59,1.21,4.62-.23,6.3-3,6.3-3A.22.22,0,0,0,410,159.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.94,183.06c-.78,3.14-2.55,5.46-5.42,6a24.76,24.76,0,0,1-5.29-.14l.13,4.59c2.56,2.83,2.51,4.67-.08,5.2a17,17,0,0,1-3.35.3c-3.28,0-7.27-.78-9.28-3.24l-.68-16a3.69,3.69,0,0,1-4.46,1.39c-2.27-.75-5.13-4.68-3.74-7.81s4.29-1.87,5.2-1l.14.14.07.07c.83,1,1.68,3.13,3.08,2.57,1.13-.44,1.06-6.71,1.06-9.7,2.38-.64,4.12-3.07,3.85-4.43a28.24,28.24,0,0,0,11.38.71c4.58-.6,6.51-2.54,6.51-2.54a.22.22,0,0,0-.05-.11,13.34,13.34,0,0,1,1.23,5.07C411.85,173,412.15,178.26,410.94,183.06Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.23,188.88s-6.46-1.14-8.73-2.28a7.32,7.32,0,0,1-3.18-3,10,10,0,0,0,1.85,3.58c1.69,2.07,10.11,3.54,10.11,3.54Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.07,172.59a1.29,1.29,0,1,1-1.22-1.4A1.32,1.32,0,0,1,398.07,172.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.23,167.74l-2.83,1.38a1.66,1.66,0,0,1,.76-2.16A1.53,1.53,0,0,1,397.23,167.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.81,181.27l4,1.1a2,2,0,0,1-2.52,1.53A2.18,2.18,0,0,1,398.81,181.27Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.57,168.94l-3-1a1.53,1.53,0,0,1,2-1A1.67,1.67,0,0,1,410.57,168.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,172.23a1.29,1.29,0,1,1-1.41-1.22A1.31,1.31,0,0,1,409.1,172.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.13 171.5 402.6 179.25 406.63 177.85 402.13 171.5",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28,198.67c-3.58-.75-12-4.06-12.85-8.19l-.11-2.27c-1.38,0-2,1.55-2.7,3.77-.29,5.84,5.87,11.17,12.06,12.61a10.82,10.82,0,0,1,1.37-3.84A5.25,5.25,0,0,1,400.28,198.67Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.25,189.48a6.19,6.19,0,0,1,2.5,1.5c4.63,4.79,2,11.09,2,11.09a4.7,4.7,0,0,0-1.69-2.64,4.4,4.4,0,0,0-2.77-.76c1.13-1.21.69-3.33.07-5.2Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,171.89v-.09c-.2-1.43-.45-3.22-.7-4.26-.94-3.86-2.4-4.53-10.71-4.13s-12.91,1.38-13.47,5.32c-.15,1.09-.22,3-.28,4.45v0a4.88,4.88,0,0,0,1.44,3.63,4.82,4.82,0,0,0,3.64,1.39l2.9-.15a5.49,5.49,0,0,0,4.87-3.6c.23-.6.7-1.61,1.37-1.65s1.24.93,1.52,1.51c1,2,2.09,3.26,4.28,3.15h.5a4.94,4.94,0,0,0,4.65-5.61ZM409.49,176l-.51,0c-1.61.08-2.16-.88-2.87-2.33-.6-1.21-1.53-2.39-2.93-2.33s-2.21,1.35-2.68,2.6a4,4,0,0,1-3.56,2.65l-2.9.15a3.37,3.37,0,0,1-3.52-3.49c.06-1.42.13-3.32.27-4.35.35-2.43,3.18-3.59,12.07-4s8.62.6,9.2,3c.24,1,.49,2.82.68,4.2A3.46,3.46,0,0,1,409.49,176Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,171.89v-.09c-.2-1.43-.45-3.22-.7-4.26-.94-3.86-2.4-4.53-10.71-4.13s-12.91,1.38-13.47,5.32c-.15,1.09-.22,3-.28,4.45v0a4.88,4.88,0,0,0,1.44,3.63,4.82,4.82,0,0,0,3.64,1.39l2.9-.15a5.49,5.49,0,0,0,4.87-3.6c.23-.6.7-1.61,1.37-1.65s1.24.93,1.52,1.51c1,2,2.09,3.26,4.28,3.15h.5a4.94,4.94,0,0,0,4.65-5.61ZM409.49,176l-.51,0c-1.61.08-2.16-.88-2.87-2.33-.6-1.21-1.53-2.39-2.93-2.33s-2.21,1.35-2.68,2.6a4,4,0,0,1-3.56,2.65l-2.9.15a3.37,3.37,0,0,1-3.52-3.49c.06-1.42.13-3.32.27-4.35.35-2.43,3.18-3.59,12.07-4s8.62.6,9.2,3c.24,1,.49,2.82.68,4.2A3.46,3.46,0,0,1,409.49,176Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.74,172.09a3.46,3.46,0,0,1-3.25,3.92l-.51,0c-1.61.08-2.16-.88-2.87-2.33-.6-1.21-1.53-2.39-2.93-2.33s-2.21,1.35-2.68,2.6a4,4,0,0,1-3.56,2.65l-2.9.15a3.37,3.37,0,0,1-3.52-3.49c.06-1.42.13-3.32.27-4.35.35-2.43,3.18-3.59,12.07-4s8.62.6,9.2,3C412.3,168.87,412.55,170.71,412.74,172.09Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.26,190.33s2.91,14.08,4.09,23.33.95,35.37.32,52c-.46,12.07-2.26,34.39-2.26,34.39s-3,.6-10.17-.58a28.19,28.19,0,0,1-10.55-3.62s1.14-33.94,2-45.79c.79-10.93.76-16.94.76-16.94l-2.57-24.94s-.6-11.41,3.84-13.5C378.66,191.85,387.26,190.33,387.26,190.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,186.27c-.76-.16-1.45.24-2.07,1.29l-2.57,4.34s-.11,6.28.59,8.11c.61,1.58,4.65,9.05,4.65,9.05s-.26,7.27-.33,9.43,4.14,11.22,4.61,15.43c0,0,.21-17.09-.42-21.83-1.08-8.26-2.44-18.15-4.27-21.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.23,188.88c1,.09,1.86,1.56,4.15,2.24,4.28,1.26,7.35,1.86,7.35,1.86,2.34,4.19,4.32,9.18,5,28.56s.95,74.58.95,74.58a15,15,0,0,1-6.54,1.33s.17-60.92-.23-74.62-2.49-20.38-5.45-24.9c-.84-3.78-3.5-6.28-5.23-8.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.49,197.93c3,4.52,5,11.2,5.45,24.9,0,1.63.09,3.91.13,6.67h0s2.44-12.42,2-15.05-3.29-8.1-3.29-8.1a24.39,24.39,0,0,0-2.42-12.79,8.28,8.28,0,0,0-1.51-2,13.1,13.1,0,0,0-1.85-1.26,8.12,8.12,0,0,0-3.77-1.45l0,.93C402,191.65,404.65,194.15,405.49,197.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.65,259.73l-1.46.85h0a2.1,2.1,0,0,0-.15-.22,1.82,1.82,0,0,0-.35-.38,1.15,1.15,0,0,0-.19-.14l-12.06-6.95-3.57-2-1.45-.83L342.6,238a.71.71,0,0,0-.64-.1l1.42-.83a.55.55,0,0,1,.25-.07.78.78,0,0,1,.44.14l19.87,11.45,2.35,1.36,3.51,2,.1.06L382,259a1.21,1.21,0,0,1,.2.14A2,2,0,0,1,382.65,259.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.11,295.65h0l1.52-.88a.74.74,0,0,0,.27-.63V260.69a2.09,2.09,0,0,0-.29-1l-1.47.86h0a1.94,1.94,0,0,1,.29,1v33.58A.57.57,0,0,1,381.11,295.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.62,238.57l0,33.4a2.16,2.16,0,0,0,1,1.7l38,21.95a.58.58,0,0,0,.87-.5V261.54a1.94,1.94,0,0,0-.29-1,2,2,0,0,0-.69-.73l-12.06-7-3.57-2L342.6,238a.71.71,0,0,0-.64-.1l0,0h0A.69.69,0,0,0,341.62,238.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,241c8.12-33.2,10.11-41.51,22.19-45.49,2.88,3.44-.19,16.39-2.09,21.6,0,0-8.73,21.32-10.35,28.93-1.42,6.69-3,15.1-2.93,20.85a4.16,4.16,0,0,0,1.13,2.73c1.85,2,1.86,3.63,3.06,5.85.94,1.74,2,2.39,1.68,2.78a2.26,2.26,0,0,1-3.05.23,11.49,11.49,0,0,1-2.31-2.22,25.63,25.63,0,0,0,1.8,7.63l2.06,1.19s-.63,2.15-5.61.72c-5.63-1.62-7.65-2.32-8.25-11.87a73.38,73.38,0,0,1-.1-10.57C349.26,254.32,349.87,246.36,351.18,241Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.41,193.62s-10.13,2.55-12.51,6.2c-2.75,4.22-4.44,10.91-9.08,27.38s-5.19,23.46-6.05,34.59c0,0,2.87,7,12.32,3.61,0,0,3.61-15.15,5.53-22.82a140.75,140.75,0,0,1,8.06-22.14S379.16,205.08,375.41,193.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,288.24c.46.28.65-.57.76-1.83l0-2.32s1.78,1.59,2.21-3.78c.48-5.91-2.17-7-2.17-7s0-1,0-2.93-.41-2.42-.86-2.75l-.66-.33v20.52S383.18,288,383.63,288.24Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.63,288.24c.46.28.65-.57.76-1.83l0-2.32s1.78,1.59,2.21-3.78c.48-5.91-2.17-7-2.17-7s0-1,0-2.93-.41-2.42-.86-2.75l-.66-.33v20.52S383.18,288,383.63,288.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383,269.71l-1.52-.7c0,.66-.34,2.87-1,2.5-.16-.09-.39-.24-.65-.41,0-2.57-.2-4.53-.8-4.9l-1.33-.8.08,18.87,1.33.8c.57.34.69-1.53.72-3.44l.33.2c1.13.69,1.3,1.73,1.3,3.49l1.7,1.19Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,269.71l-1.52-.7c0,.66-.34,2.87-1,2.5-.16-.09-.39-.24-.65-.41,0-2.57-.2-4.53-.8-4.9l-1.33-.8.08,18.87,1.33.8c.57.34.69-1.53.72-3.44l.33.2c1.13.69,1.3,1.73,1.3,3.49l1.7,1.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.72,221.79a3.66,3.66,0,0,0-.69-2.09L468.3,204V190.35l-8,0V204L449.56,219.7a3.73,3.73,0,0,0-.69,2.09s0,.06,0,.1h0c0,.08,0,.16,0,.24a3.53,3.53,0,0,0,.05.56c.31,2,1.79,4,4.46,5.51,6,3.47,15.79,3.47,21.81,0,3-1.75,4.53-4,4.51-6.34A.2.2,0,0,0,479.72,221.79Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.72,221.79a3.66,3.66,0,0,0-.69-2.09L468.3,204V190.35l-8,0V204L449.56,219.7a3.73,3.73,0,0,0-.69,2.09s0,.06,0,.1h0c0,.08,0,.16,0,.24a3.53,3.53,0,0,0,.05.56c.31,2,1.79,4,4.46,5.51,6,3.47,15.79,3.47,21.81,0,3-1.75,4.53-4,4.51-6.34A.2.2,0,0,0,479.72,221.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.87,221,475.08,217l-4-5.9H457.5l-4,5.91L450.72,221a1.87,1.87,0,0,0-.13.69,2,2,0,0,0,.07.59v0c.33,1.61,1.64,3.17,3.93,4.41,5.35,2.89,14,2.89,19.39,0,2.28-1.23,3.59-2.79,3.93-4.39,0,0,0,0,0,0a2,2,0,0,0,.08-.64v0A2.17,2.17,0,0,0,477.87,221Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.21 191.56 467.79 191.38 467.73 204.32 474.4 214.74 467.21 204.47 467.21 191.56",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.3,192.82s-.81.73-4,.73-4-.71-4-.71v-2.47l8,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.3,190.9a8.64,8.64,0,0,1-4,.73,8.84,8.84,0,0,1-4-.71v-.55l8,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.57,209.08a15,15,0,0,0-7.29.68c-2.7,1.12-2.7,2.93,0,4.05a15.18,15.18,0,0,0,10,0c2.8-1.12,2.8-2.93,0-4.05a11.46,11.46,0,0,0-2.67-.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.77,187.75a10.76,10.76,0,0,0-7,0c-1.9.79-1.9,2.06,0,2.85a10.63,10.63,0,0,0,7,0C469.73,189.81,469.73,188.54,467.77,187.75Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.77,187.75a10.76,10.76,0,0,0-7,0c-1.9.79-1.9,2.06,0,2.85a10.63,10.63,0,0,0,7,0C469.73,189.81,469.73,188.54,467.77,187.75Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.51,189.25c.34.26,1.49.85,4.39.51,2.56-.29,2.21-1.58.15-1.73A10,10,0,0,0,461.51,189.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.55,188.14a9.68,9.68,0,0,0-4.54,0c-1.23.36-1.23.94,0,1.3a9.68,9.68,0,0,0,4.54,0C467.82,189.08,467.82,188.5,466.55,188.14Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.55,188.14a9.68,9.68,0,0,0-4.54,0c-1.23.36-1.23.94,0,1.3a9.68,9.68,0,0,0,4.54,0C467.82,189.08,467.82,188.5,466.55,188.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.11,213.39c-3.43,1.68-8.92.68-10.43-.78s.6-3,2.23-3.53a11,11,0,0,0-2.63.68c-2.7,1.12-2.7,2.93,0,4.05a15.18,15.18,0,0,0,10,0A5.89,5.89,0,0,0,470.11,213.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.77,190.6a2.76,2.76,0,0,0,1.29-.89c-1.71,1.34-5.9,1.15-7.64.56s-1.79-1.75-1.1-2.3c-1.43.79-1.28,1.91.45,2.63A10.63,10.63,0,0,0,467.77,190.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.55,188.14a8.57,8.57,0,0,0-2.25-.27v1.83a9,9,0,0,0,2.25-.26C467.82,189.08,467.82,188.5,466.55,188.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.77,187.75a10.87,10.87,0,0,0-5.64-.39c.19,0,3.72-.4,5.58.55,1.62.83,1.54,1.57,1.12,2.07C469.62,189.24,469.27,188.35,467.77,187.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.86,205.33V191.11a9,9,0,0,1-1.75-.38v13.74l-10.85,15.84c-.69,1-.19,2.53.39,3.75a9.06,9.06,0,0,0,3.11,3,17.11,17.11,0,0,0,6.45,2.33s-4.45-2.33-5.33-4.08c-.66-1.3-.07-3.28.87-5Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M453.14,200.19c1.77-2.52,3.92-3.34,6-5.52s2.77-3.73,3.73-2.18-1.22,4.69-1.58,5.44c-.18.37-.87,1-1.08,1.55",
    style: {
      fill: "#396CF0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.9,46.28a185.41,185.41,0,0,0,7.82,36.93h-34.3c-2.22-11.6-3.41-23.52,0-36.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,98.05c-3.58,1.56-11,3.79-18.52,5.84A63.39,63.39,0,0,1,209,106.12c-8.95.7-13,0-15-3.38-3.08-5.33-1-7.51,3.71-6.78a21.49,21.49,0,0,0,6,.14,10.8,10.8,0,0,1-2.57-1.55,2.11,2.11,0,0,1-.55-2.81c.28-.36,1.12.41,2.93.83,2.31.54,3.77.15,6,1.33a6.11,6.11,0,0,0,3,.48c1.72.05,4-.65,8.53-2a101,101,0,0,0,10.91-4.45",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.52,60.15A201.87,201.87,0,0,1,247,81.83c-1.6,9.84-2,14.54-5.51,15.93-4.58,1.83-18.76,5.95-18.76,5.95A15.3,15.3,0,0,0,219.07,93l12.36-5.27S238.6,68.39,240,65.07,245.73,59.08,249.52,60.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.43,87.74A8.55,8.55,0,0,1,238,90.61s-.66-3.38-6.13-4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.59,60.19c-4.88-1.23-7,1.5-8.66,4.48-2.6,4.77-5.16,13.93-7,31.64-1.07,10.48-1.55,26-2.26,36.82-1.07,16.32-1.58,29-1.58,29a208.26,208.26,0,0,1,29.11-1.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.71,226.21s2.93-20,1.71-31.78c-1.05-10.07-2.53-14.29-2.75-16.58,0,0-1.69-23.66-1.23-43.7.22-9.5-.26-20-7-31.17l-.25-.44c-.6,3.67-6.26,6-11.31,6.61q-7.29.81-18.16-2.89c-1.61,9.51-3.44,27.61-5.31,47.35-.92,9.64-.76,17.76-.92,24C236.25,186,237,219,237,219v1.39c0,1.54-.43,2.61-1.5,5a30.07,30.07,0,0,1-5.55,8.53c-.72.73-5.71,4.81-6.38,5.69-2.16,2.36,2.1,3.87,5.32,3.55,3.39-.34,8.68-1.45,10.24-3.46,1-1.33,1.94-6.11,3-7.47,3.59-4.57,5.07-6.54,5.14-8,.14-2.71-.76-3.81-1-5.35.39-3.18,6.85-19.83,7.28-29.12a97.79,97.79,0,0,0-.78-12.29l5.68-32.3c1.26,9.09,3.66,29.55,4.52,36.06,1.2,9,5.63,24.15,8.42,36.06a63,63,0,0,1,1.83,9.4s.06,1,.06,1.05c0,1.32.14,15.44.56,18.43.89,6.25,6.44,5.65,7.49.65.89-4.25.39-17.51.42-19.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,226.13c1.56.08.34,6.07.61,10,.29,4.17,1.55,7.25,1.83,10.67a13.79,13.79,0,0,1-1.59,8.69c-1.17,2.46-6.74,5.69-8.69,2.06a20,20,0,0,1-1.9-11.59c.38-4,.72-6.92.9-10,.16-2.69-1.7-9.07.33-9.39l.06,1.05c.68,1.48,7.56,2.71,8.47-.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.69,227.4c.42,2-.25,7.27-.25,7.27a7.12,7.12,0,0,1-3.95,2.93l-1.09-7.45Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "243.5 237.6 236.96 235.22 235.56 229.3 242.86 233.3 243.5 237.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.19,220.26v-1.39c-.91.41-3.13,7.57-6,12.44-2.59,4.45-7.51,6.81-9.14,8.73-2.19,2.57,1.78,6.1,8.37,4.92,3.28-.59,8.27-2.5,9.68-4.65s2-6.17,3.13-7.74,3.8-3.35,4.41-5.17a9.93,9.93,0,0,0,.16-5.07c-.46-1.69-.84-3.72-1.42-3.56l-.08,1.27c-.46.88-2.08,1.87-5.39,1.94C239.38,222,237.86,221.72,237.19,220.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,193.29a69.12,69.12,0,0,0-.55-15.23l4.77-31.77s3.25,30.24,3.79,34.93,9.26,55.24,9.26,55.24c4.45,2.64,10.18,1.8,13.9-.17,0-20.45-.64-40.93-1.38-46.6a95.91,95.91,0,0,0-2.65-11.46s-.47-29.83-.45-41.15-.83-18.89-3-24a72.39,72.39,0,0,0-5.93-10.62s-1.66,5.59-14.77,5.6-14.56-3.31-14.56-3.31-3.84,13.41-5.12,33.67c-1,16.32-1.27,23.74-1.58,31-.26,6.2-.43,13.36-.57,25.89-.11,9.45-1.44,30.24-1.44,30.24s6.4,3.35,17-.47C251.1,225.11,253.74,201.45,254.39,193.29Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,193.29a69.12,69.12,0,0,0-.55-15.23l4.77-31.77s3.25,30.24,3.79,34.93,9.26,55.24,9.26,55.24c4.45,2.64,10.18,1.8,13.9-.17,0-20.45-.64-40.93-1.38-46.6a95.91,95.91,0,0,0-2.65-11.46s-.47-29.83-.45-41.15-.83-18.89-3-24a72.39,72.39,0,0,0-5.93-10.62s-1.66,5.59-14.77,5.6-14.56-3.31-14.56-3.31-3.84,13.41-5.12,33.67c-1,16.32-1.27,23.74-1.58,31-.26,6.2-.43,13.36-.57,25.89-.11,9.45-1.44,30.24-1.44,30.24s6.4,3.35,17-.47C251.1,225.11,253.74,201.45,254.39,193.29Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,146.29,256,127.08a16.41,16.41,0,0,1-10-4.85s1.46,4.65,7.62,7.26l3.48,16.86-2.54,27.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,61.52l6.17.66c4.1,1,5.95,2.81,6.37,6.44a28.4,28.4,0,0,1-.21,11.84c-1.3,5.11-4.76,17.62-4.76,17.62s8,10.38,9.41,28.21c-14.57,9.5-36.91,4.39-43-1.36.51-5.44,4-20.37,4.42-25.22,0,0-.31-7.57-.91-10.86-4.61-5-4-9.84-2-13.72,3.82-7.16,9.59-13.45,11.45-13.45Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,61.52l6.17.66c4.1,1,5.95,2.81,6.37,6.44a28.4,28.4,0,0,1-.21,11.84c-1.3,5.11-4.76,17.62-4.76,17.62s8,10.38,9.41,28.21c-14.57,9.5-36.91,4.39-43-1.36.51-5.44,4-20.37,4.42-25.22,0,0-.31-7.57-.91-10.86-4.61-5-4-9.84-2-13.72,3.82-7.16,9.59-13.45,11.45-13.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,57.18c-1.83,0-2,.31-3.62,2.41-.93,1.26-6.85,11-6.85,11s4.71-6.2,8.26-8.08a7.94,7.94,0,0,1,2.2-.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.09,61.52S260,74.9,258.84,84s2.82,34.41,4.52,52.65c1.1,11.8,2.77,29.14,2.77,29.14a59.9,59.9,0,0,0,10.52-.9c6-1.13,8.25-2.71,9.27-3.93,0,0-2.95-29.73-4.41-41.28-1.37-10.88-7.21-21.6-7.21-21.6l7-29.09s-.34-4.9-5-6.28C272,61.38,265.09,61.52,265.09,61.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.75,113.19,279,109.11a62.65,62.65,0,0,1,1.71,6.06c-6.95,3-15.9,5.66-19,6.15C261.43,119,261,115.45,260.75,113.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.43,78.9c.13-7,1.57-10.83,2.61-13L279,78.62,274.3,98.05h0A73.91,73.91,0,0,1,281,116.63h0c-4.6-13-10.29-13.85-10.29-13.85S271.3,86.48,271.43,78.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,28.77l-4,3.22a2.39,2.39,0,0,1,.34-3.46A2.62,2.62,0,0,1,275.47,28.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.16,57.67c0-2.48,5.76-6.18,8.74-11.39s1.49-13.75-2.59-15.07c0,0-.14-1.09-.16-1.17a9.51,9.51,0,0,0-1.1-2.82,12.33,12.33,0,0,0-8.46-5.54c-12.92-1.88-18.85,3.13-21.23,8.65a13.43,13.43,0,0,0-1,5.87,6.75,6.75,0,0,0,5.22,6.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.26,28.49c-2.53,1.1-4.94,5-4.9,15.8,0,9.18,2.84,11.5,4.26,12.18s4.2.34,6.9-.08v5.28s-2,2-1.32,3.24,3.34,2.3,7.4,1c4.62-1.45,5.67-4.53,5.67-4.53l.09-11.55s1.56,1.64,4.29-.76c2.25-2,3.06-5.35,1.37-7.21s-3.87-2-5.83.07l-1.41-.75c-2.51-.29-6.22-.71-8.91-2.08C247.92,35.59,247.21,31.74,247.26,28.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.16,40.46l0,5.1a2.39,2.39,0,0,1-2.45-2.47A2.63,2.63,0,0,1,265.16,40.46Z",
    style: {
      fill: "#37474f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247,40.7a1.22,1.22,0,1,1-1.26-1.22A1.24,1.24,0,0,1,247,40.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.66,41.25a1.32,1.32,0,0,1-1.26,1.4,1.36,1.36,0,1,1,1.26-1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.72,38.44l3.14-1.25a1.62,1.62,0,0,0-2.17-1A1.75,1.75,0,0,0,243.72,38.44Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "249.99 40.18 250.15 47.7 246.11 46.8 249.99 40.18",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.75,49.23l-3.94,1.22A2,2,0,0,0,253.33,52,2.26,2.26,0,0,0,254.75,49.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.57,52A2.07,2.07,0,0,1,254.64,50h.17a2.18,2.18,0,0,1-1.48,2A1.81,1.81,0,0,1,252.57,52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,56.39c2.84-.33,8.7-2,9.66-4.34a6.31,6.31,0,0,1-2.11,3c-1.77,1.52-7.56,3.1-7.56,3.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,43.57a4.14,4.14,0,0,0,3,1.48h.42c1.81.1,2.74-1,3.56-2.62.23-.48.71-1.28,1.26-1.25s.95.87,1.14,1.37a4.61,4.61,0,0,0,4.06,3l2.41.12a4,4,0,0,0,4.22-4.18v0c-.05-1.25-.11-2.8-.24-3.71-.47-3.28-4.3-4.08-11.21-4.42s-8.13.22-8.92,3.43c-.2.87-.41,2.36-.58,3.55v.07A4.1,4.1,0,0,0,241.45,43.57Zm.31-3c.16-1.15.37-2.68.57-3.5.48-2,.24-2.85,7.65-2.48s9.76,1.33,10,3.35c.12.86.18,2.44.23,3.62a2.8,2.8,0,0,1-2.93,2.9l-2.41-.12a3.34,3.34,0,0,1-3-2.2c-.4-1-1.08-2.11-2.24-2.17s-1.93.93-2.43,1.94c-.6,1.21-1.05,2-2.39,1.94h-.42A2.88,2.88,0,0,1,241.76,40.55Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,43.57a4.14,4.14,0,0,0,3,1.48h.42c1.81.1,2.74-1,3.56-2.62.23-.48.71-1.28,1.26-1.25s.95.87,1.14,1.37a4.61,4.61,0,0,0,4.06,3l2.41.12a4,4,0,0,0,4.22-4.18v0c-.05-1.25-.11-2.8-.24-3.71-.47-3.28-4.3-4.08-11.21-4.42s-8.13.22-8.92,3.43c-.2.87-.41,2.36-.58,3.55v.07A4.1,4.1,0,0,0,241.45,43.57Zm.31-3c.16-1.15.37-2.68.57-3.5.48-2,.24-2.85,7.65-2.48s9.76,1.33,10,3.35c.12.86.18,2.44.23,3.62a2.8,2.8,0,0,1-2.93,2.9l-2.41-.12a3.34,3.34,0,0,1-3-2.2c-.4-1-1.08-2.11-2.24-2.17s-1.93.93-2.43,1.94c-.6,1.21-1.05,2-2.39,1.94h-.42A2.88,2.88,0,0,1,241.76,40.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,40.55a2.88,2.88,0,0,0,2.71,3.27h.42c1.34.07,1.79-.73,2.39-1.94.5-1,1.27-2,2.43-1.94s1.84,1.13,2.24,2.17a3.34,3.34,0,0,0,3,2.2l2.41.12a2.8,2.8,0,0,0,2.93-2.9c-.05-1.18-.11-2.76-.23-3.62-.28-2-2.63-3-10-3.35s-7.17.5-7.65,2.48C242.13,37.87,241.92,39.4,241.76,40.55Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,57.22c.74-.15,1.4.17,2,1.2s1.94,3.2,1.94,3.2.69,7.21,0,9c-.6,1.55-7.18,7.38-7.18,7.38s1.72,6.47,1.78,8.59-4,10.18-4.43,14.31c0,0-1.42-13-.81-17.63a82.11,82.11,0,0,1,6.65-21.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.23,108.69v-8.2c0-4.29,2.82-8.58,8.49-11.85,11.33-6.54,29.7-6.54,41,0,5.67,3.27,8.49,7.56,8.49,11.84h0v8.21h0c.08,4.34-2.74,8.69-8.48,12-11.33,6.54-29.7,6.54-41,0-5.74-3.32-8.56-7.67-8.49-12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.23,
    cy: 100.48,
    rx: 29.02,
    ry: 16.75,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.23,
    cy: 100.48,
    rx: 27.36,
    ry: 15.8,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.89,96.9c10.68-6.17,28-6.17,38.69,0,3.66,2.11,6.07,4.67,7.22,7.38-1.15,2.7-3.56,5.26-7.22,7.37-10.68,6.17-28,6.17-38.69,0-3.66-2.11-6.07-4.67-7.22-7.37C199.82,101.57,202.23,99,205.89,96.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.84,101.32a10.89,10.89,0,0,0-9.82,0c-2.71,1.57-2.71,4.11,0,5.67a10.83,10.83,0,0,0,9.82,0C232.55,105.43,232.55,102.89,229.84,101.32Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,107.07a3.33,3.33,0,0,0-3,0,.93.93,0,0,0,0,1.76,3.39,3.39,0,0,0,3,0A.93.93,0,0,0,217.4,107.07Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.55,
    cy: 102.8,
    rx: 2.38,
    ry: 1.35,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.62,107.52c0,.23.33.42.74.42s.74-.19.74-.42-.33-.42-.74-.42S214.62,107.29,214.62,107.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.34,112.11c-3.41,1.92-10.53,4.9-17.83,7.71a64.57,64.57,0,0,1-11.2,3.39c-8.83,1.61-13,1.29-15.23-1.84-3.6-5-1.81-7.36,3-7.12a21.77,21.77,0,0,0,6-.48,10.76,10.76,0,0,1-2.72-1.27,2.1,2.1,0,0,1-.83-2.74c.24-.39,1.16.29,3,.52,2.35.3,3.77-.23,6.15.71a6.13,6.13,0,0,0,3.05.16c1.71-.13,4-1.06,8.28-2.88s11.37-6.7,11.37-6.7l2.72-21.34s-4-13.18,1.41-17.46c5.53,1.13,7.24,2.92,9.16,8.51,1.75,5.09-.95,28.48-1.72,33C283.36,107.86,283.23,110,279.34,112.11Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.64,62.54c3.14.23,7.43,1.2,9.92,5.58,2.26,4,.72,15.4,0,27-.62,10-.5,14.56-4.85,16.89-4.77,2.56-18,7.33-18,7.33A14.6,14.6,0,0,0,259,109.11l12.68-7.71,1-21.47S272.28,66.5,275.64,62.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.7,101.4a13.22,13.22,0,0,1,7.12,3.27,9.29,9.29,0,0,0-7.06-4.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Virus--inject-156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--virus--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.94,121.71a18.06,18.06,0,0,1,8-3.48c-1.25.84-1.4,3.45.29,7.94,1.37,3.67,2.81,7.16,3.88,9.65.16.38.32.73.46,1.05l-2.08.91c-.14-.33-.29-.68-.46-1.05-1.1-2.48-2.68-5.91-4.43-9.41C424.43,123,422.41,121.37,420.94,121.71Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,121.71a18.06,18.06,0,0,1,8-3.48c-1.25.84-1.4,3.45.29,7.94,1.37,3.67,2.81,7.16,3.88,9.65.16.38.32.73.46,1.05l-2.08.91c-.14-.33-.29-.68-.46-1.05-1.1-2.48-2.68-5.91-4.43-9.41C424.43,123,422.41,121.37,420.94,121.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.9,136.47a8,8,0,0,1,1-.53,8.09,8.09,0,0,1,1.07-.38c.2.47.39.91.57,1.31l-2.08.91C431.3,137.37,431.11,136.94,430.9,136.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.49,140.07a1.53,1.53,0,0,0,.39.54l.11.09.05,0,.2.11.11,0,.17.06h0a5.54,5.54,0,0,0,3.35-.49,5.48,5.48,0,0,0,2.63-2.12h0l.07-.16a.54.54,0,0,0,.05-.11,1.89,1.89,0,0,0,.05-.23s0,0,0-.06,0-.1,0-.14a1.64,1.64,0,0,0-.13-.65,1.47,1.47,0,0,0-.38-.53c-.63-.65-2.3-.61-4,.13s-2.88,2-2.83,2.86A1.55,1.55,0,0,0,429.49,140.07Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.11,140c-.25-.56.51-1.43,1.7-1.95s2.33-.48,2.58.09c.15.34-.08.81-.56,1.24.4-.61,0-1.16-.78-1.13a4.49,4.49,0,0,0-2.38,1.07c-.36.38-.51.74-.19,1A.61.61,0,0,1,431.11,140Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,114.26a20.11,20.11,0,0,1,5.87-6.43c-.82,1.26-1.26,2.45,1.72,5.51,2.44,2.5,2.53,2.74,4.3,4.38l.75.7-1.52,1.67-.76-.69c-1.8-1.62-2-1.74-4.7-3.94C437.12,112.77,436,113.33,434.79,114.26Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,114.26a20.11,20.11,0,0,1,5.87-6.43c-.82,1.26-1.26,2.45,1.72,5.51,2.44,2.5,2.53,2.74,4.3,4.38l.75.7-1.52,1.67-.76-.69c-1.8-1.62-2-1.74-4.7-3.94C437.12,112.77,436,113.33,434.79,114.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.85,119.13a9.15,9.15,0,0,1,.7-.9,8.56,8.56,0,0,1,.83-.78l1.05,1-1.52,1.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.83,123.79a2,2,0,0,0,.68.39l.17,0,.07,0a1.23,1.23,0,0,0,.27,0h.14l.22,0h0a7.6,7.6,0,0,0,5.22-5.71h0v-.22a.71.71,0,0,0,0-.14,2.51,2.51,0,0,0,0-.27l0-.07-.06-.16A2,2,0,0,0,451,117a1.83,1.83,0,0,0-.66-.38c-1-.4-2.8.44-4.29,2.07s-2.17,3.51-1.68,4.46A1.8,1.8,0,0,0,444.83,123.79Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.53,122.88c-.54-.49-.14-1.81.9-2.94s2.3-1.64,2.83-1.15c.33.3.31.92,0,1.62.15-.86-.51-1.28-1.38-.85a5.29,5.29,0,0,0-2.06,2.3c-.21.6-.21,1,.28,1.2A.84.84,0,0,1,446.53,122.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49,101.06a18.7,18.7,0,0,1,2.31-7c-.21,1.24,1,2.7,4,3.93a21.13,21.13,0,0,0,2.77,1.18l.74.26-.6,1.81L453,101a20.05,20.05,0,0,0-2.93-.7C446.89,99.49,445.06,99.94,444.49,101.06Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49,101.06a18.7,18.7,0,0,1,2.31-7c-.21,1.24,1,2.7,4,3.93a21.13,21.13,0,0,0,2.77,1.18l.74.26-.6,1.81L453,101a20.05,20.05,0,0,0-2.93-.7C446.89,99.49,445.06,99.94,444.49,101.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.6,100.9a7,7,0,0,1,.23-.93,7.2,7.2,0,0,1,.37-.89l1.14.39-.6,1.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.06,103.82a1.29,1.29,0,0,0,.55.05h.17l.19-.07.09,0,.13-.08h0a5.39,5.39,0,0,0,1.74-5.23h0l-.06-.14,0-.09a1.11,1.11,0,0,0-.11-.16l0,0-.08-.09a1.44,1.44,0,0,0-.48-.28,1.13,1.13,0,0,0-.54-.06c-.76,0-1.69,1.09-2.19,2.59s-.39,2.9.2,3.38A1.23,1.23,0,0,0,454.06,103.82Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.9,102.73c-.49-.16-.62-1.13-.27-2.16s1-1.74,1.51-1.57c.3.1.47.51.46,1-.15-.59-.7-.68-1.15-.15a3.83,3.83,0,0,0-.67,2.1c0,.44.17.74.53.69A.5.5,0,0,1,454.9,102.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.87,86.35a18.24,18.24,0,0,1-.85-8.66c.42,1.44,2.82,2.4,7.55,2.19,3.85-.18,7.57-.46,10.23-.7l1.13-.11.22,2.25-1.12.12c-2.67.27-6.37.72-10.18,1.29C450.17,83.45,448,84.85,447.87,86.35Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.87,86.35a18.24,18.24,0,0,1-.85-8.66c.42,1.44,2.82,2.4,7.55,2.19,3.85-.18,7.57-.46,10.23-.7l1.13-.11.22,2.25-1.12.12c-2.67.27-6.37.72-10.18,1.29C450.17,83.45,448,84.85,447.87,86.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.73,81.47a7.83,7.83,0,0,1-.19-1.13,7.3,7.3,0,0,1,0-1.14l1.42-.13.22,2.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.33,84.82a1.94,1.94,0,0,0,.79-.26,1.19,1.19,0,0,0,.15-.09l.06,0a1.3,1.3,0,0,0,.22-.19l.09-.12a1.4,1.4,0,0,0,.13-.18h0a6.72,6.72,0,0,0,.71-4.16,6.81,6.81,0,0,0-1.5-3.94h0l-.16-.15-.11-.1a1.28,1.28,0,0,0-.25-.15l-.07,0a1.15,1.15,0,0,0-.17-.06,1.86,1.86,0,0,0-.82-.1,1.79,1.79,0,0,0-.76.24c-1,.5-1.62,2.5-1.4,4.82s1.22,4.16,2.31,4.45A1.87,1.87,0,0,0,468.33,84.82Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.82,82.85c-.76.08-1.51-1.16-1.67-2.76s.34-3,1.1-3c.47,0,.94.41,1.26,1.14-.57-.71-1.36-.5-1.64.49a5.54,5.54,0,0,0,.35,3.23c.32.58.68.9,1.13.63A.83.83,0,0,1,468.82,82.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.85,70.64a31.11,31.11,0,0,1-4.09-7.2c.82,1.16,2.42,1.55,4.68.54,1.84-.82,3.56-1.72,4.78-2.39l.52-.29,1.06,1.87-.51.3c-1.2.7-2.85,1.72-4.51,2.88C444.76,67.78,444.28,69.35,444.85,70.64Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.85,70.64a31.11,31.11,0,0,1-4.09-7.2c.82,1.16,2.42,1.55,4.68.54,1.84-.82,3.56-1.72,4.78-2.39l.52-.29,1.06,1.87-.51.3c-1.2.7-2.85,1.72-4.51,2.88C444.76,67.78,444.28,69.35,444.85,70.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,63.63a8.88,8.88,0,0,1-.58-.91,9.82,9.82,0,0,1-.49-1l.81-.45,1.06,1.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.28,64.63a1.39,1.39,0,0,0,.44-.39l.07-.11,0,0a1.08,1.08,0,0,0,.08-.19l0-.1,0-.16h0a4.85,4.85,0,0,0-.75-2.93,4.92,4.92,0,0,0-2.12-2.14h0l-.15-.05-.1,0-.21,0h-.18a1.45,1.45,0,0,0-.56.17,1.24,1.24,0,0,0-.43.39c-.52.61-.34,2.1.49,3.54s2,2.37,2.79,2.24A1.22,1.22,0,0,0,454.28,64.63Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,63.21c-.48.27-1.33-.32-1.89-1.33s-.64-2-.17-2.29c.29-.17.73,0,1.15.38-.57-.3-1,.07-.92.8a3.91,3.91,0,0,0,1.17,2c.37.29.7.39.92.08A.62.62,0,0,1,454,63.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.88,57.87a18.33,18.33,0,0,1-7-5.17c1.35.66,3.66-.47,6.65-4.1,2.44-3,4.7-5.9,6.29-8,.24-.32.47-.62.67-.9L444.32,41l-.67.91c-1.56,2.15-3.7,5.17-5.81,8.38C435.26,54.23,434.85,56.77,435.88,57.87Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.88,57.87a18.33,18.33,0,0,1-7-5.17c1.35.66,3.66-.47,6.65-4.1,2.44-3,4.7-5.9,6.29-8,.24-.32.47-.62.67-.9L444.32,41l-.67.91c-1.56,2.15-3.7,5.17-5.81,8.38C435.26,54.23,434.85,56.77,435.88,57.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.47,42.16a7.31,7.31,0,0,1-1-.61,7.05,7.05,0,0,1-.87-.74l.85-1.14L444.32,41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.89,41.8a2.26,2.26,0,0,0,.36-.83.63.63,0,0,0,0-.19s0-.06,0-.09,0-.21,0-.31a.78.78,0,0,0,0-.16,2.1,2.1,0,0,0-.06-.24h0a7.42,7.42,0,0,0-2.86-3.62A7.44,7.44,0,0,0,442,34.68h0l-.24,0a.76.76,0,0,0-.16,0l-.3.08-.08,0-.18.09a2.23,2.23,0,0,0-.68.59,2.13,2.13,0,0,0-.36.8c-.34,1.19.84,3.15,2.89,4.66s4.28,2.06,5.31,1.39A2.26,2.26,0,0,0,448.89,41.8Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.64,40c-.49.68-2.05.38-3.46-.67s-2.16-2.43-1.66-3.11c.3-.41,1-.46,1.85-.18-1-.06-1.4.74-.81,1.69a6.15,6.15,0,0,0,2.89,2.08c.7.17,1.22.1,1.33-.46A.84.84,0,0,1,447.64,40Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52,49.84a28.7,28.7,0,0,1-8.91-2c1.55.14,3.11-1.16,4.08-4.32.79-2.59,1.43-5.11,1.85-6.93.06-.28.12-.53.17-.78l2.32.51c0,.24-.11.5-.17.78-.38,1.83-.86,4.39-1.23,7.06C420.18,47.49,421.05,49.32,422.52,49.84Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52,49.84a28.7,28.7,0,0,1-8.91-2c1.55.14,3.11-1.16,4.08-4.32.79-2.59,1.43-5.11,1.85-6.93.06-.28.12-.53.17-.78l2.32.51c0,.24-.11.5-.17.78-.38,1.83-.86,4.39-1.23,7.06C420.18,47.49,421.05,49.32,422.52,49.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.8,37.43a10.68,10.68,0,0,1-1.18-.19,11.23,11.23,0,0,1-1.15-.32c.09-.38.17-.74.24-1.07l2.32.51C422,36.7,421.88,37.05,421.8,37.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.08,35.27a1.63,1.63,0,0,0,0-.66.74.74,0,0,0,0-.14s0,0,0-.06a1,1,0,0,0-.1-.21.53.53,0,0,0-.06-.1l-.1-.15h0a6.43,6.43,0,0,0-6.38-1.4h0l-.16.09-.1.06-.18.15,0,0-.09.11a1.51,1.51,0,0,0-.28.6,1.53,1.53,0,0,0,0,.64c.13.9,1.5,1.86,3.33,2.26s3.47.11,4-.65A1.68,1.68,0,0,0,425.08,35.27Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,34.42c-.13.59-1.26.86-2.52.58s-2.17-1-2-1.59c.08-.37.54-.61,1.18-.67-.68.25-.71.91,0,1.37a4.58,4.58,0,0,0,2.55.53c.52-.1.85-.29.76-.71A.69.69,0,0,1,423.7,34.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,47.9a59.2,59.2,0,0,1-6.54,1.34c.89-.23,2-.89,2-1.83a9.61,9.61,0,0,0-.12-2.07c0-.08,0-.15,0-.22l1.38-.28a1.6,1.6,0,0,0,0,.21,6.55,6.55,0,0,0,.76,1.92A2.33,2.33,0,0,0,405.63,47.9Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,47.9a59.2,59.2,0,0,1-6.54,1.34c.89-.23,2-.89,2-1.83a9.61,9.61,0,0,0-.12-2.07c0-.08,0-.15,0-.22l1.38-.28a1.6,1.6,0,0,0,0,.21,6.55,6.55,0,0,0,.76,1.92A2.33,2.33,0,0,0,405.63,47.9Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.46,45.35l-.69.17a6.31,6.31,0,0,1-.7.11c0-.18-.07-.35-.1-.51l1.38-.28C402.38,45,402.42,45.17,402.46,45.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.27,42.85a1.33,1.33,0,0,0-.21-.47L404,42.3l0,0-.13-.12-.08,0-.12-.07h0a5,5,0,0,0-4.94,1h0a.76.76,0,0,0-.08.11.35.35,0,0,0-.05.08.48.48,0,0,0-.08.16s0,0,0,0l0,.1a1.25,1.25,0,0,0,0,.51,1.06,1.06,0,0,0,.2.46c.37.59,1.64.84,3.05.55s2.49-1,2.6-1.71A1.2,1.2,0,0,0,404.27,42.85Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,42.68c.09.46-.62,1-1.6,1.2s-1.84,0-1.94-.47c-.05-.29.19-.61.63-.85-.4.39-.22.87.41,1a3.42,3.42,0,0,0,2-.42c.34-.23.51-.48.31-.74A.52.52,0,0,1,403,42.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,52.7a20.71,20.71,0,0,1-7,5.2c1.05-1.08,1.71-2.16-.57-5.64-1.86-2.84-1.9-3.08-3.3-5-.2-.29-.4-.55-.59-.8l1.82-1.35.6.79c1.41,1.88,1.58,2,3.77,4.63C388.34,53.73,389.57,53.39,390.9,52.7Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,52.7a20.71,20.71,0,0,1-7,5.2c1.05-1.08,1.71-2.16-.57-5.64-1.86-2.84-1.9-3.08-3.3-5-.2-.29-.4-.55-.59-.8l1.82-1.35.6.79c1.41,1.88,1.58,2,3.77,4.63C388.34,53.73,389.57,53.39,390.9,52.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,46.27a8.06,8.06,0,0,1-.86.74,7.31,7.31,0,0,1-1,.61c-.3-.41-.58-.79-.85-1.14l1.82-1.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,41.7a1.82,1.82,0,0,0-.59-.52l-.16-.07-.06,0L382,41l-.13,0-.22,0h0a7.63,7.63,0,0,0-6.2,4.63h0a1.55,1.55,0,0,0,0,.21.59.59,0,0,0,0,.14,2.44,2.44,0,0,0,0,.27s0,.05,0,.08a.45.45,0,0,0,0,.16,1.84,1.84,0,0,0,.31.72,2.09,2.09,0,0,0,.58.5c.9.58,2.83.09,4.61-1.23s2.79-3,2.49-4.06A1.88,1.88,0,0,0,383,41.7Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.19,42.27c.44.58-.2,1.8-1.43,2.71s-2.57,1.18-3,.6c-.26-.36-.12-1,.32-1.59-.3.81.26,1.35,1.2,1.09a5.31,5.31,0,0,0,2.46-1.87c.32-.54.4-1-.05-1.23A.79.79,0,0,1,381.19,42.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,64a19,19,0,0,1-3.6,6.4c.45-1.18-.42-2.82-3.13-4.58a22,22,0,0,0-2.45-1.66l-.68-.38.94-1.67.67.38a19.9,19.9,0,0,0,2.7,1.22C376.32,65.11,378.17,65,379,64Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,64a19,19,0,0,1-3.6,6.4c.45-1.18-.42-2.82-3.13-4.58a22,22,0,0,0-2.45-1.66l-.68-.38.94-1.67.67.38a19.9,19.9,0,0,0,2.7,1.22C376.32,65.11,378.17,65,379,64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,62.7a5.69,5.69,0,0,1-.41.87,5.84,5.84,0,0,1-.53.8l-1.05-.59.94-1.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.2,59.56a1.17,1.17,0,0,0-.54-.16h-.17l-.2,0-.09,0-.14,0h0a5.44,5.44,0,0,0-2.7,4.8h0a.83.83,0,0,0,0,.15s0,.06,0,.09a1.59,1.59,0,0,0,.08.18l0,0a.61.61,0,0,0,.07.1,1.23,1.23,0,0,0,.41.37,1.49,1.49,0,0,0,.52.16c.76.12,1.87-.76,2.64-2.13s.94-2.78.45-3.36A1.42,1.42,0,0,0,370.2,59.56Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,60.46c.45.26.38,1.23-.15,2.18s-1.33,1.51-1.78,1.26c-.28-.16-.36-.59-.25-1.12,0,.61.56.8,1.1.36a3.83,3.83,0,0,0,1.05-1.93c.05-.44,0-.76-.38-.78A.57.57,0,0,1,369.17,60.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82,77.87a18.39,18.39,0,0,1-.81,8.67c-.13-1.5-2.29-2.89-6.93-3.58-3.79-.55-7.46-1-10.11-1.24l-1.11-.11.21-2.25,1.11.1c2.65.23,6.34.49,10.16.64C370,80.28,372.41,79.32,372.82,77.87Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82,77.87a18.39,18.39,0,0,1-.81,8.67c-.13-1.5-2.29-2.89-6.93-3.58-3.79-.55-7.46-1-10.11-1.24l-1.11-.11.21-2.25,1.11.1c2.65.23,6.34.49,10.16.64C370,80.28,372.41,79.32,372.82,77.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.49,79.49a8.79,8.79,0,0,1,0,1.14,9.33,9.33,0,0,1-.19,1.12l-1.42-.14.21-2.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.59,75.51a2,2,0,0,0-.82.11.85.85,0,0,0-.17.06l-.07,0-.25.16-.11.09-.16.16h0a8,8,0,0,0-.75,8.11h0l.13.18a1.09,1.09,0,0,0,.1.11,1.31,1.31,0,0,0,.21.2l.07,0a.56.56,0,0,0,.15.1,2,2,0,0,0,.78.25,1.94,1.94,0,0,0,.8-.09c1.09-.3,2.06-2.15,2.28-4.47s-.4-4.32-1.42-4.8A2,2,0,0,0,352.59,75.51Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,77.35c.76.07,1.26,1.43,1.11,3s-.89,2.84-1.65,2.77c-.47,0-.84-.58-1-1.36.42.81,1.24.74,1.7-.17a5.54,5.54,0,0,0,.27-3.24c-.2-.63-.5-1-1-.83A.87.87,0,0,1,351.74,77.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.87,93.91a32,32,0,0,1,2.65,7.84c-.59-1.29-2.07-2-4.45-1.42-1.95.45-3.79,1-5.1,1.42l-.56.19-.69-2,.56-.19c1.3-.46,3.09-1.15,4.91-2C372.42,96.73,373.19,95.29,372.87,93.91Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.87,93.91a32,32,0,0,1,2.65,7.84c-.59-1.29-2.07-2-4.45-1.42-1.95.45-3.79,1-5.1,1.42l-.56.19-.69-2,.56-.19c1.3-.46,3.09-1.15,4.91-2C372.42,96.73,373.19,95.29,372.87,93.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.6,99.6a10.41,10.41,0,0,1,.4,1,9.69,9.69,0,0,1,.29,1l-.88.3-.69-2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,98a1.34,1.34,0,0,0-.5.3l-.09.09,0,0a1.08,1.08,0,0,0-.11.18l-.05.09-.06.15h0a4.81,4.81,0,0,0,.18,3,4.9,4.9,0,0,0,1.68,2.5h0l.14.08.09,0a.76.76,0,0,0,.2.06l.05,0h.13a1.28,1.28,0,0,0,.58-.06,1.26,1.26,0,0,0,.5-.3c.62-.5.72-2,.19-3.57s-1.52-2.71-2.33-2.73A1.28,1.28,0,0,0,362.56,98Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,99.44c.51-.17,1.23.57,1.6,1.66s.25,2.11-.27,2.29c-.32.1-.72-.14-1.06-.6.51.41,1,.13,1.06-.6a4,4,0,0,0-.77-2.2c-.31-.35-.61-.51-.89-.25A.6.6,0,0,1,362.55,99.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,108.25a14.61,14.61,0,0,1,5.9,6.39c-1.25-.85-4.18.24-8.73,4.09-1.08.91-3.73,2.77-6.22,5l-1.05,1-1.54-1.66,1.05-1c2.47-2.3,5.11-4.79,5.81-5.49C379,112.41,380.27,109.57,379.52,108.25Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,108.25a14.61,14.61,0,0,1,5.9,6.39c-1.25-.85-4.18.24-8.73,4.09-1.08.91-3.73,2.77-6.22,5l-1.05,1-1.54-1.66,1.05-1c2.47-2.3,5.11-4.79,5.81-5.49C379,112.41,380.27,109.57,379.52,108.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.93,122.11a7.36,7.36,0,0,1,.83.77,8,8,0,0,1,.71.9l-1.05,1-1.54-1.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,121.44a2.05,2.05,0,0,0-.51.74,1.34,1.34,0,0,0-.07.18l0,.09a2.51,2.51,0,0,0-.05.31.76.76,0,0,0,0,.15,2,2,0,0,0,0,.25h0a8.78,8.78,0,0,0,6,6.55h0l.24,0h.16l.32,0,.08,0,.19,0a2.12,2.12,0,0,0,.78-.45,2.21,2.21,0,0,0,.51-.72c.55-1.1-.24-3.25-2-5.12s-3.81-2.83-4.95-2.37A2.28,2.28,0,0,0,363.54,121.44Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,123.47c.61-.56,2.08,0,3.27,1.32s1.66,2.8,1.05,3.37c-.38.35-1.09.26-1.86-.17,1,.25,1.52-.47,1.11-1.51a6.09,6.09,0,0,0-2.44-2.59c-.65-.3-1.18-.33-1.39.2A.87.87,0,0,1,364.42,123.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.88,118.29a22.13,22.13,0,0,1,8.39,3.61c-1.52-.38-3.49,1-5.43,4.88-1.59,3.13-1.38,2.84-2.36,5.07l-.41.94-2.18-.94c.12-.29.26-.6.4-.94.95-2.24.59-2,1.78-5.32C392.53,121.54,392.21,119.13,390.88,118.29Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.88,118.29a22.13,22.13,0,0,1,8.39,3.61c-1.52-.38-3.49,1-5.43,4.88-1.59,3.13-1.38,2.84-2.36,5.07l-.41.94-2.18-.94c.12-.29.26-.6.4-.94.95-2.24.59-2,1.78-5.32C392.53,121.54,392.21,119.13,390.88,118.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.31,130.85a12,12,0,0,1,1.13.41,10.47,10.47,0,0,1,1.06.54c-.15.35-.3.68-.43,1l-2.18-.94C389,131.54,389.17,131.21,389.31,130.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.69,132.35a1.68,1.68,0,0,0-.13.65c0,.05,0,.1,0,.15s0,0,0,.06a.9.9,0,0,0,.06.22.49.49,0,0,0,0,.11,1.19,1.19,0,0,0,.08.16h0a6.43,6.43,0,0,0,6,2.58h0l.17-.06.11,0,.2-.11.05,0,.11-.09a1.63,1.63,0,0,0,.39-.54,1.58,1.58,0,0,0,.13-.63c0-.9-1.13-2.11-2.84-2.84s-3.39-.77-4-.11A1.53,1.53,0,0,0,385.69,132.35Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88,133.45c.24-.56,1.4-.6,2.59-.09s1.94,1.38,1.7,1.94c-.15.35-.65.5-1.29.44.72-.12.87-.76.29-1.34a4.55,4.55,0,0,0-2.4-1c-.53,0-.9.13-.88.55A.64.64,0,0,1,386.88,133.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.17,123.62a58.2,58.2,0,0,1,6.68-.08c-.92.06-2.13.5-2.35,1.41a9.46,9.46,0,0,0-.27,2.07.81.81,0,0,0,0,.22h-1.41a1.55,1.55,0,0,1,0-.22,6.71,6.71,0,0,0-.39-2A2.31,2.31,0,0,0,407.17,123.62Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.17,123.62a58.2,58.2,0,0,1,6.68-.08c-.92.06-2.13.5-2.35,1.41a9.46,9.46,0,0,0-.27,2.07.81.81,0,0,0,0,.22h-1.41a1.55,1.55,0,0,1,0-.22,6.71,6.71,0,0,0-.39-2A2.31,2.31,0,0,0,407.17,123.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.81,126.73l.7,0c.25,0,.49,0,.71,0,0,.18,0,.35,0,.52h-1.41C409.81,127.09,409.81,126.92,409.81,126.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55,128.84a1.36,1.36,0,0,0,.12.5.47.47,0,0,0,.05.1l0,0a.49.49,0,0,0,.11.14l.06.06.11.1h0a4.29,4.29,0,0,0,2.53.66,4.34,4.34,0,0,0,2.52-.72h0a.94.94,0,0,0,.1-.1l.07-.06a1.3,1.3,0,0,0,.1-.15l0,0,0-.1a1.18,1.18,0,0,0,.11-.5,1.14,1.14,0,0,0-.11-.49c-.25-.65-1.46-1.13-2.9-1.11s-2.63.53-2.87,1.18A1.34,1.34,0,0,0,407.55,128.84Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.74,129.24c0-.47.8-.86,1.8-.88s1.8.37,1.81.84c0,.29-.3.56-.77.72.46-.31.37-.82-.22-1a3.48,3.48,0,0,0-2,0c-.38.17-.59.38-.45.67A.51.51,0,0,1,408.74,129.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,100.86a38.23,38.23,0,1,1,50.33,19.73A38.23,38.23,0,0,1,374.93,100.86Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,100.86a38.23,38.23,0,1,1,50.33,19.73A38.23,38.23,0,0,1,374.93,100.86Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.42,57.12c8.63-7.33,37.8-13.52,54.25,8.87s-2.08,47.47-10.11,53a38.22,38.22,0,1,0-44.14-61.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.76,110.69c-7.68,8.33-35.88,18-54.92-2.23s-3.7-47.38,3.61-53.78a38.22,38.22,0,1,0,51.31,56Z",
    style: {
      fill: "#396CF0",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.92,64.05c-2.68-1.07-4.19-3.57-3.38-5.58s3.63-2.77,6.3-1.7,4.19,3.57,3.38,5.58S424.59,65.13,421.92,64.05Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.92,64.05c-2.68-1.07-4.19-3.57-3.38-5.58s3.63-2.77,6.3-1.7,4.19,3.57,3.38,5.58S424.59,65.13,421.92,64.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,60.5c.54,1.25-1.29,2.68-3.82,1.84-2-.65-3.51-2.27-3.43-3.51a1.64,1.64,0,0,1,1.8-1.48c-.84.32-1.16,1.2-.45,2.26a5,5,0,0,0,4.17,2.13C426.42,61.69,427.08,61.16,427.12,60.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.68,98.75c2.27,1.78,3,4.61,1.68,6.31s-4.26,1.64-6.52-.14-3-4.6-1.68-6.3S389.42,97,391.68,98.75Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.68,98.75c2.27,1.78,3,4.61,1.68,6.31s-4.26,1.64-6.52-.14-3-4.6-1.68-6.3S389.42,97,391.68,98.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.7,100.7c-.17-1.35,2-2.2,4.18-.7,1.74,1.2,2.73,3.18,2.3,4.34a1.61,1.61,0,0,1-2.13.91c.89-.06,1.44-.82,1.06-2A5,5,0,0,0,387.7,100C386.7,99.76,385.92,100.08,385.7,100.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,88.38c.63-2.34,2.56-3.85,4.31-3.38s2.68,2.74,2.06,5.08-2.56,3.85-4.31,3.38S420.39,90.71,421,88.38Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,88.38c.63-2.34,2.56-3.85,4.31-3.38s2.68,2.74,2.06,5.08-2.56,3.85-4.31,3.38S420.39,90.71,421,88.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5,92.35c-1,.58-2.36-.8-1.92-3,.34-1.74,1.54-3.16,2.58-3.22a1.37,1.37,0,0,1,1.41,1.35c-.34-.67-1.11-.84-1.93-.14A4.26,4.26,0,0,0,423.29,91C423.44,91.89,424,92.39,424.5,92.35Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.54,74.27c-2.45,1.51-5.36,1.25-6.5-.59s-.08-4.57,2.36-6.08,5.36-1.26,6.5.59S407,72.75,404.54,74.27Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.54,74.27c-2.45,1.51-5.36,1.25-6.5-.59s-.08-4.57,2.36-6.08,5.36-1.26,6.5.59S407,72.75,404.54,74.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.76,68c1.33.31,1.39,2.62-.78,4.17-1.72,1.23-3.92,1.48-4.86.68A1.63,1.63,0,0,1,399,70.5c-.24.86.28,1.64,1.56,1.7a5.1,5.1,0,0,0,4.19-2.1C405.3,69.24,405.27,68.4,404.76,68Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.58,89.17c.89-2.73,3.28-4.41,5.34-3.74s3,3.44,2.12,6.18-3.29,4.41-5.35,3.74S432.68,91.91,433.58,89.17Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.58,89.17c.89-2.73,3.28-4.41,5.34-3.74s3,3.44,2.12,6.18-3.29,4.41-5.35,3.74S432.68,91.91,433.58,89.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.47,94.13c-1.22.62-2.76-1.11-2.1-3.69.53-2,2-3.65,3.28-3.66a1.63,1.63,0,0,1,1.59,1.7c-.36-.82-1.27-1.07-2.28-.3a5.06,5.06,0,0,0-1.84,4.31C436.24,93.51,436.81,94.13,437.47,94.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,88.24c.11,2.55-1.35,4.68-3.26,4.76s-3.56-1.91-3.67-4.46,1.35-4.67,3.27-4.76S398.75,85.7,398.86,88.24Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,88.24c.11,2.55-1.35,4.68-3.26,4.76s-3.56-1.91-3.67-4.46,1.35-4.67,3.27-4.76S398.75,85.7,398.86,88.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,85.35c.82-.9,2.63.06,2.88,2.4.2,1.86-.55,3.66-1.58,4a1.43,1.43,0,0,1-1.84-.91c.55.56,1.38.49,2-.47a4.49,4.49,0,0,0,.19-4.14C395.31,85.47,394.65,85.14,394.1,85.35Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.19,105c4-.14,7.31,2.18,7.42,5.18s-3,5.55-7,5.69-7.3-2.18-7.41-5.18S403.21,105.18,407.19,105Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.19,105c4-.14,7.31,2.18,7.42,5.18s-3,5.55-7,5.69-7.3-2.18-7.41-5.18S403.21,105.18,407.19,105Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.59,112.46c-1.38-1.28.14-4.11,3.81-4.48,2.92-.29,5.73.92,6.32,2.53a2.26,2.26,0,0,1-1.45,2.88c.88-.86.79-2.16-.7-3.11a7,7,0,0,0-6.48-.36C402.81,110.57,402.28,111.6,402.59,112.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.35,58.71c-2.08.52-4.09-.33-4.48-1.9s1-3.26,3.06-3.78,4.1.32,4.49,1.89S407.44,58.19,405.35,58.71Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.35,58.71c-2.08.52-4.09-.33-4.48-1.9s1-3.26,3.06-3.78,4.1.32,4.49,1.89S407.44,58.19,405.35,58.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,54.28c.88.52.4,2.19-1.5,2.79-1.5.48-3.12.16-3.61-.62a1.22,1.22,0,0,1,.44-1.68c-.37.55-.18,1.23.72,1.56a3.78,3.78,0,0,0,3.45-.54C407,55.31,407.21,54.7,406.94,54.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.86,70.24c-1.74,2.36-4.59,3.2-6.36,1.89s-1.79-4.28-.05-6.64,4.59-3.2,6.36-1.88S392.61,67.89,390.86,70.24Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.86,70.24c-1.74,2.36-4.59,3.2-6.36,1.89s-1.79-4.28-.05-6.64,4.59-3.2,6.36-1.88S392.61,67.89,390.86,70.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.71,64.21c1.37-.21,2.3,2,.83,4.24-1.17,1.8-3.15,2.86-4.35,2.46a1.66,1.66,0,0,1-1-2.14c.1.9.89,1.44,2.11,1a5.13,5.13,0,0,0,3.17-3.56C389.69,65.2,389.35,64.42,388.71,64.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.79,85c.27,1.86-.64,3.53-2,3.73s-2.75-1.13-3-3,.64-3.53,2-3.73S383.52,83.18,383.79,85Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.79,85c.27,1.86-.64,3.53-2,3.73s-2.75-1.13-3-3,.64-3.53,2-3.73S383.52,83.18,383.79,85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,83.27c.53-.71,1.93-.15,2.29,1.55.29,1.35-.13,2.73-.85,3.09a1.07,1.07,0,0,1-1.42-.53c.45.37,1,.26,1.41-.49a3.3,3.3,0,0,0-.16-3C381,83.28,380.47,83.08,380.08,83.27Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.72,104.15c1.4-1.25,3.3-1.4,4.24-.35s.56,2.93-.84,4.17-3.31,1.4-4.25.35S425.31,105.39,426.72,104.15Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.72,104.15c1.4-1.25,3.3-1.4,4.24-.35s.56,2.93-.84,4.17-3.31,1.4-4.25.35S425.31,105.39,426.72,104.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.27,108.21c-.88,0-1.18-1.53,0-2.76,1-1,2.35-1.38,3.05-1a1.06,1.06,0,0,1,.34,1.48c.06-.58-.36-1-1.19-.92a3.28,3.28,0,0,0-2.45,1.82C426.79,107.46,426.9,108,427.27,108.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,75.87C418,75,417.16,73.25,417.83,72s2.55-1.53,4.2-.64,2.45,2.62,1.78,3.86S421.26,76.76,419.6,75.87Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,75.87C418,75,417.16,73.25,417.83,72s2.55-1.53,4.2-.64,2.45,2.62,1.78,3.86S421.26,76.76,419.6,75.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,74c.25.85-1,1.64-2.61.92-1.26-.58-2.11-1.74-2-2.53a1.07,1.07,0,0,1,1.27-.83c-.56.14-.83.69-.45,1.43A3.29,3.29,0,0,0,422,74.63C422.7,74.67,423.16,74.38,423.24,74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.11,96.33c1.87-.15,3.48.87,3.59,2.28s-1.31,2.67-3.18,2.82-3.49-.87-3.6-2.28S408.24,96.48,410.11,96.33Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.11,96.33c1.87-.15,3.48.87,3.59,2.28s-1.31,2.67-3.18,2.82-3.49-.87-3.6-2.28S408.24,96.48,410.11,96.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,99.91c-.68-.57,0-1.93,1.7-2.18,1.36-.2,2.71.31,3,1a1.07,1.07,0,0,1-.62,1.39c.4-.43.33-1-.39-1.45a3.31,3.31,0,0,0-3.06,0C408.16,99,407.94,99.51,408.1,99.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.72,74.27c-.72-1.74-.24-3.58,1.06-4.12s3,.43,3.67,2.17.24,3.58-1.07,4.12S436.44,76,435.72,74.27Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.72,74.27c-.72-1.74-.24-3.58,1.06-4.12s3,.43,3.67,2.17.24,3.58-1.07,4.12S436.44,76,435.72,74.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.75,75.08c-.34.82-1.84.62-2.6-.94-.61-1.24-.54-2.68.07-3.21a1.07,1.07,0,0,1,1.51.17c-.53-.25-1.08,0-1.26.82a3.33,3.33,0,0,0,.91,2.92C438.88,75.29,439.42,75.36,439.75,75.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9,85.26c.09-2.46,2.47-4.37,5.32-4.26s5.07,2.19,5,4.65-2.47,4.37-5.32,4.26S404.8,87.72,404.9,85.26Z",
    style: {
      fill: "#396CF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9,85.26c.09-2.46,2.47-4.37,5.32-4.26s5.07,2.19,5,4.65-2.47,4.37-5.32,4.26S404.8,87.72,404.9,85.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,87c.89-1.34.18-3.49-2.12-4.35s-5.6,1-5,3.17a4.71,4.71,0,0,1,4.31-1.91C412.42,84.18,413.52,85.6,413.32,87Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--virus--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457,146.12a6.93,6.93,0,0,1-2,2.67c.26-.52-.18-1.42-1.59-2.6-1.15-1-2.29-1.87-3.12-2.5l-.35-.27.53-.69.35.26c.83.62,2,1.47,3.26,2.32C455.62,146.34,456.61,146.51,457,146.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.93,143.06a3.75,3.75,0,0,1-.24.36,1.9,1.9,0,0,1-.29.33l-.44-.33.53-.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.72,141.59a.54.54,0,0,0-.23-.11h-.28a2.44,2.44,0,0,0-1.51,2h0v.07a.09.09,0,0,0,0,.05.19.19,0,0,0,0,.08v0l0,0a.62.62,0,0,0,.16.2.67.67,0,0,0,.23.1c.33.1.88-.23,1.31-.8s.6-1.19.41-1.49A.55.55,0,0,0,450.72,141.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.2,141.93c.19.14.1.58-.2,1s-.69.6-.88.46-.13-.29-.05-.52c0,.28.21.4.48.23a1.79,1.79,0,0,0,.59-.8c.05-.2,0-.35-.12-.38A.22.22,0,0,1,450.2,141.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,151.22a7.88,7.88,0,0,1-.76,3.26c0-.58,0-1.06-1.61-1.52-1.29-.38-1.36-.44-2.27-.66l-.38-.09.2-.85.38.09c.91.21,1,.21,2.32.43C453.3,152.16,453.59,151.76,453.81,151.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.52,151.49a2.26,2.26,0,0,1-.07.43,1.87,1.87,0,0,1-.13.42l-.53-.13.2-.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.65,149.92a.76.76,0,0,0-.3,0l-.06,0h0l-.1,0,0,0-.07,0h0a2.91,2.91,0,0,0-.67,2.89h0a.25.25,0,0,0,0,.07l0,0,.07.09h0l.05,0a.8.8,0,0,0,.28.13.71.71,0,0,0,.29,0c.41-.05.85-.67,1-1.5s.07-1.58-.27-1.81A.84.84,0,0,0,448.65,149.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.25,150.55c.28.06.39.58.26,1.15s-.46,1-.74.92-.27-.25-.3-.54c.11.31.41.33.63,0a2.06,2.06,0,0,0,.25-1.16c0-.24-.13-.39-.32-.35A.3.3,0,0,1,448.25,150.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,157.46a7.24,7.24,0,0,1,.54,2.77c-.16-.46-.84-.72-2.09-.56a10,10,0,0,0-1.15.13l-.29,0-.14-.72.29-.06a9.41,9.41,0,0,0,1.12-.31C452.54,158.44,453.06,158,453,157.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.36,159a3.1,3.1,0,0,1,.1.36c0,.13,0,.25,0,.37l-.45.08-.14-.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.32,158.34a.56.56,0,0,0-.19.09l0,0h0l-.05.06,0,0,0,.05h0a2.11,2.11,0,0,0,.4,2.08h0l.05,0,0,0,.07,0h.06a.54.54,0,0,0,.22,0,.46.46,0,0,0,.19-.08c.25-.15.36-.68.24-1.28s-.41-1-.7-1.09A.5.5,0,0,0,449.32,158.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.24,158.86c.2,0,.42.27.5.68s0,.77-.21.81-.25-.08-.35-.27c.16.17.36.1.41-.16a1.44,1.44,0,0,0-.17-.83c-.09-.14-.2-.22-.31-.13A.24.24,0,0,1,449.24,158.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.68,163a7,7,0,0,1,1.91,2.73c-.41-.4-1.39-.27-2.93.69-1.26.78-2.45,1.58-3.3,2.16l-.35.25-.5-.71.35-.25c.84-.6,2-1.44,3.17-2.35C454.46,164.43,454.92,163.55,454.68,163Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,167.83c.09.1.18.22.27.34a3.85,3.85,0,0,1,.23.38l-.45.31-.5-.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.12,167.39a.66.66,0,0,0-.21.23.21.21,0,0,0,0,.06v0a.19.19,0,0,0,0,.1.13.13,0,0,0,0,.06.28.28,0,0,0,0,.09h0a3.06,3.06,0,0,0,1.79,2.56h0l.08,0H450a.81.81,0,0,0,.29-.12.9.9,0,0,0,.21-.23c.25-.36.07-1.14-.44-1.88s-1.19-1.16-1.61-1A.85.85,0,0,0,448.12,167.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.33,168.14c.24-.17.72.1,1.07.61s.45,1.05.21,1.22-.39,0-.64-.15c.32.14.55-.09.46-.47a2.14,2.14,0,0,0-.73-1c-.21-.14-.39-.18-.49,0A.31.31,0,0,1,448.33,168.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.65,167.71a12.24,12.24,0,0,1,2.72,1.64c-.49-.23-1.1-.06-1.67.7s-.87,1.25-1.15,1.7l-.12.2-.7-.43.11-.19c.27-.46.63-1.12,1-1.82C459.21,168.65,459.08,168,458.65,167.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.91,171.22a3.13,3.13,0,0,1,.36.19l.35.23-.19.31-.7-.43A3.4,3.4,0,0,1,457.91,171.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.62,171.5a.58.58,0,0,0-.07.21v0a0,0,0,0,1,0,0,.25.25,0,0,1,0,.08.08.08,0,0,1,0,0s0,0,0,.06h0a2.21,2.21,0,0,0,1.92,1.16h.1l.07,0h0l0,0a.61.61,0,0,0,.16-.16.58.58,0,0,0,.07-.21c.06-.31-.28-.77-.83-1.1s-1.12-.41-1.36-.22A.46.46,0,0,0,456.62,171.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,171.93c.11-.18.51-.14.89.09s.59.55.48.73-.24.14-.45.09c.25,0,.33-.22.16-.44a1.52,1.52,0,0,0-.77-.45c-.18,0-.31,0-.32.15A.24.24,0,0,1,457,171.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.05,170.3a7,7,0,0,1,3.32.41c-.58,0-1.14.85-1.46,2.63-.25,1.45-.46,2.85-.59,3.87l-.06.43-.86-.11c0-.13,0-.28.05-.43.12-1,.27-2.43.37-3.9C465,171.4,464.6,170.47,464.05,170.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.47,177a2.1,2.1,0,0,1,.43,0l.43.08c0,.2,0,.38-.07.55l-.86-.11C464.42,177.36,464.45,177.18,464.47,177Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.72,178.13a.78.78,0,0,0,0,.34.19.19,0,0,0,0,.07,0,0,0,0,1,0,0l.07.11,0,0,.07.07h0a3.38,3.38,0,0,0,3.39.42h0l.08-.06,0,0,.09-.09,0,0,0-.06a.87.87,0,0,0,.12-.33.91.91,0,0,0,0-.33c-.11-.46-.88-.9-1.85-1s-1.82.12-2,.54A.82.82,0,0,0,462.72,178.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.49,178.51c0-.32.61-.51,1.28-.43s1.18.41,1.14.73-.25.34-.58.41c.34-.17.33-.52-.05-.72a2.37,2.37,0,0,0-1.36-.15c-.26.07-.43.19-.36.4A.32.32,0,0,1,463.49,178.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,170.47a11.2,11.2,0,0,1,3.36-1c-.55.25-.83,1-.56,2.22.23,1,.49,2,.69,2.66,0,.11.06.2.09.29l-.88.27a1.9,1.9,0,0,0-.09-.29c-.21-.69-.53-1.63-.91-2.6C471.26,170.82,470.62,170.37,470,170.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.61,174.49a4.29,4.29,0,0,1,.43-.16l.45-.11c0,.15.08.28.12.4l-.88.27C472.7,174.77,472.66,174.63,472.61,174.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.92,175.83a.78.78,0,0,0,.12.22l0,0,0,0,.07,0,0,0,.07,0h0a2.48,2.48,0,0,0,2.4-.73h0l0-.06,0,0,0-.08v0a.11.11,0,0,0,0-.05.59.59,0,0,0,0-.26.55.55,0,0,0-.12-.21c-.21-.28-.85-.34-1.54-.13s-1.18.62-1.2,1A.53.53,0,0,0,471.92,175.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54,175.86c-.07-.23.26-.53.74-.67s.91-.08,1,.14-.07.31-.27.45c.18-.21.07-.44-.25-.46a1.7,1.7,0,0,0-.95.3c-.16.13-.23.26-.12.38A.29.29,0,0,1,472.54,175.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.05,167.94a22.52,22.52,0,0,1,1.94-1.68c-.26.25-.5.68-.34,1a3.39,3.39,0,0,0,.43.67l.05.07-.4.35-.06-.06a2.67,2.67,0,0,0-.62-.5A.9.9,0,0,0,476.05,167.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.59,168.2l.2-.19.21-.17.13.16-.4.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.46,169.38a.39.39,0,0,0,.15.11l0,0h.18a1.6,1.6,0,0,0,.9-.43,1.55,1.55,0,0,0,.56-.84h0a.09.09,0,0,0,0,0v-.12s0,0,0,0a.31.31,0,0,0-.09-.18.39.39,0,0,0-.15-.11c-.24-.13-.71,0-1.13.39s-.64.81-.55,1.06A.42.42,0,0,0,477.46,169.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.9,169.2c-.11-.14,0-.45.31-.7s.62-.35.74-.21.05.24-.05.4c.06-.2-.09-.33-.32-.25a1.35,1.35,0,0,0-.58.52c-.07.14-.08.25,0,.3A.18.18,0,0,1,477.9,169.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.08,163.57a8,8,0,0,1,1.35-3.06c-.14.56-.16,1,1.26,1.78,1.15.6,1.21.67,2,1.05l.35.15-.36.8-.35-.16c-.82-.36-.91-.38-2.13-.83C480.74,162.74,480.39,163.08,480.08,163.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.22,164.07a3.39,3.39,0,0,1,.15-.41,2.42,2.42,0,0,1,.21-.39l.5.22-.36.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.78,165.77a.8.8,0,0,0,.3.06h.09l.1,0,.05,0,.08,0h0a2.46,2.46,0,0,0,1-1.19,2.49,2.49,0,0,0,.24-1.53h0l0-.08,0-.05a.41.41,0,0,0-.05-.09,0,0,0,0,0,0,0s0,0-.05-.05a.55.55,0,0,0-.24-.18.72.72,0,0,0-.29-.06c-.41,0-1,.5-1.3,1.28s-.37,1.54-.08,1.82A1.08,1.08,0,0,0,484.78,165.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.29,165.23c-.26-.12-.27-.64,0-1.18s.64-.88.89-.76.23.29.2.59c-.06-.33-.35-.41-.61-.14a2,2,0,0,0-.47,1.09c0,.24.05.4.24.4A.28.28,0,0,1,485.29,165.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,157.53a7.36,7.36,0,0,1,0-2.82c.07.48.67.87,1.91.95a8.94,8.94,0,0,0,1.13.09h.3v.74H485a6.8,6.8,0,0,0-1.13.1C482.62,156.67,482,157.05,482,157.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.83,156.49a2.3,2.3,0,0,1,0-.74h.46v.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.71,157.37a.65.65,0,0,0,.21,0l.05,0h0l.06-.05,0,0,0,0h0a2.08,2.08,0,0,0,0-2.12h0l0,0,0,0-.06-.05h0l0,0a.46.46,0,0,0-.21,0,.45.45,0,0,0-.2,0c-.28.1-.48.61-.48,1.21s.21,1.11.48,1.21A.45.45,0,0,0,485.71,157.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.89,156.88c-.2,0-.36-.34-.36-.76s.16-.76.36-.76.23.13.29.33c-.12-.2-.33-.16-.43.09a1.4,1.4,0,0,0,0,.84c.07.16.15.25.27.19A.21.21,0,0,1,485.89,156.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,151.74a7.14,7.14,0,0,1-1.36-3.05c.33.47,1.31.53,3-.11,1.38-.53,2.68-1.08,3.62-1.49l.39-.17.36.79-.4.18c-.92.42-2.21,1-3.52,1.69C481.87,150.41,481.26,151.18,481.39,151.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.89,147.93a2,2,0,0,1-.21-.38,4.14,4.14,0,0,1-.15-.41l.5-.22.36.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.61,148.72a.79.79,0,0,0,.25-.19l.05-.05s0,0,0,0l.06-.1,0,0s0-.05,0-.08h0a2.5,2.5,0,0,0-.25-1.6,2.64,2.64,0,0,0-1-1.26h0l-.08,0-.06,0-.1,0h-.1a.67.67,0,0,0-.31.07.64.64,0,0,0-.25.18c-.31.3-.29,1.1.08,1.92s.94,1.37,1.37,1.34A.81.81,0,0,0,488.61,148.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.54,147.94c-.26.12-.69-.24-.94-.8s-.23-1.12,0-1.24.39,0,.6.27c-.29-.2-.56,0-.54.37a2.2,2.2,0,0,0,.52,1.14c.19.17.36.24.49.09A.3.3,0,0,1,488.54,147.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.36,146.38a12.23,12.23,0,0,1-2.37-2.13c.44.33,1.07.28,1.76-.36s1.08-1,1.44-1.43l.15-.17.62.55-.15.17c-.35.4-.82,1-1.28,1.58S478,146,478.36,146.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.72,143.11l-.32-.26q-.16-.15-.3-.3l.24-.26.62.55C479.88,142.93,479.8,143,479.72,143.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,143.07a.52.52,0,0,0,.11-.19.43.43,0,0,1,0,0v-.14a.13.13,0,0,0,0-.06h0a1.82,1.82,0,0,0-.63-1,1.86,1.86,0,0,0-1-.52h-.1l-.08,0h0l-.05,0a.46.46,0,0,0-.18.13.47.47,0,0,0-.11.19c-.12.29.13.81.61,1.24s1,.62,1.29.47A.68.68,0,0,0,481,143.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.77,142.59c-.14.15-.52,0-.85-.26s-.48-.66-.34-.81.27-.09.47,0c-.25,0-.37.15-.24.4a1.55,1.55,0,0,0,.67.59c.17.06.3.05.34-.09A.25.25,0,0,1,480.77,142.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.43,142.83a5.63,5.63,0,0,1-3.18-1c.59,0,1.36-.86,2.16-3,.19-.51.72-1.63,1.13-2.86l.17-.52.83.27c-.06.16-.11.34-.17.52-.4,1.24-.81,2.57-.91,2.93C472.84,141.34,472.93,142.53,473.43,142.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.37,136.2a2.53,2.53,0,0,1-.83-.27l.17-.52.83.27C474.48,135.84,474.43,136,474.37,136.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.3,135.41a1,1,0,0,0,0-.34s0,0,0-.08,0,0,0,0a.36.36,0,0,0,0-.11l0-.06a.35.35,0,0,0-.05-.08h0a2.78,2.78,0,0,0-1.48-1,2.82,2.82,0,0,0-1.77-.09h0l-.09,0-.06,0-.1.07,0,0-.05.05a.92.92,0,0,0-.18.3.8.8,0,0,0,0,.34c0,.47.69,1,1.62,1.34s1.8.23,2.1-.14A.92.92,0,0,0,476.3,135.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.62,134.9c-.1.3-.7.38-1.34.17s-1.09-.62-1-.93.32-.29.66-.29c-.37.1-.42.44-.09.71a2.3,2.3,0,0,0,1.3.41c.28,0,.46-.11.43-.33A.31.31,0,0,1,475.62,134.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.74,141.61a8.4,8.4,0,0,1-3.49.37c.59-.16,1-1,.9-2.65-.06-1.35-.07-1.22-.16-2.14,0-.14,0-.28,0-.4l.9-.09c0,.12,0,.25,0,.39.1.93.18.78.4,2.11C466.58,140.83,467.14,141.58,467.74,141.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.9,137.11l-.45.08-.46,0c0-.15,0-.29,0-.42l.9-.09C465.87,136.83,465.88,137,465.9,137.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.83,135.93a.62.62,0,0,0-.08-.24l0-.05v0l-.06-.06,0,0-.06,0h0a2,2,0,0,0-1.28-.21,2.05,2.05,0,0,0-1.21.47h0l-.05.05,0,0a.25.25,0,0,0,0,.07,0,0,0,0,0,0,0,.08.08,0,0,0,0,.05.52.52,0,0,0,0,.25.62.62,0,0,0,.08.24c.15.31.77.49,1.48.41s1.28-.38,1.37-.72A.63.63,0,0,0,466.83,135.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.23,135.78c0,.24-.36.47-.85.52s-.91-.09-.94-.33.13-.29.35-.39c-.22.18-.15.42.16.51a1.76,1.76,0,0,0,1-.12c.18-.1.27-.21.19-.35A.26.26,0,0,1,466.23,135.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.28,142.89a21.73,21.73,0,0,1-2.21,1.29c.29-.2.61-.57.52-.92a3.88,3.88,0,0,0-.3-.74.43.43,0,0,0,0-.07l.47-.28a.3.3,0,0,0,0,.08,2.5,2.5,0,0,0,.51.6A.89.89,0,0,0,461.28,142.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.82,142.35l-.23.14-.24.13-.1-.17.47-.28A1.62,1.62,0,0,0,459.82,142.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.17,141.22a.47.47,0,0,0-.13-.15l0,0h0l-.06,0h-.09a1.59,1.59,0,0,0-1,.26,1.65,1.65,0,0,0-.71.71h0s0,0,0,.06v0a.17.17,0,0,0,0,.07v.06a.47.47,0,0,0,.06.19.57.57,0,0,0,.13.14c.2.17.7.1,1.18-.17s.78-.68.73-.94A.32.32,0,0,0,460.17,141.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.7,141.31c.09.15-.1.44-.43.63s-.68.22-.77.06,0-.24.13-.39c-.1.2,0,.35.26.31a1.33,1.33,0,0,0,.67-.39c.09-.13.13-.24,0-.31A.19.19,0,0,1,459.7,141.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.36,144.44a14.68,14.68,0,1,1-20.56,2.87A14.68,14.68,0,0,1,476.36,144.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.36,144.44a14.68,14.68,0,1,1-20.56,2.87A14.68,14.68,0,0,1,476.36,144.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.79,148.11c2.28,3.7,2.67,14.79-6.79,19.73s-17.62-3.2-19.23-6.56a14.67,14.67,0,1,0,26-13.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.19,164.94a1.81,1.81,0,0,1,2.18,1.23c.11.83-.69,1.61-1.79,1.76a1.82,1.82,0,0,1-2.18-1.23C465.29,165.87,466.09,165.09,467.19,164.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.12,167.11c-.42-.32-.08-1.14.93-1.34a1.77,1.77,0,0,1,1.81.53.63.63,0,0,1-.33.84c.22-.27.16-.62-.27-.84a1.92,1.92,0,0,0-1.8.07C466.13,166.58,466,166.88,466.12,167.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.78,147.64c-1.1-.17-1.88-1-1.75-1.8a1.81,1.81,0,0,1,2.21-1.18c1.09.17,1.87,1,1.75,1.8A1.81,1.81,0,0,1,470.78,147.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.41,145.86c.31.42-.25,1.11-1.26,1-.81-.07-1.51-.55-1.59-1a.61.61,0,0,1,.54-.7c-.28.18-.33.54,0,.88a1.94,1.94,0,0,0,1.75.43C472.26,146.36,472.45,146.11,472.41,145.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.91,156.63a1.51,1.51,0,0,1-.8,1.94c-.68.18-1.42-.41-1.65-1.31a1.51,1.51,0,0,1,.81-1.94C462,155.14,462.68,155.73,462.91,156.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,156c.22-.38.94-.18,1.21.64a1.47,1.47,0,0,1-.26,1.56.53.53,0,0,1-.73-.19c.24.16.53.08.67-.31a1.61,1.61,0,0,0-.24-1.49C461.44,155.91,461.18,155.84,461,156Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.08,158.25a1.57,1.57,0,1,1,.36,2.48A1.8,1.8,0,0,1,471.08,158.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.19,160.4c-.5.15-1-.62-.52-1.54.34-.74,1-1.23,1.5-1.14a.63.63,0,0,1,.48.75c-.08-.33-.4-.5-.84-.28a2,2,0,0,0-1,1.5C471.77,160.08,471.94,160.35,472.19,160.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.56,158.73a1.82,1.82,0,0,1-1.08,2.26c-.82.16-1.66-.59-1.87-1.67a1.8,1.8,0,0,1,1.08-2.26C457.51,156.9,458.34,157.64,458.56,158.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.33,157.8c.29-.43,1.13-.14,1.39.84a1.73,1.73,0,0,1-.41,1.84.62.62,0,0,1-.85-.26c.28.2.63.12.82-.33a2,2,0,0,0-.19-1.79C456.85,157.78,456.55,157.68,456.33,157.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.35,152.51a1.39,1.39,0,1,1,2.07.8A1.6,1.6,0,0,1,470.35,152.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.49,152.58c-.1.45-.89.47-1.42-.26a1.54,1.54,0,0,1-.23-1.65.56.56,0,0,1,.79,0c-.29-.08-.56.1-.58.53a1.69,1.69,0,0,0,.72,1.42C472.06,152.77,472.35,152.75,472.49,152.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.4,148.45c-1.31.8-2.85.65-3.45-.34s0-2.42,1.28-3.22,2.85-.65,3.46.34S465.71,147.66,464.4,148.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.55,145.11c.7.16.73,1.4-.44,2.21a2.38,2.38,0,0,1-2.59.34.87.87,0,0,1,0-1.23c-.14.45.14.87.82.91a2.69,2.69,0,0,0,2.23-1.11C464.83,145.78,464.81,145.33,464.55,145.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.74,163.61a1.35,1.35,0,0,1,1.86-.21,1.56,1.56,0,1,1-1.86.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,165.39c-.39,0-.54-.65,0-1.21a1.27,1.27,0,0,1,1.32-.47.45.45,0,0,1,.17.64c0-.25-.17-.44-.53-.39a1.46,1.46,0,0,0-1.06.84C473.81,165.07,473.87,165.3,474,165.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.42,157c.14-1.11.93-1.93,1.77-1.82a1.83,1.83,0,0,1,1.27,2.21c-.14,1.11-.94,1.93-1.78,1.83A1.85,1.85,0,0,1,476.42,157Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.27,158.64c-.42.33-1.13-.22-1.07-1.26.05-.83.51-1.55,1-1.65a.63.63,0,0,1,.73.54c-.2-.29-.56-.32-.89,0a2,2,0,0,0-.4,1.79C477.76,158.49,478,158.69,478.27,158.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,150.74a1,1,0,1,1,1.57.44A1.17,1.17,0,0,1,476,150.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.57,150.64c0,.34-.61.41-1.06-.09a1.13,1.13,0,0,1-.29-1.19.42.42,0,0,1,.58-.1c-.22,0-.4.12-.39.44a1.29,1.29,0,0,0,.63,1C477.27,150.8,477.48,150.77,477.57,150.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,152.43a1,1,0,1,1-.5-1.56A1.19,1.19,0,0,1,458,152.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,151.17c.3-.15.68.29.5.93s-.52.91-.83.9a.41.41,0,0,1-.4-.43c.09.21.32.28.57.09a1.29,1.29,0,0,0,.49-1.07C457.39,151.33,457.25,151.17,457.09,151.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.74,160.55a1.18,1.18,0,0,1,1.32,1c0,.54-.57,1-1.29,1a1.18,1.18,0,0,1-1.32-1C464.44,161,465,160.56,465.74,160.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.88,161.88c-.24-.24,0-.75.71-.8s1,.18,1.13.48a.4.4,0,0,1-.27.51c.16-.15.15-.39-.12-.56a1.27,1.27,0,0,0-1.17-.09C464.93,161.54,464.83,161.72,464.88,161.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.07,151.92a1.18,1.18,0,0,1-1.63-.09,1.16,1.16,0,0,1,.53-1.54,1,1,0,1,1,1.1,1.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.06,150.34c.34.07.38.64-.15,1a1.14,1.14,0,0,1-1.21.22.41.41,0,0,1-.06-.58c-.05.21.09.4.41.41a1.27,1.27,0,0,0,1-.57C465.21,150.65,465.19,150.44,465.06,150.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.65,164.12a1.19,1.19,0,0,1,.42,1.58,1.37,1.37,0,1,1-.42-1.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.15,164.61c0-.34.5-.56,1.05-.18s.68.8.57,1.09a.41.41,0,0,1-.53.23c.22,0,.36-.21.26-.51a1.26,1.26,0,0,0-.85-.81C459.4,164.37,459.2,164.45,459.15,164.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.9,154.64a2,2,0,1,1-2.55-.62A1.87,1.87,0,0,1,468.9,154.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.75,155.65c0,.62.6,1.2,1.53,1.06s1.69-1.38,1.09-2a1.51,1.51,0,0,1-1.08,1.45A1.14,1.14,0,0,1,465.75,155.65Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--virus--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.33,43.83a7.35,7.35,0,0,1-2.13,2.82c.27-.55-.19-1.5-1.68-2.76-1.22-1-2.42-2-3.3-2.64l-.37-.28.56-.73.37.28c.88.66,2.13,1.55,3.44,2.44C308.84,44.05,309.88,44.24,310.33,43.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87,40.58a2.84,2.84,0,0,1-.25.39,2.67,2.67,0,0,1-.31.35l-.46-.35.56-.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.65,39a.58.58,0,0,0-.24-.11h-.23l-.07,0h0a2.18,2.18,0,0,0-1.09.84,2.22,2.22,0,0,0-.51,1.27h0a.17.17,0,0,0,0,.07v.05l0,.09v0l0,0a.72.72,0,0,0,.18.21.66.66,0,0,0,.24.11c.35.1.93-.24,1.39-.85s.63-1.26.43-1.57A.54.54,0,0,0,303.65,39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,39.39c.2.16.11.62-.21,1s-.73.64-.93.49-.13-.31,0-.55c0,.29.22.42.5.24a1.77,1.77,0,0,0,.63-.85c0-.21,0-.36-.13-.4A.3.3,0,0,1,303.1,39.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.92,49.22a8.24,8.24,0,0,1-.8,3.45c0-.61-.05-1.12-1.71-1.61-1.36-.4-1.44-.47-2.39-.7l-.41-.09.21-.9.4.09c1,.22,1.06.22,2.45.46C306.38,50.21,306.68,49.79,306.92,49.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.38,49.5a2.57,2.57,0,0,1-.07.46,2.83,2.83,0,0,1-.13.44l-.57-.13.21-.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.46,47.85a.69.69,0,0,0-.32,0h-.09a.31.31,0,0,0-.1.05l-.05,0-.07,0h0a2.62,2.62,0,0,0-.77,1.43,2.7,2.7,0,0,0,.06,1.63h0a.25.25,0,0,0,0,.07l0,0,.07.09,0,0,.05,0a1,1,0,0,0,.29.14.81.81,0,0,0,.31,0c.43,0,.9-.71,1.11-1.59s.07-1.67-.3-1.91A.66.66,0,0,0,301.46,47.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,48.51c.29.07.41.61.27,1.22s-.49,1-.77,1-.3-.27-.32-.58c.11.34.43.36.66,0a2.23,2.23,0,0,0,.27-1.23c0-.25-.14-.41-.34-.36A.29.29,0,0,1,301,48.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.11,55.82a7.52,7.52,0,0,1,.56,2.93c-.17-.48-.88-.76-2.2-.59a9,9,0,0,0-1.22.13l-.31.06-.15-.76.31-.06a7.52,7.52,0,0,0,1.18-.34C305.57,56.86,306.13,56.34,306.11,55.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,57.49a2.36,2.36,0,0,1,.1.38,2.78,2.78,0,0,1,.05.39l-.48.09-.15-.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.17,56.75a.61.61,0,0,0-.2.09l0,0,0,0a.15.15,0,0,0-.05.06l0,0,0,.05h0a2.16,2.16,0,0,0,.43,2.19h0a.1.1,0,0,0,0,0l0,0,.07,0h.07a.59.59,0,0,0,.23,0,.72.72,0,0,0,.2-.09c.26-.16.38-.73.26-1.35s-.44-1.11-.75-1.16A.54.54,0,0,0,302.17,56.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.09,57.3c.21,0,.44.28.53.72s0,.81-.23.85-.26-.08-.37-.28c.17.18.39.1.44-.17a1.6,1.6,0,0,0-.18-.88c-.1-.15-.21-.22-.33-.14A.26.26,0,0,1,302.09,57.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84,61.71a7.3,7.3,0,0,1,2,2.89c-.43-.43-1.47-.29-3.1.73-1.33.83-2.59,1.67-3.49,2.28l-.37.27-.53-.76.38-.26c.88-.63,2.1-1.52,3.34-2.49C307.6,63.19,308.09,62.26,307.84,61.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.84,66.79q.15.17.3.36a2.3,2.3,0,0,1,.23.4c-.17.11-.33.22-.47.33l-.53-.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,66.32a.78.78,0,0,0-.23.25l0,.06v0a.36.36,0,0,0,0,.11s0,0,0,.06,0,.06,0,.09h0a2.74,2.74,0,0,0,.58,1.62,2.77,2.77,0,0,0,1.31,1.09h0l.09,0h.05a.48.48,0,0,0,.12,0h.11a.82.82,0,0,0,.31-.13.84.84,0,0,0,.22-.24c.26-.37.07-1.2-.47-2s-1.26-1.23-1.7-1.12A.72.72,0,0,0,300.9,66.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.12,67.11c.26-.18.77.11,1.14.65s.47,1.11.22,1.29-.42,0-.68-.15c.34.14.58-.1.49-.5a2.37,2.37,0,0,0-.77-1.08c-.23-.14-.42-.18-.53,0A.37.37,0,0,1,301.12,67.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,66.66a12.86,12.86,0,0,1,2.87,1.74c-.51-.25-1.16-.07-1.76.74-.48.66-.92,1.32-1.21,1.8l-.13.2-.75-.45.12-.2c.29-.49.67-1.18,1-1.92C312.64,67.66,312.5,67,312,66.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,70.37a3.72,3.72,0,0,1,.39.21c.13.07.25.16.37.24l-.2.32-.75-.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.89,70.67a.62.62,0,0,0-.07.23.07.07,0,0,0,0,0v0s0,.06,0,.08,0,0,0,0a.64.64,0,0,0,0,.07h0a2,2,0,0,0,.85.89,2,2,0,0,0,1.18.33H312l.07,0,0,0,.05,0a.56.56,0,0,0,.16-.18.45.45,0,0,0,.08-.22c.06-.32-.3-.81-.88-1.16s-1.18-.44-1.44-.23A.52.52,0,0,0,309.89,70.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,71.12c.11-.19.53-.15.93.09s.63.59.52.78-.26.15-.49.1c.26,0,.35-.23.17-.47a1.65,1.65,0,0,0-.81-.48c-.19,0-.33,0-.34.16A.22.22,0,0,1,310.27,71.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.75,69.4a7.47,7.47,0,0,1,3.51.44c-.61,0-1.2.89-1.54,2.77-.27,1.54-.49,3-.63,4.1q0,.24-.06.45l-.91-.11.06-.46c.12-1.07.28-2.57.39-4.12C318.7,70.56,318.33,69.58,317.75,69.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,76.47a3.62,3.62,0,0,1,.46,0,3.12,3.12,0,0,1,.46.09c0,.21-.05.4-.08.58l-.91-.11C318.14,76.87,318.17,76.68,318.19,76.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.35,77.68a.85.85,0,0,0,0,.36l0,.08s0,0,0,0l.07.11,0,0,.06.08h0a3.56,3.56,0,0,0,3.59.44h0l.08-.06.05,0a.28.28,0,0,0,.09-.1s0,0,0,0l.05-.06a.81.81,0,0,0,.12-.35.82.82,0,0,0,0-.35c-.12-.49-.92-.95-1.95-1.07s-1.92.12-2.15.56A.77.77,0,0,0,316.35,77.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.15,78.08c.05-.34.65-.54,1.36-.45s1.25.43,1.21.77-.27.36-.62.43c.37-.18.35-.54-.05-.76a2.47,2.47,0,0,0-1.44-.16c-.28.08-.45.21-.38.43A.38.38,0,0,1,317.15,78.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,69.58a11.62,11.62,0,0,1,3.55-1.08c-.58.26-.88,1-.59,2.34.24,1.08.51,2.1.73,2.82,0,.12.06.22.09.31l-.92.28c0-.09-.06-.19-.1-.3-.23-.73-.57-1.73-1-2.75C325.38,70,324.7,69.47,324.08,69.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.8,73.83l.46-.17.47-.11c0,.15.09.29.13.42l-.92.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.07,75.25a.59.59,0,0,0,.14.23l0,0,0,0,.07.06,0,0,.07,0h0a2.61,2.61,0,0,0,2.54-.77h0l0-.07a.05.05,0,0,0,0,0,.16.16,0,0,0,0-.09v0s0,0,0-.06a.62.62,0,0,0,0-.27.65.65,0,0,0-.13-.23c-.22-.29-.9-.35-1.62-.13s-1.25.65-1.28,1A.78.78,0,0,0,326.07,75.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.73,75.28c-.07-.24.28-.56.78-.71s1-.08,1,.15-.07.33-.29.48c.19-.23.07-.47-.26-.49a1.84,1.84,0,0,0-1,.32c-.16.13-.24.27-.13.4A.31.31,0,0,1,326.73,75.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.44,66.91a24.07,24.07,0,0,1,2.05-1.78c-.27.26-.53.71-.35,1.05a3.51,3.51,0,0,0,.45.71l.06.07-.44.38a.19.19,0,0,0-.06-.07,2.75,2.75,0,0,0-.65-.53A1,1,0,0,0,330.44,66.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.08,67.18c.06-.07.13-.13.2-.2l.23-.18.14.16-.44.38A1.83,1.83,0,0,0,332.08,67.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,68.42a.52.52,0,0,0,.17.13h.22a2,2,0,0,0,1.55-1.34h0a.09.09,0,0,0,0,0v-.13s0,0,0,0a.5.5,0,0,0-.1-.19.48.48,0,0,0-.16-.12c-.25-.13-.75,0-1.19.42s-.68.85-.58,1.12A.42.42,0,0,0,331.93,68.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,68.24c-.12-.15,0-.48.33-.75s.65-.36.78-.21.05.25-.05.42c.06-.22-.1-.35-.34-.26a1.36,1.36,0,0,0-.61.54c-.08.15-.09.27,0,.32A.25.25,0,0,1,332.4,68.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.7,62.28a8.42,8.42,0,0,1,1.44-3.23c-.16.59-.18,1.1,1.32,1.88,1.23.63,1.29.71,2.16,1.11l.37.16-.37.84-.37-.16c-.88-.38-1-.4-2.26-.89C335.4,61.4,335,61.77,334.7,62.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.09,62.81a4.59,4.59,0,0,1,.15-.44,4,4,0,0,1,.22-.41l.53.24-.37.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.68,64.6a.7.7,0,0,0,.31.07h.1l.11,0,.05,0,.08,0h0a2.59,2.59,0,0,0,1-1.27,2.68,2.68,0,0,0,.25-1.61h0l0-.08a.14.14,0,0,0,0-.06.41.41,0,0,0-.05-.09l0,0,0,0a.83.83,0,0,0-.26-.19.8.8,0,0,0-.3-.06c-.44,0-1,.53-1.39,1.35s-.38,1.63-.07,1.93A.64.64,0,0,0,339.68,64.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.21,64c-.27-.12-.28-.68,0-1.25s.68-.93.95-.81.23.32.2.63c-.05-.35-.36-.43-.64-.15a2.08,2.08,0,0,0-.5,1.15c0,.25.06.43.26.42A.29.29,0,0,1,340.21,64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.68,55.9a7.76,7.76,0,0,1,0-3c.08.51.71.92,2,1a7.65,7.65,0,0,0,1.2.1h.32v.78h-.32a7.13,7.13,0,0,0-1.2.11C337.39,55,336.76,55.39,336.68,55.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.73,54.79a2.38,2.38,0,0,1,0-.39,2.56,2.56,0,0,1,0-.39h.49v.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.66,55.73a.59.59,0,0,0,.23,0l0,0h0l.06,0,0,0,0,0h0a2.18,2.18,0,0,0,0-2.24h0l0-.05,0,0-.06-.05h0l-.05,0a.4.4,0,0,0-.22-.05.49.49,0,0,0-.21,0c-.29.11-.51.64-.51,1.28s.22,1.17.51,1.28A.5.5,0,0,0,340.66,55.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.85,55.2c-.21,0-.38-.36-.38-.8s.17-.8.38-.8.24.14.31.35c-.13-.21-.36-.17-.46.09a1.57,1.57,0,0,0,0,.89c.07.17.16.26.29.2A.19.19,0,0,1,340.85,55.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,49.77a7.55,7.55,0,0,1-1.44-3.23c.35.5,1.39.57,3.17-.12,1.45-.55,2.83-1.13,3.82-1.57l.42-.18.37.84-.41.18c-1,.45-2.34,1.09-3.73,1.8C336.6,48.36,336,49.17,336.09,49.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,45.74a2.52,2.52,0,0,1-.21-.4,3,3,0,0,1-.16-.44l.53-.23.37.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.72,46.57a.6.6,0,0,0,.27-.2l.05,0,0,0a.31.31,0,0,0,.05-.1.14.14,0,0,0,0-.06s0-.05,0-.08h0a2.73,2.73,0,0,0-.26-1.69A2.84,2.84,0,0,0,342.82,43h0l-.08,0-.06,0-.11,0h-.11a.91.91,0,0,0-.32.06.79.79,0,0,0-.27.2c-.32.32-.3,1.17.08,2s1,1.45,1.46,1.42A.71.71,0,0,0,343.72,46.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.66,45.75c-.29.13-.73-.25-1-.85s-.25-1.18,0-1.31.42,0,.64.28c-.31-.2-.59,0-.57.4a2.24,2.24,0,0,0,.55,1.2c.19.19.37.26.51.1A.29.29,0,0,1,343.66,45.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,44.1a13,13,0,0,1-2.5-2.25c.47.34,1.13.29,1.86-.38s1.14-1.11,1.52-1.52l.16-.17.65.58a1.43,1.43,0,0,0-.15.18c-.37.42-.87,1-1.35,1.67S332.5,43.67,332.88,44.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.32,40.64a3.84,3.84,0,0,1-.34-.28,3,3,0,0,1-.31-.31l.25-.27.65.58C334.5,40.45,334.41,40.54,334.32,40.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,40.6a.53.53,0,0,0,.11-.21s0,0,0,0v0a.22.22,0,0,0,0-.08v0s0-.05,0-.07h0a2,2,0,0,0-.66-1,1.93,1.93,0,0,0-1.1-.55h-.21l-.05,0a.66.66,0,0,0-.2.14.56.56,0,0,0-.11.2c-.12.31.14.85.64,1.31s1.08.65,1.37.5A.62.62,0,0,0,335.72,40.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.43,40.09c-.14.16-.55,0-.89-.27s-.51-.7-.36-.86.28-.1.49,0c-.26,0-.39.16-.25.43a1.57,1.57,0,0,0,.7.62c.19.07.32.06.37-.08A.25.25,0,0,1,335.43,40.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.67,40.35a6,6,0,0,1-3.36-1.09c.62.05,1.44-.92,2.28-3.19.2-.53.77-1.72,1.2-3,.06-.2.12-.38.18-.55l.87.28c0,.18-.11.36-.18.56-.41,1.3-.85,2.71-1,3.09C327.05,38.76,327.15,40,327.67,40.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.66,33.34c-.14,0-.29-.06-.45-.11a2.65,2.65,0,0,1-.42-.18c.06-.2.12-.38.18-.55l.87.28C328.79,33,328.73,33.14,328.66,33.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,32.5a.94.94,0,0,0,0-.37s0-.05,0-.07a.08.08,0,0,1,0,0s0-.08,0-.12l0-.06a.35.35,0,0,1,0-.08h0a2.94,2.94,0,0,0-1.57-1,3,3,0,0,0-1.87-.09h0l-.09,0-.06,0-.11.07,0,0-.06.05a.92.92,0,0,0-.18.32.86.86,0,0,0,0,.35c0,.5.73,1.11,1.71,1.43s1.91.24,2.22-.15A.87.87,0,0,0,330.7,32.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,32c-.11.33-.74.41-1.42.19s-1.15-.66-1-1,.33-.31.69-.31c-.39.1-.45.46-.09.75a2.46,2.46,0,0,0,1.37.43c.3,0,.49-.11.46-.35A.44.44,0,0,1,330,32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,39.06a9.1,9.1,0,0,1-3.69.39c.62-.17,1-1.07,1-2.81-.07-1.42-.08-1.28-.18-2.26,0-.15,0-.29,0-.42l1-.1c0,.13,0,.27,0,.41.12,1,.2.83.43,2.24C320.42,38.23,321,39,321.65,39.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,34.3l-.48.08-.49,0c0-.16,0-.3,0-.44l1-.1C319.67,34,319.69,34.14,319.71,34.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,33.05a.72.72,0,0,0-.08-.26l0,0,0,0-.06-.07,0,0-.06,0h0a2.21,2.21,0,0,0-1.36-.22,2.17,2.17,0,0,0-1.28.5h0l-.05,0,0,0a.35.35,0,0,0-.05.08v0a.14.14,0,0,0,0,.06.59.59,0,0,0,0,.27.62.62,0,0,0,.08.24c.16.33.82.53,1.57.45s1.35-.41,1.45-.76A.76.76,0,0,0,320.69,33.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.05,32.89c0,.25-.37.5-.89.55s-1-.1-1-.35.13-.3.37-.41c-.23.19-.16.44.16.53a1.79,1.79,0,0,0,1.05-.12c.19-.1.29-.22.2-.37A.28.28,0,0,1,320.05,32.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.83,40.41a24.54,24.54,0,0,1-2.35,1.36c.31-.21.65-.6.55-1a3.81,3.81,0,0,0-.31-.78.56.56,0,0,0-.05-.08l.5-.29,0,.08a3,3,0,0,0,.54.64A1,1,0,0,0,314.83,40.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27,39.83A1.43,1.43,0,0,1,313,40l-.25.13a1.74,1.74,0,0,1-.11-.18l.5-.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65,38.64a.4.4,0,0,0-.14-.15l0,0h0l-.07,0h-.09a1.78,1.78,0,0,0-1,.27,1.74,1.74,0,0,0-.75.76h0a.08.08,0,0,1,0,0s0,0,0,0v.14a.35.35,0,0,0,.06.19.34.34,0,0,0,.14.15,1.24,1.24,0,0,0,1.24-.18c.51-.29.83-.71.78-1A.35.35,0,0,0,313.65,38.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.15,38.73c.1.17-.11.47-.46.67s-.71.23-.81.07,0-.26.13-.41c-.1.2,0,.36.29.32A1.42,1.42,0,0,0,313,39c.1-.14.13-.25,0-.33A.23.23,0,0,1,313.15,38.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77,42.05a15.52,15.52,0,1,1-21.74,3A15.52,15.52,0,0,1,330.77,42.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77,42.05a15.52,15.52,0,1,1-21.74,3A15.52,15.52,0,0,1,330.77,42.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,45.93c2.41,3.92,2.82,15.64-7.18,20.87s-18.64-3.38-20.35-6.94A15.52,15.52,0,1,0,334.4,45.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07,63.73A1.92,1.92,0,0,1,323.38,65c.11.87-.73,1.7-1.89,1.85a1.91,1.91,0,0,1-2.31-1.3C319.06,64.71,319.91,63.88,321.07,63.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.94,66c-.44-.33-.08-1.2,1-1.41a1.86,1.86,0,0,1,1.92.56.67.67,0,0,1-.35.88c.24-.27.17-.65-.29-.88a2,2,0,0,0-1.9.07C320,65.47,319.82,65.78,319.94,66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,45.43c-1.15-.18-2-1-1.84-1.9a1.9,1.9,0,0,1,2.33-1.25c1.16.18,2,1,1.85,1.9A1.91,1.91,0,0,1,324.86,45.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,43.55c.32.45-.27,1.18-1.35,1.08-.85-.08-1.59-.58-1.67-1.08a.65.65,0,0,1,.57-.74c-.3.2-.34.57,0,.93a2.09,2.09,0,0,0,1.85.46C326.43,44.08,326.64,43.81,326.6,43.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,54.94a1.39,1.39,0,1,1-1.74-1.39A1.62,1.62,0,0,1,316.55,54.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.52,54.23c.24-.4,1-.19,1.28.68a1.54,1.54,0,0,1-.27,1.65.56.56,0,0,1-.77-.2c.25.17.56.08.71-.33a1.74,1.74,0,0,0-.26-1.58C315,54.18,314.71,54.11,314.52,54.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.19,56.66a1.66,1.66,0,1,1,.37,2.62A1.92,1.92,0,0,1,325.19,56.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.36,58.93c-.53.15-1-.65-.55-1.63.36-.78,1.09-1.3,1.59-1.21a.66.66,0,0,1,.5.8c-.08-.36-.42-.53-.89-.29A2,2,0,0,0,326,58.17C325.92,58.59,326.1,58.88,326.36,58.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.94,57.16a1.91,1.91,0,0,1-1.14,2.39c-.87.17-1.75-.62-2-1.76A1.91,1.91,0,0,1,310,55.4C310.83,55.22,311.71,56,311.94,57.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.58,56.18c.31-.46,1.2-.15,1.48.89a1.84,1.84,0,0,1-.44,2,.68.68,0,0,1-.9-.28c.29.21.67.12.87-.35a2.09,2.09,0,0,0-.2-1.9C310.14,56.16,309.81,56.05,309.58,56.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42,50.58a1.46,1.46,0,1,1,2.39-1.49,1.47,1.47,0,1,1-2.39,1.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,50.66c-.11.48-.94.5-1.5-.28a1.64,1.64,0,0,1-.25-1.75.6.6,0,0,1,.84,0c-.31-.09-.59.1-.61.56a1.81,1.81,0,0,0,.75,1.5C326.22,50.85,326.52,50.84,326.68,50.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.12,46.29c-1.38.85-3,.69-3.65-.36s0-2.56,1.36-3.41,3-.68,3.65.36S319.51,45.45,318.12,46.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.27,42.75c.75.18.78,1.48-.45,2.34a2.53,2.53,0,0,1-2.74.37.92.92,0,0,1-.06-1.31c-.14.48.15.92.87,1A2.84,2.84,0,0,0,318.25,44C318.57,43.46,318.56,43,318.27,42.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,62.33a1.23,1.23,0,1,1-.33,2A1.41,1.41,0,0,1,328,62.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.31,64.21c-.41,0-.57-.69,0-1.29a1.39,1.39,0,0,1,1.41-.5.5.5,0,0,1,.17.69c0-.27-.18-.47-.56-.41a1.55,1.55,0,0,0-1.12.88C328.08,63.87,328.14,64.11,328.31,64.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.83,55.36c.15-1.18,1-2,1.88-1.94a2,2,0,0,1,1.34,2.34c-.15,1.18-1,2.05-1.88,1.94A1.94,1.94,0,0,1,330.83,55.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.79,57.07c-.44.34-1.2-.24-1.13-1.34,0-.87.54-1.64,1-1.74a.68.68,0,0,1,.78.57c-.21-.3-.6-.34-1,.06a2.07,2.07,0,0,0-.41,1.89C332.25,56.91,332.53,57.12,332.79,57.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.39,48.71a1.08,1.08,0,1,1,1.66.46A1.23,1.23,0,0,1,330.39,48.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,48.6c0,.36-.65.44-1.12-.09a1.2,1.2,0,0,1-.31-1.26.44.44,0,0,1,.61-.1c-.23,0-.42.12-.4.46a1.31,1.31,0,0,0,.66,1C331.73,48.78,332,48.75,332.05,48.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.39,50.5a1.08,1.08,0,1,1-2-.68c.25-.72.89-1.16,1.43-1A1.26,1.26,0,0,1,311.39,50.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.38,49.17c.33-.16.73.3.54,1s-.56,1-.88,1a.44.44,0,0,1-.42-.46c.1.22.33.29.61.09a1.34,1.34,0,0,0,.5-1.13C310.71,49.34,310.56,49.17,310.38,49.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,59.09a1.24,1.24,0,0,1,1.4,1c0,.58-.6,1-1.37,1.07s-1.39-.44-1.4-1S318.77,59.1,319.54,59.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.63,60.49c-.26-.25,0-.79.75-.84.55,0,1.09.19,1.19.5a.43.43,0,0,1-.28.55c.17-.17.16-.41-.13-.6a1.33,1.33,0,0,0-1.23-.09C318.68,60.13,318.58,60.32,318.63,60.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,50a1.08,1.08,0,1,1-1.16-1.73A1.08,1.08,0,1,1,318.83,50Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,48.29c.36.07.4.68-.16,1.11a1.2,1.2,0,0,1-1.28.23.43.43,0,0,1-.06-.61c-.05.22.09.43.43.43a1.35,1.35,0,0,0,1.09-.6A.42.42,0,0,0,318.82,48.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,62.86a1.08,1.08,0,1,1-1.28,1.64,1.26,1.26,0,0,1-.45-1.67A1.24,1.24,0,0,1,314.15,62.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.57,63.38c-.05-.36.52-.59,1.1-.19s.73.84.61,1.15a.42.42,0,0,1-.56.24c.23,0,.38-.21.28-.54a1.35,1.35,0,0,0-.9-.85C312.83,63.13,312.63,63.21,312.57,63.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.88,52.84a2.12,2.12,0,1,1-2.69-.66A2,2,0,0,1,322.88,52.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.55,53.9c-.05.66.63,1.28,1.61,1.12s1.79-1.46,1.16-2.12a1.58,1.58,0,0,1-1.15,1.53A1.19,1.19,0,0,1,319.55,53.9Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--virus--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.32,53a10.38,10.38,0,0,1-1.79,4.71c.16-.86-.86-2-3.4-3.1-2.07-.92-4.09-1.74-5.56-2.3L34,52.1l.47-1.23.62.24c1.47.55,3.53,1.28,5.68,2C43.37,53.94,44.87,53.78,45.32,53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.19,51.16a4.19,4.19,0,0,1-.19.64,3.56,3.56,0,0,1-.28.59L34,52.1l.47-1.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.27,49.12a1,1,0,0,0-.37,0h-.12l-.13,0-.06,0-.1.05h0a3.16,3.16,0,0,0-1.15,1.58,3.08,3.08,0,0,0-.19,1.95h0a.3.3,0,0,0,0,.1.14.14,0,0,0,0,.06l.07.12,0,0,0,.06a1,1,0,0,0,.32.21,1,1,0,0,0,.37,0c.52,0,1.19-.7,1.57-1.71s.36-2,0-2.32A.89.89,0,0,0,34.27,49.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.67,49.84c.33.13.38.8.12,1.49s-.75,1.16-1.08,1-.31-.37-.29-.74c.09.41.46.49.78.14a2.59,2.59,0,0,0,.52-1.42c0-.31-.09-.51-.34-.49A.42.42,0,0,1,33.67,49.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79,61.77a11.66,11.66,0,0,1,.28,5c-.19-.85-.5-1.51-3-1.52-2,0-2.15-.07-3.55,0l-.59,0L35.88,64l.59,0c1.4-.09,1.53-.12,3.53-.35C42.46,63.34,42.7,62.63,42.79,61.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,64a3.29,3.29,0,0,1,.09.65,4.8,4.8,0,0,1,0,.66l-.83,0L35.88,64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.79,62.06a1.07,1.07,0,0,0-.44.12l-.09,0,0,0-.12.1,0,.06a.39.39,0,0,0-.08.1h0a3.84,3.84,0,0,0-.48,2.27,3.72,3.72,0,0,0,.73,2.2h0l.09.09.06,0,.13.09,0,0,.09,0a1.12,1.12,0,0,0,.45.07,1,1,0,0,0,.43-.12c.56-.24,1-1.33.88-2.61s-.57-2.32-1.17-2.5A1,1,0,0,0,34.79,62.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.48,63.13c.42,0,.8.67.85,1.56s-.26,1.62-.68,1.64c-.26,0-.5-.25-.66-.66.29.4.73.31.91-.23a3.07,3.07,0,0,0-.12-1.78c-.16-.33-.35-.51-.6-.37A.45.45,0,0,1,34.48,63.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.32,71.12a10.92,10.92,0,0,1,1.93,3.78c-.42-.59-1.51-.69-3.25.07a13.54,13.54,0,0,0-1.61.67l-.41.2-.5-1,.4-.21a13.53,13.53,0,0,0,1.48-.92C44,72.75,44.55,71.82,44.32,71.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,74.54a4.19,4.19,0,0,1,.29.47,3.15,3.15,0,0,1,.21.52l-.62.31-.5-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3,74a.85.85,0,0,0-.25.21l0,0s0,0,0,0l0,.1a.14.14,0,0,0,0,.06.19.19,0,0,0,0,.08h0a3.15,3.15,0,0,0,1.45,2.84h0a.16.16,0,0,0,.09,0l0,0,.11,0h.1a.68.68,0,0,0,.31-.08.82.82,0,0,0,.25-.2c.29-.32.23-1.14-.19-2s-1-1.34-1.48-1.29A.84.84,0,0,0,39.3,74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41,74.75c.26-.14.71.2,1,.76s.3,1.13,0,1.26-.4,0-.62-.23c.3.18.56,0,.52-.42A2.15,2.15,0,0,0,39.76,75c-.2-.17-.38-.23-.5-.07A.3.3,0,0,1,39.41,74.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,78.48A10.61,10.61,0,0,1,53,81.64c-.77-.41-2.14.19-4,2.23-1.49,1.66-2.87,3.31-3.85,4.51l-.42.51-1-.82.41-.51c1-1.21,2.28-2.92,3.59-4.73C49.29,80.61,49.59,79.14,49,78.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.21,87.43a4.33,4.33,0,0,1,.54.37,5.27,5.27,0,0,1,.48.45l-.52.64-1-.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.36,87.56a1.19,1.19,0,0,0-.21.42s0,.07,0,.11a.08.08,0,0,1,0,0v.17s0,0,0,.08a.59.59,0,0,0,0,.13h0a4.64,4.64,0,0,0,3.67,3H45l.16,0,0,0,.09,0a1.07,1.07,0,0,0,.37-.3,1,1,0,0,0,.21-.42c.21-.62-.37-1.68-1.42-2.52s-2.21-1.19-2.77-.86A1.17,1.17,0,0,0,41.36,87.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,88.55c.28-.34,1.09-.15,1.82.44s1.08,1.33.81,1.68-.55.22-1,0c.53.06.76-.36.46-.87a3.19,3.19,0,0,0-1.47-1.17c-.37-.1-.65-.08-.72.22A.5.5,0,0,1,42,88.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.74,83.6a18.12,18.12,0,0,1,4.63,1.22c-.81-.12-1.62.38-2.12,1.72-.41,1.09-.73,2.17-1,2.95l-.09.33L57,89.5c0-.11.05-.22.08-.33.2-.79.44-1.88.63-3C58,84.72,57.5,83.89,56.74,83.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.14,89a4.76,4.76,0,0,1,.61.13,4.7,4.7,0,0,1,.6.19c-.05.18-.1.35-.14.52L57,89.5C57.05,89.34,57.09,89.16,57.14,89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,89.93a1,1,0,0,0,0,.34s0,0,0,.07a0,0,0,0,0,0,0,.56.56,0,0,0,0,.12l0,.05.06.07h0a2.78,2.78,0,0,0,1.51.87,2.75,2.75,0,0,0,1.74,0h0l.08,0,0,0,.1-.08s0,0,0,0,0,0,.05,0a.83.83,0,0,0,.16-.31.74.74,0,0,0,0-.33c0-.46-.73-1-1.66-1.24s-1.79-.13-2.06.25A.85.85,0,0,0,55.4,89.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.09,90.4c.08-.3.67-.41,1.31-.24s1.1.55,1,.86-.3.3-.63.32c.36-.12.39-.45.05-.71a2.37,2.37,0,0,0-1.3-.33c-.27,0-.45.14-.41.35A.37.37,0,0,1,56.09,90.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,85.07a10.61,10.61,0,0,1,5-.8c-.82.29-1.29,1.7-1,4.41.24,2.21.53,4.33.77,5.85,0,.23.07.44.1.64l-1.29.21c0-.2-.07-.41-.11-.64-.25-1.52-.64-3.63-1.11-5.8C67.4,86.28,66.52,85.09,65.65,85.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,94.57a4,4,0,0,1,.64-.16,5.14,5.14,0,0,1,.66,0c0,.29.09.56.13.81l-1.29.21C69.15,95.13,69.11,94.86,69.06,94.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,97a1.32,1.32,0,0,0,.19.49l.07.09,0,0,.13.12.08.06.12.07h0A5.1,5.1,0,0,0,72.73,97h0a.31.31,0,0,0,.09-.11l.06-.07.09-.16a.43.43,0,0,1,0,0,.49.49,0,0,0,0-.11,1.29,1.29,0,0,0,0-.52,1.16,1.16,0,0,0-.19-.47c-.35-.62-1.64-.93-3.09-.7s-2.59.93-2.72,1.63A1.1,1.1,0,0,0,67,97Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,97.18c-.08-.48.68-1,1.68-1.16s1.88.1,2,.57c0,.3-.22.61-.68.84.43-.38.26-.87-.37-1a3.54,3.54,0,0,0-2,.35c-.35.22-.53.46-.35.73A.51.51,0,0,1,68.28,97.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.38,82.8a16.6,16.6,0,0,1,4.42-2.89c-.69.59-.79,1.76.13,3.44.75,1.37,1.53,2.66,2.12,3.57a4.2,4.2,0,0,0,.24.38l-1.15.76-.25-.38c-.6-.91-1.46-2.14-2.42-3.38C76.3,82.79,75.19,82.4,74.38,82.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8,87.53a4.92,4.92,0,0,1,.55-.41c.21-.13.41-.24.6-.34l.34.52-1.15.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.36,89.76a1,1,0,0,0,.27.27l.08,0,0,0,.12,0h.07l.1,0h0a3.13,3.13,0,0,0,1.86-.6,3.17,3.17,0,0,0,1.3-1.47h0l0-.1s0,0,0-.07a.57.57,0,0,0,0-.13v0a.22.22,0,0,0,0-.08,1,1,0,0,0-.13-.36.83.83,0,0,0-.27-.26c-.42-.31-1.37-.13-2.28.46s-1.45,1.39-1.33,1.9A.93.93,0,0,0,79.36,89.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.27,89.54c-.19-.3.16-.87.78-1.28s1.29-.5,1.48-.2,0,.47-.2.76c.17-.38-.08-.66-.55-.57a2.54,2.54,0,0,0-1.25.84c-.17.26-.23.47,0,.6A.42.42,0,0,1,80.27,89.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,76.61a31.8,31.8,0,0,1,2.1-3.25c-.27.47-.44,1.19-.07,1.58a5,5,0,0,0,.9.8l.11.07-.45.68-.1-.06a4,4,0,0,0-1.1-.47A1.38,1.38,0,0,0,82,76.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.36,76.33c.06-.11.13-.23.21-.35s.15-.24.23-.34l.26.17-.45.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,78.09a.56.56,0,0,0,.27.1h.25l.08,0h0a2.84,2.84,0,0,0,1.58-2.45h0a.19.19,0,0,0,0-.08.13.13,0,0,0,0-.06l0-.09,0,0,0,0a.6.6,0,0,0-.21-.21.64.64,0,0,0-.27-.11c-.39-.08-1,.34-1.46,1s-.59,1.44-.35,1.77A.58.58,0,0,0,84.66,78.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,77.65c-.23-.15-.16-.66.15-1.15s.75-.75,1-.61.18.33.1.61c0-.33-.27-.45-.57-.23a2,2,0,0,0-.62,1c0,.24,0,.4.18.43A.28.28,0,0,1,85.23,77.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,68.58a12,12,0,0,1,.67-5c0,.87.2,1.58,2.56,2,1.93.38,2.05.46,3.4.65l.57.08L93,67.67l-.57-.07c-1.35-.18-1.48-.17-3.44-.32C86.62,67.1,86.26,67.75,86,68.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22,67.56a3.73,3.73,0,0,1,0-.66,6,6,0,0,1,.14-.64l.82.11L93,67.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74,69.79a1.12,1.12,0,0,0,.45,0l.1,0h0l.14-.08.07-.05.09-.08h0a4.42,4.42,0,0,0,.61-4.44h0a.61.61,0,0,1-.07-.1l0-.06L95,64.76l0,0-.08-.06a1.16,1.16,0,0,0-.43-.16,1.08,1.08,0,0,0-.44,0c-.6.14-1.18,1.13-1.35,2.4s.12,2.38.66,2.67A1,1,0,0,0,93.74,69.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,68.79c-.42-.05-.66-.81-.54-1.69s.55-1.54,1-1.48c.26,0,.45.34.53.77-.21-.45-.67-.44-.94.06A3.07,3.07,0,0,0,94,68.22c.1.35.25.57.53.48A.43.43,0,0,1,94.25,68.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.18,59.06A10.83,10.83,0,0,1,85,55c.3.67,1.34,1,3.16.56a10.89,10.89,0,0,0,1.68-.34l.43-.12.31,1.06-.43.13a11,11,0,0,0-1.6.62C86.79,57.53,86.08,58.34,86.18,59.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,56.34a3.52,3.52,0,0,1-.19-.52,3.89,3.89,0,0,1-.12-.55l.67-.19.31,1.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.56,57.25a.85.85,0,0,0,.28-.16l0-.05,0,0,.07-.09,0,0a.3.3,0,0,1,0-.08h0a2.66,2.66,0,0,0,0-1.65,2.61,2.61,0,0,0-.87-1.41h0l-.07,0,0,0-.11,0h-.1a.7.7,0,0,0-.32,0,.69.69,0,0,0-.28.15c-.35.26-.44,1.08-.18,1.95s.76,1.52,1.2,1.55A.87.87,0,0,0,91.56,57.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,56.45c-.29.09-.66-.33-.84-.94s-.08-1.16.2-1.24.39.09.57.35c-.27-.24-.56-.1-.6.3a2.32,2.32,0,0,0,.37,1.22c.17.2.33.3.48.16A.27.27,0,0,1,91.6,56.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,50.91a10.6,10.6,0,0,1-3.25-3.84c.67.55,2.12.22,4.28-1.42C85.73,44.31,87.39,43,88.57,42l.5-.42.84,1-.49.42c-1.17,1-2.77,2.42-4.38,3.94C83.06,48.78,82.5,50.16,82.93,50.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.28,43.09a5,5,0,0,1-.46-.46,4.56,4.56,0,0,1-.39-.54l.64-.53.84,1C89.72,42.73,89.51,42.9,89.28,43.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1,43.51a1,1,0,0,0,.29-.38.42.42,0,0,0,0-.1s0,0,0,0a.86.86,0,0,0,0-.17.19.19,0,0,0,0-.08v-.13h0a3.9,3.9,0,0,0-1-2.22,3.94,3.94,0,0,0-2-1.38h0l-.13,0H89l-.1,0a1.46,1.46,0,0,0-.43.22,1.39,1.39,0,0,0-.28.37c-.32.57.05,1.73.92,2.75s2,1.59,2.56,1.37A1.25,1.25,0,0,0,92.1,43.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,42.41c-.33.29-1.09-.06-1.7-.77s-.81-1.51-.47-1.8.58-.11,1,.13c-.5-.15-.81.21-.62.77a3.27,3.27,0,0,0,1.23,1.43c.35.17.62.2.75-.08A.47.47,0,0,1,91.68,42.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.29,44.43A18,18,0,0,1,72,42.35c.77.28,1.66-.05,2.39-1.26.6-1,1.13-2,1.48-2.69l.15-.3,1.12.54c0,.1-.09.2-.14.31-.34.72-.79,1.74-1.18,2.83C75.3,43.11,75.59,44,76.29,44.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,39.13a5.64,5.64,0,0,1-.58-.25,4.83,4.83,0,0,1-.55-.3q.14-.26.24-.48l1.12.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.77,38.52a.8.8,0,0,0,.08-.33v-.11l0-.11a.14.14,0,0,0,0-.06l0-.09h0a3.26,3.26,0,0,0-3-1.46h0l-.09,0-.06,0-.11.06h0l-.06.05a.71.71,0,0,0-.21.27.72.72,0,0,0-.08.32c0,.46.53,1.11,1.4,1.53s1.73.47,2.07.14A.75.75,0,0,0,78.77,38.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18,37.93c-.14.28-.73.28-1.33,0s-1-.75-.84-1,.35-.24.68-.2c-.38,0-.47.38-.18.69a2.31,2.31,0,0,0,1.21.57c.28,0,.47,0,.47-.27A.33.33,0,0,1,78.18,37.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,41.37a8.48,8.48,0,0,1-5-.15c.87-.17,1.6-1.83,1.85-5.27.06-.81.37-2.66.44-4.61,0-.29,0-.57,0-.82l1.3,0c0,.25,0,.53,0,.82,0,1.95-.09,4.05-.09,4.62C66.18,39.45,66.82,41.15,67.67,41.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.23,31.38a3.57,3.57,0,0,1-.66,0,4.31,4.31,0,0,1-.65-.07c0-.29,0-.57,0-.82l1.3,0C66.25,30.81,66.24,31.09,66.23,31.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.69,29.43a1.08,1.08,0,0,0-.1-.51.54.54,0,0,0,0-.11l0,0a.72.72,0,0,0-.11-.15l-.06-.07-.1-.1h0a4.31,4.31,0,0,0-2.55-.78,4.38,4.38,0,0,0-2.6.62h0l-.11.09-.07.06-.12.14,0,.05-.06.1a1.37,1.37,0,0,0-.13.5,1.18,1.18,0,0,0,.1.5c.23.68,1.43,1.22,2.91,1.27s2.71-.43,3-1.09A1.31,1.31,0,0,0,68.69,29.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.49,29c0,.48-.85.85-1.87.82s-1.82-.45-1.81-.94c0-.29.33-.55.82-.69-.49.29-.42.81.18,1.07a3.59,3.59,0,0,0,2,0c.39-.16.62-.36.49-.66A.51.51,0,0,1,67.49,29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.91,42A12.62,12.62,0,0,1,54,44c.78-.47,1-1.86.19-4.22-.65-1.92-.62-1.72-1.14-3l-.22-.55,1.27-.52c.07.17.14.35.23.55.54,1.3.59,1.06,1.47,2.89C56.91,41.36,58,42.21,58.91,42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,36.26a5.37,5.37,0,0,1-1.28.52l-.23-.58,1.27-.52C54.19,35.86,54.27,36.06,54.36,36.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,34.16a.91.91,0,0,0-.22-.32l-.06-.05,0,0-.12-.06-.06,0-.1,0h0a3.17,3.17,0,0,0-1.94.23,3.21,3.21,0,0,0-1.56,1.2h0l0,.09a.25.25,0,0,1,0,.07.5.5,0,0,0,0,.13v0s0,.06,0,.08a1,1,0,0,0,.07.38.85.85,0,0,0,.21.31c.35.38,1.32.39,2.32,0s1.69-1.09,1.68-1.62A.92.92,0,0,0,55.21,34.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.27,34.2c.14.33-.31.83-1,1.11s-1.35.24-1.49-.08.06-.48.34-.71c-.24.34,0,.67.44.66a2.61,2.61,0,0,0,1.39-.59c.21-.22.31-.42.13-.58A.34.34,0,0,1,54.27,34.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.11,46.57a33.66,33.66,0,0,1-2.67,2.79c.35-.41.66-1.08.37-1.54a5.73,5.73,0,0,0-.74-1L47,46.78l.56-.59.1.09a4,4,0,0,0,1,.66A1.36,1.36,0,0,0,50.11,46.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.76,46.4l-.27.31-.3.28a2.08,2.08,0,0,0-.21-.21l.56-.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8,44.61a.64.64,0,0,0-.25-.15l-.06,0h-.27a2.44,2.44,0,0,0-1.3.78,2.49,2.49,0,0,0-.72,1.33h0v.13a.43.43,0,0,0,0,.11v0l0,.06a.56.56,0,0,0,.16.25.64.64,0,0,0,.25.15c.37.16,1.05-.14,1.63-.74s.85-1.31.67-1.67A.63.63,0,0,0,47.8,44.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.15,44.94c.2.19,0,.68-.36,1.1s-.88.6-1.08.41-.11-.35,0-.61c-.06.32.18.48.51.33a2,2,0,0,0,.8-.85c.08-.22.09-.39-.09-.45A.27.27,0,0,1,47.15,44.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.58,42.47A22.12,22.12,0,1,1,44,55.27,22.13,22.13,0,0,1,72.58,42.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.58,42.47A22.12,22.12,0,1,1,44,55.27,22.13,22.13,0,0,1,72.58,42.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09,46.33c4.86,4.4,10.08,20.28-1.52,31.42S50.72,80.53,47,76.34a22.12,22.12,0,1,0,32.12-30Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,76c1.53-.67,3.17-.28,3.68.87s-.33,2.62-1.85,3.29-3.17.28-3.68-.87S66.41,76.66,67.93,76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.29,79.58c-.73-.28-.58-1.61.79-2.32,1.08-.57,2.36-.53,2.84,0a1,1,0,0,1-.12,1.34c.21-.47,0-1-.75-1.1a2.94,2.94,0,0,0-2.57.87C67.08,78.81,67,79.3,67.29,79.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,49.44c-1.66.22-3.13-.61-3.29-1.86s1-2.42,2.7-2.64,3.12.62,3.28,1.86S67.5,49.23,65.85,49.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.47,46.18c.62.48.1,1.71-1.41,2-1.2.24-2.42-.16-2.73-.8a.94.94,0,0,1,.49-1.25c-.33.39-.24.92.42,1.26A2.94,2.94,0,0,0,67,47.29C67.45,47,67.63,46.53,67.47,46.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25,65.76c.71,1.21.56,2.62-.35,3.16A2.3,2.3,0,0,1,55,67.71c-.71-1.21-.56-2.62.35-3.16A2.3,2.3,0,0,1,58.25,65.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.19,65.59c.17-.64,1.29-.65,2,.42a2.18,2.18,0,0,1,.28,2.37.78.78,0,0,1-1.12,0c.41.13.79-.12.83-.74a2.44,2.44,0,0,0-1-2.05C55.81,65.34,55.41,65.35,55.19,65.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75,64.67c.37-1.62,1.66-2.72,2.88-2.44s1.92,1.81,1.55,3.44-1.65,2.72-2.87,2.45S70.39,66.3,70.75,64.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.26,67.32c-.66.42-1.64-.49-1.4-2,.19-1.21,1-2.22,1.69-2.29a1,1,0,0,1,1,.89c-.26-.45-.79-.55-1.33,0a2.93,2.93,0,0,0-.83,2.59C72.52,67,72.88,67.35,73.26,67.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.83,70.63c.77,1.48.49,3.15-.62,3.73s-2.64-.15-3.41-1.63-.49-3.14.62-3.72S52.06,69.15,52.83,70.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.21,70.23c.23-.75,1.57-.69,2.37.63.63,1,.68,2.33.18,2.84a.94.94,0,0,1-1.34,0c.48.18,1-.09,1-.82a2.9,2.9,0,0,0-1-2.51C50,70,49.48,70,49.21,70.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,56.67c-1.1-1-1.39-2.45-.64-3.28s2.23-.69,3.32.29,1.39,2.45.65,3.28S68.37,57.65,67.28,56.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4,55.88c0,.69-1.09,1.06-2.16.21a2.31,2.31,0,0,1-1-2.29.85.85,0,0,1,1.12-.4c-.45,0-.76.38-.61,1a2.6,2.6,0,0,0,1.64,1.76C69.86,56.32,70.27,56.19,70.4,55.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,53.3c-1.56,1.71-3.86,2.14-5.14,1s-1.06-3.51.5-5.21,3.86-2.14,5.14-1S58.52,51.6,57,53.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,48.4c1.09,0,1.65,1.72.31,3.39-1.06,1.32-2.7,2-3.61,1.58a1.31,1.31,0,0,1-.6-1.76c0,.71.58,1.2,1.57,1A4.09,4.09,0,0,0,56.21,50C56.46,49.26,56.25,48.62,55.76,48.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.85,71.31A1.77,1.77,0,1,1,79.78,73a1.77,1.77,0,1,1-2.93-1.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,73.76c-.56.15-1.06-.72-.54-1.75.41-.81,1.2-1.35,1.72-1.24a.72.72,0,0,1,.52.87c-.08-.38-.44-.57-.94-.34A2.17,2.17,0,0,0,77.62,73C77.57,73.39,77.76,73.7,78,73.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,60.65c-.27-1.67.54-3.19,1.8-3.39s2.49,1,2.76,2.67-.54,3.19-1.8,3.39S78.22,62.33,78,60.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.32,62.21c-.47.65-1.74.16-2.08-1.37-.28-1.22.09-2.46.74-2.8a1,1,0,0,1,1.28.46c-.41-.32-1-.22-1.27.46a3,3,0,0,0,.18,2.75C80.51,62.21,81,62.39,81.32,62.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71,51.74a1.54,1.54,0,1,1,1.74-2.39,1.54,1.54,0,1,1-1.74,2.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,50.92c.08.51-.72.86-1.57.32-.67-.43-1.07-1.16-.92-1.6a.6.6,0,0,1,.79-.37c-.33,0-.53.33-.37.78a1.89,1.89,0,0,0,1.33,1.17C76.58,51.29,76.86,51.16,76.94,50.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.42,61.73c-.05,1.09-.76,1.94-1.57,1.9a1.77,1.77,0,0,1-1.38-2c.05-1.09.76-1.94,1.57-1.89A1.76,1.76,0,0,1,49.42,61.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.52,60.32c.38-.35,1.11.13,1.12,1.13a1.7,1.7,0,0,1-.83,1.66.61.61,0,0,1-.74-.46c.21.26.56.26.86-.12a1.92,1.92,0,0,0,.24-1.75C48,60.42,47.76,60.25,47.52,60.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,70.25a1.77,1.77,0,0,1,2.31.83c.25.78-.4,1.68-1.44,2a1.77,1.77,0,0,1-2.31-.83C62.3,71.47,63,70.57,64,70.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.31,72.53c-.46-.24-.26-1.09.68-1.45a1.69,1.69,0,0,1,1.84.21.62.62,0,0,1-.18.86c.17-.29.06-.62-.4-.77a2,2,0,0,0-1.73.37C63.23,72,63.16,72.32,63.31,72.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38,58a1.54,1.54,0,1,1-2.27-1.9A1.54,1.54,0,1,1,59.38,58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.72,55.76c.51,0,.81.77.21,1.58-.47.65-1.23,1-1.66.83a.63.63,0,0,1-.32-.82c0,.33.29.55.76.42A1.91,1.91,0,0,0,59,56.52C59.06,56.15,59,55.85,58.72,55.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.12,77.56A1.54,1.54,0,1,1,57,80.3a1.54,1.54,0,1,1,1.11-2.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.16,78.89c-.21-.47.48-1,1.44-.69.76.25,1.32.86,1.29,1.33a.61.61,0,0,1-.68.55c.32-.11.44-.45.17-.85a1.91,1.91,0,0,0-1.57-.8C56.42,78.44,56.17,78.64,56.16,78.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.07,60.37a3,3,0,1,1-3.94.17A2.8,2.8,0,0,1,66.07,60.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.94,63.15c.2.91,1.37,1.49,2.66.89s1.86-2.71.73-3.37a2.24,2.24,0,0,1-1,2.55A1.69,1.69,0,0,1,61.94,63.15Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--virus--inject-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.47,144.53a7.74,7.74,0,0,1-2.26,3c.29-.58-.21-1.6-1.79-2.93-1.3-1.09-2.58-2.1-3.51-2.81l-.4-.3.59-.78.4.3c.94.7,2.26,1.65,3.66,2.6C316.88,144.77,318,145,318.47,144.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6,141.08a3.62,3.62,0,0,1-.27.41,2.94,2.94,0,0,1-.32.37l-.5-.37.59-.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,139.42a.66.66,0,0,0-.26-.11H311s0,0,0,0h-.23a2.27,2.27,0,0,0-1.16.89,2.38,2.38,0,0,0-.54,1.36h0v.08a.07.07,0,0,1,0,0l0,.09s0,0,0,0l0,.05a.55.55,0,0,0,.18.22.72.72,0,0,0,.25.12c.38.11,1-.26,1.49-.9s.67-1.34.46-1.67A1,1,0,0,0,311.37,139.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.78,139.81c.21.16.11.65-.22,1.1s-.78.67-1,.51-.15-.32-.06-.58c0,.31.23.44.54.26a2.07,2.07,0,0,0,.67-.91c0-.22,0-.39-.15-.42A.29.29,0,0,1,310.78,139.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.84,150.27a8.79,8.79,0,0,1-.85,3.66c0-.64-.05-1.19-1.82-1.71-1.44-.42-1.53-.49-2.55-.74l-.42-.1.22-.95.43.1c1,.23,1.12.23,2.6.48C314.27,151.32,314.59,150.87,314.84,150.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,150.57a4.37,4.37,0,0,1-.08.48,2.88,2.88,0,0,1-.15.47l-.59-.14.22-.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,148.81a.65.65,0,0,0-.34,0h-.1l-.11,0-.05,0-.08.06h0a3.32,3.32,0,0,0-.76,3.26h0a.56.56,0,0,0,0,.08l0,.05a.86.86,0,0,0,.07.1l0,0,.06,0a.77.77,0,0,0,.3.15.74.74,0,0,0,.33,0c.46-.06,1-.76,1.18-1.7s.07-1.77-.31-2A.69.69,0,0,0,309,148.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,149.51c.31.07.43.65.28,1.3s-.51,1.1-.82,1-.31-.28-.34-.61c.13.35.46.37.7,0a2.28,2.28,0,0,0,.29-1.31c-.05-.27-.14-.44-.36-.39A.34.34,0,0,1,308.59,149.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,157.29a8,8,0,0,1,.6,3.12c-.18-.52-.94-.81-2.35-.63a9.12,9.12,0,0,0-1.29.14l-.33.06-.16-.81.33-.06a9,9,0,0,0,1.26-.36C313.41,158.4,314,157.84,314,157.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,159.07c0,.13.08.26.11.4a3.19,3.19,0,0,1,.05.42l-.51.09-.16-.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.79,158.28a.62.62,0,0,0-.22.1l0,0,0,0a.15.15,0,0,0-.05.06l0,0,0,.06h0a2.37,2.37,0,0,0,.45,2.34h0l0,0,0,0,.07,0h0l0,0a.64.64,0,0,0,.24,0,.5.5,0,0,0,.21-.09c.29-.17.41-.77.28-1.44s-.47-1.18-.79-1.23A.65.65,0,0,0,309.79,158.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.71,158.87c.21,0,.47.3.55.76s0,.87-.23.91-.29-.09-.4-.3c.18.19.41.11.46-.19a1.61,1.61,0,0,0-.18-.93c-.11-.16-.23-.24-.35-.15A.25.25,0,0,1,309.71,158.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.82,163.55a8,8,0,0,1,2.16,3.09c-.47-.46-1.57-.31-3.31.77-1.41.88-2.75,1.77-3.71,2.43l-.4.28-.56-.8.4-.28c1-.67,2.25-1.62,3.56-2.65C315.57,165.13,316.09,164.15,315.82,163.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.51,169c.1.12.21.24.31.38a3.94,3.94,0,0,1,.25.43l-.51.35-.56-.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.44,168.46a.88.88,0,0,0-.24.27l0,.06s0,0,0,0a.56.56,0,0,0,0,.12.13.13,0,0,0,0,.06.38.38,0,0,0,0,.1h0a2.85,2.85,0,0,0,.61,1.71,2.93,2.93,0,0,0,1.4,1.17h0l.09,0,.06,0h.24a.94.94,0,0,0,.33-.14.77.77,0,0,0,.23-.25c.28-.4.09-1.29-.49-2.11s-1.34-1.31-1.81-1.19A.8.8,0,0,0,308.44,168.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,169.31c.27-.19.82.12,1.22.69s.5,1.18.22,1.37-.44,0-.71-.17c.36.15.62-.1.51-.53a2.43,2.43,0,0,0-.81-1.14c-.25-.15-.45-.19-.56,0A.33.33,0,0,1,308.67,169.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.29,168.83a13.69,13.69,0,0,1,3.06,1.84c-.55-.26-1.24-.07-1.87.79-.52.7-1,1.4-1.3,1.92-.05.07-.09.15-.13.21l-.8-.48c0-.06.08-.14.13-.21.31-.52.71-1.26,1.09-2.05C320.93,169.89,320.78,169.2,320.29,168.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46,172.77l.41.22.39.26-.21.34-.8-.48C319.32,173,319.38,172.89,319.46,172.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,173.09a.57.57,0,0,0-.08.24.13.13,0,0,0,0,.06v0a.28.28,0,0,0,0,.09s0,0,0,0a.64.64,0,0,0,0,.07h0a2.21,2.21,0,0,0,.9.95,2.12,2.12,0,0,0,1.26.35h.11l.09,0h0l0,0a.52.52,0,0,0,.18-.18.57.57,0,0,0,.08-.24c.06-.34-.32-.86-.93-1.23s-1.26-.47-1.53-.25A.58.58,0,0,0,318,173.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.41,173.57c.12-.2.56-.16,1,.1s.67.63.55.83-.28.16-.52.1c.28,0,.37-.24.18-.5a1.68,1.68,0,0,0-.86-.5c-.21,0-.35,0-.37.16A.25.25,0,0,1,318.41,173.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.37,171.74a8,8,0,0,1,3.73.46c-.65,0-1.28,1-1.63,3-.29,1.63-.53,3.21-.67,4.36a4.49,4.49,0,0,0-.06.48l-1-.12c0-.15,0-.31.06-.49.14-1.14.3-2.73.42-4.38C327.38,173,327,171.94,326.37,171.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.84,179.26l.49,0a2.4,2.4,0,0,1,.48.1c0,.21-.05.42-.07.61l-1-.12C326.79,179.69,326.81,179.48,326.84,179.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.88,180.55a1,1,0,0,0,0,.39l0,.08,0,0a.67.67,0,0,0,.06.12l.05.05a.27.27,0,0,0,.07.08h0a3.28,3.28,0,0,0,1.85.75,3.24,3.24,0,0,0,2-.28h0l.09-.06.06-.05.09-.09,0,0,0-.07a.78.78,0,0,0,.13-.37,1,1,0,0,0,0-.38c-.12-.52-1-1-2.08-1.14s-2,.13-2.29.6A.9.9,0,0,0,324.88,180.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.73,181c0-.36.7-.58,1.45-.49s1.33.46,1.28.82-.28.39-.65.46c.38-.18.37-.57-.06-.8a2.63,2.63,0,0,0-1.53-.17c-.3.08-.48.22-.4.45A.37.37,0,0,1,325.73,181Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1,171.94a12,12,0,0,1,3.78-1.15c-.62.27-.93,1.09-.63,2.49.25,1.14.55,2.22.78,3l.09.33-1,.3c0-.11-.06-.21-.1-.33-.24-.77-.6-1.84-1-2.92C334.48,172.33,333.77,171.82,333.1,171.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,176.46a3.12,3.12,0,0,1,.49-.18l.5-.12c.05.16.09.31.13.45l-1,.3C336.1,176.77,336.05,176.62,336,176.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,178a.68.68,0,0,0,.14.25l0,0,0,0,.08.05.05,0,.07,0h0a2.37,2.37,0,0,0,1.46,0,2.41,2.41,0,0,0,1.24-.78h0a.43.43,0,0,1,0-.07l0,0a.69.69,0,0,0,0-.1v0a.64.64,0,0,1,0-.07.69.69,0,0,0,0-.28.51.51,0,0,0-.13-.24c-.24-.31-1-.38-1.73-.15s-1.33.7-1.36,1.09A.63.63,0,0,0,335.23,178Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.93,178c-.08-.25.29-.59.82-.75s1-.09,1.11.17-.08.34-.31.5c.21-.24.08-.49-.27-.52a2,2,0,0,0-1.08.34c-.17.14-.26.29-.13.42A.27.27,0,0,1,335.93,178Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.88,169.09a23.37,23.37,0,0,1,2.18-1.89c-.29.27-.57.76-.38,1.12a3.25,3.25,0,0,0,.48.75l.06.08-.46.4-.06-.08a3.21,3.21,0,0,0-.7-.55A1,1,0,0,0,339.88,169.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.61,169.38l.22-.21.24-.19.15.17-.46.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,170.7a.52.52,0,0,0,.17.13l.05,0h.2a2.16,2.16,0,0,0,1.64-1.43h0a.13.13,0,0,0,0-.06v-.14a.09.09,0,0,0,0-.05.5.5,0,0,0-.1-.19.52.52,0,0,0-.17-.13c-.27-.14-.8,0-1.27.44s-.72.91-.62,1.19A.52.52,0,0,0,341.46,170.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,170.5c-.13-.15,0-.51.35-.79s.69-.38.83-.23.06.27-.06.45c.07-.23-.1-.37-.36-.28a1.55,1.55,0,0,0-.65.58c-.08.16-.09.28,0,.34A.21.21,0,0,1,342,170.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,164.16a9,9,0,0,1,1.52-3.44c-.16.63-.18,1.18,1.41,2,1.31.67,1.37.75,2.3,1.17l.39.18-.39.89-.4-.17c-.93-.41-1-.43-2.4-.94C345.15,163.23,344.76,163.62,344.41,164.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.07,164.73a3,3,0,0,1,.17-.47,4.34,4.34,0,0,1,.23-.43l.56.25-.39.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,166.64a.65.65,0,0,0,.33.06.22.22,0,0,0,.08,0h0l.12,0,.05,0,.09,0h0a3.33,3.33,0,0,0,1.36-3.06h0l0-.09a.14.14,0,0,1,0-.06l-.06-.1,0,0a.12.12,0,0,0-.05-.05.71.71,0,0,0-.27-.21A1,1,0,0,0,351,163c-.46,0-1.09.56-1.48,1.44s-.41,1.73-.08,2.05A.9.9,0,0,0,349.7,166.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.27,166c-.28-.13-.3-.72,0-1.32s.72-1,1-.86.26.33.22.66c-.06-.37-.38-.45-.68-.16a2.35,2.35,0,0,0-.53,1.23c0,.27.06.46.27.45A.31.31,0,0,1,350.27,166Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52,157.37a8.09,8.09,0,0,1,0-3.17c.08.54.76,1,2.15,1.06a9.75,9.75,0,0,0,1.28.11h.33v.82h-.33a6.91,6.91,0,0,0-1.28.11C347.27,156.4,346.6,156.83,346.52,157.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,156.2a2.77,2.77,0,0,1,0-.42,2.73,2.73,0,0,1,0-.41h.52v.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.75,157.19a.6.6,0,0,0,.24-.05l0,0h0a.18.18,0,0,0,.07,0l0,0a.1.1,0,0,0,0-.05h0a2,2,0,0,0,.32-1.19,1.94,1.94,0,0,0-.33-1.19h0l0-.05,0,0-.07,0h0l0,0a.69.69,0,0,0-.24,0,.59.59,0,0,0-.23,0c-.31.12-.54.68-.54,1.36s.23,1.25.54,1.36A.59.59,0,0,0,350.75,157.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,156.63c-.23,0-.41-.38-.41-.85s.18-.85.41-.85.26.15.33.37c-.14-.22-.38-.18-.49.1a1.61,1.61,0,0,0,0,.95c.08.17.17.27.31.21A.21.21,0,0,1,351,156.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.89,150.85a8,8,0,0,1-1.54-3.44c.37.54,1.48.61,3.37-.12,1.55-.59,3-1.21,4.07-1.67.16-.07.31-.13.44-.2l.4.9-.44.2c-1,.47-2.49,1.15-4,1.9C346.42,149.35,345.73,150.22,345.89,150.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.07,146.57a4.34,4.34,0,0,1-.23-.43,3.36,3.36,0,0,1-.17-.47l.56-.25.4.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,147.45a.74.74,0,0,0,.28-.21l0-.06,0,0,.06-.11a.14.14,0,0,0,0-.06l0-.09h0a3.42,3.42,0,0,0-1.43-3.22h0l-.09,0-.06,0a.27.27,0,0,0-.12,0h-.11a.84.84,0,0,0-.35.07.74.74,0,0,0-.28.21c-.35.34-.33,1.24.08,2.16s1.07,1.54,1.56,1.51A.86.86,0,0,0,354,147.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94,146.58c-.31.13-.78-.27-1.06-.91s-.27-1.25,0-1.39.44,0,.67.3c-.33-.22-.62,0-.6.42a2.38,2.38,0,0,0,.58,1.28c.21.19.4.27.55.1A.38.38,0,0,1,353.94,146.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,144.82a13.46,13.46,0,0,1-2.66-2.39c.49.36,1.2.3,2-.41.63-.58,1.21-1.18,1.62-1.62l.17-.18.69.62-.17.19c-.39.45-.92,1.08-1.43,1.78C342,143.66,342.06,144.37,342.47,144.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,141.14q-.18-.13-.36-.3l-.33-.33.27-.29.69.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,141.1a.6.6,0,0,0,.12-.22s0,0,0-.06v0a.28.28,0,0,0,0-.09v-.05a.15.15,0,0,1,0-.07h0a2.06,2.06,0,0,0-.71-1.09,2.13,2.13,0,0,0-1.16-.59h-.12l-.09,0h0l0,0a.6.6,0,0,0-.21.14.53.53,0,0,0-.12.22c-.13.32.15.91.68,1.39s1.15.69,1.45.53A.6.6,0,0,0,345.49,141.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.19,140.55c-.16.17-.59,0-1-.29s-.54-.74-.38-.91.3-.11.52,0c-.27,0-.41.17-.27.46a1.74,1.74,0,0,0,.76.66c.19.07.34.06.38-.09A.23.23,0,0,1,345.19,140.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,140.83a6.33,6.33,0,0,1-3.58-1.16c.66.06,1.53-1,2.42-3.39.22-.57.82-1.83,1.28-3.22l.19-.58.93.3-.19.58c-.44,1.39-.91,2.89-1,3.3C336.26,139.14,336.37,140.49,336.93,140.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,133.36a3.26,3.26,0,0,1-.48-.11,4.68,4.68,0,0,1-.45-.19l.19-.58.93.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.15,132.48a1.08,1.08,0,0,0,0-.39.29.29,0,0,0,0-.09v0a.5.5,0,0,0-.05-.13l0-.06,0-.1h0a3.15,3.15,0,0,0-1.66-1.09,3.34,3.34,0,0,0-2-.1h0l-.1,0-.06,0-.11.08,0,0-.06.06a1.05,1.05,0,0,0-.2.34,1,1,0,0,0,0,.38c0,.53.78,1.17,1.83,1.51s2,.26,2.36-.16A.94.94,0,0,0,340.15,132.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.39,131.89c-.11.35-.79.44-1.51.2s-1.22-.7-1.11-1,.36-.33.74-.33c-.42.11-.48.49-.1.8a2.65,2.65,0,0,0,1.46.46c.32,0,.52-.13.49-.37A.35.35,0,0,1,339.39,131.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,139.45a9.46,9.46,0,0,1-3.92.42c.65-.18,1.09-1.13,1-3-.07-1.52-.08-1.36-.19-2.41,0-.16,0-.3,0-.44l1-.11c0,.14,0,.28.05.44.12,1,.2.89.45,2.38C329.21,138.58,329.84,139.42,330.52,139.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.45,134.39l-.51.08-.51,0c0-.17,0-.33-.05-.47l1-.11C328.41,134.07,328.43,134.22,328.45,134.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5,133.06a.66.66,0,0,0-.09-.28l0-.05v0l-.07-.07,0,0-.06-.05h0a2.8,2.8,0,0,0-2.81.3h0l-.06.06,0,0a.56.56,0,0,0-.05.08s0,0,0,0,0,0,0,.05a.57.57,0,0,0,0,.29.72.72,0,0,0,.08.26c.18.35.87.56,1.67.47s1.44-.43,1.54-.81A.61.61,0,0,0,329.5,133.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.82,132.89c0,.27-.4.53-1,.59s-1-.11-1.05-.37.14-.33.39-.44c-.24.19-.16.47.18.56a1.85,1.85,0,0,0,1.12-.13c.2-.11.3-.23.21-.39A.32.32,0,0,1,328.82,132.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.26,140.9a25.85,25.85,0,0,1-2.5,1.44c.33-.22.69-.64.58-1a3.86,3.86,0,0,0-.33-.84l-.05-.08.53-.3a.56.56,0,0,1,.05.08,3.09,3.09,0,0,0,.57.68A1,1,0,0,0,323.26,140.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.61,140.28a2.26,2.26,0,0,1-.26.16l-.28.15a1.28,1.28,0,0,0-.11-.2l.53-.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,139a.46.46,0,0,0-.15-.16l0,0h0l-.07,0h-.1a1.72,1.72,0,0,0-1.09.29,1.74,1.74,0,0,0-.8.8h0l0,.06s0,0,0,0,0,.05,0,.07v0a.07.07,0,0,0,0,.05.42.42,0,0,0,.06.21.46.46,0,0,0,.15.16c.23.19.78.12,1.32-.19s.88-.76.83-1.06A.47.47,0,0,0,322,139Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,139.11c.11.18-.11.49-.49.71s-.75.25-.86.07,0-.28.14-.43c-.11.21,0,.38.31.34a1.5,1.5,0,0,0,.74-.44c.11-.14.15-.27,0-.35A.19.19,0,0,1,321.47,139.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22,142.64a16.51,16.51,0,1,1-23.13,3.23A16.51,16.51,0,0,1,340.22,142.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22,142.64a16.51,16.51,0,1,1-23.13,3.23A16.51,16.51,0,0,1,340.22,142.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.08,146.76c2.57,4.17,3,16.65-7.64,22.22s-19.83-3.61-21.64-7.39a16.51,16.51,0,0,0,28.65,4.18A16.51,16.51,0,0,0,344.08,146.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9,165.71a2,2,0,0,1,2.46,1.39c.12.93-.78,1.81-2,2a2,2,0,0,1-2.45-1.39C327.77,166.76,328.67,165.87,329.9,165.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69,168.15c-.46-.36-.08-1.28,1.05-1.5a2,2,0,0,1,2,.59.71.71,0,0,1-.36.94c.24-.3.18-.7-.32-.94a2.14,2.14,0,0,0-2,.08C328.71,167.55,328.57,167.89,328.69,168.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,146.24c-1.23-.19-2.11-1.1-2-2a2,2,0,0,1,2.49-1.33c1.23.19,2.11,1.09,2,2A2,2,0,0,1,333.94,146.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,144.23c.35.48-.28,1.25-1.43,1.15-.91-.08-1.7-.62-1.78-1.14a.7.7,0,0,1,.61-.8c-.32.21-.37.62,0,1a2.18,2.18,0,0,0,2,.49C335.6,144.8,335.83,144.52,335.78,144.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,156.36a1.7,1.7,0,0,1-.91,2.18c-.76.2-1.59-.46-1.85-1.48a1.7,1.7,0,0,1,.91-2.18C324,154.68,324.83,155.34,325.09,156.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.93,155.6c.26-.43,1.06-.2,1.36.72a1.64,1.64,0,0,1-.29,1.76.61.61,0,0,1-.82-.21c.28.18.6.08.76-.36a1.83,1.83,0,0,0-.27-1.67C323.43,155.55,323.14,155.47,322.93,155.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.28,158.18a1.76,1.76,0,1,1,.4,2.79A2,2,0,0,1,334.28,158.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.53,160.6c-.56.16-1.08-.69-.59-1.74.39-.82,1.17-1.38,1.69-1.28a.7.7,0,0,1,.54.84c-.09-.37-.45-.55-.94-.3a2.17,2.17,0,0,0-1.14,1.67C335.06,160.24,335.25,160.55,335.53,160.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,158.72a2,2,0,0,1-1.22,2.54c-.92.18-1.86-.66-2.11-1.88a2,2,0,0,1,1.23-2.54C319,156.66,320,157.5,320.19,158.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.68,157.68c.32-.5,1.27-.17,1.57.94a2,2,0,0,1-.47,2.07.69.69,0,0,1-.95-.3c.31.23.7.14.92-.37a2.18,2.18,0,0,0-.22-2C318.27,157.65,317.92,157.54,317.68,157.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.46,151.72a1.56,1.56,0,1,1,2.33.9A1.81,1.81,0,0,1,333.46,151.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87,151.8c-.12.51-1,.53-1.6-.3a1.73,1.73,0,0,1-.26-1.86.63.63,0,0,1,.89,0c-.33-.09-.63.11-.65.6a1.94,1.94,0,0,0,.81,1.6A.6.6,0,0,0,335.87,151.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.76,147.15c-1.47.9-3.21.73-3.88-.38s0-2.73,1.44-3.63,3.21-.73,3.89.38S328.24,146.26,326.76,147.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,143.38c.79.19.82,1.58-.49,2.5-1,.72-2.35.86-2.92.38a1,1,0,0,1-.06-1.39c-.15.51.16,1,.92,1a3,3,0,0,0,2.52-1.23C327.25,144.14,327.23,143.64,326.93,143.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.27,164.21a1.32,1.32,0,1,1-.35,2.08A1.53,1.53,0,0,1,337.27,164.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,166.22c-.44,0-.61-.74,0-1.37a1.45,1.45,0,0,1,1.49-.53.52.52,0,0,1,.19.72c0-.28-.2-.5-.6-.43a1.63,1.63,0,0,0-1.19.93C337.36,165.85,337.42,166.12,337.61,166.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.29,156.8c.16-1.26,1-2.18,2-2.06a2.07,2.07,0,0,1,1.43,2.49c-.16,1.26-1,2.18-2,2.06A2.07,2.07,0,0,1,340.29,156.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.38,158.62c-.48.36-1.28-.25-1.21-1.42.05-.93.58-1.75,1.11-1.85a.71.71,0,0,1,.83.6c-.23-.32-.64-.36-1,.06a2.2,2.2,0,0,0-.44,2C341.79,158.45,342.09,158.67,342.38,158.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.82,149.73a1.15,1.15,0,1,1,1.77.49A1.33,1.33,0,0,1,339.82,149.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.59,149.61c0,.38-.7.47-1.19-.1a1.24,1.24,0,0,1-.33-1.34.45.45,0,0,1,.64-.1c-.24,0-.45.12-.43.48a1.42,1.42,0,0,0,.71,1.11A.45.45,0,0,0,341.59,149.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,151.63a1.15,1.15,0,1,1-.56-1.75A1.32,1.32,0,0,1,319.6,151.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,150.21c.35-.17.77.33.57,1s-.59,1-.94,1a.45.45,0,0,1-.44-.48c.1.23.35.31.64.09a1.41,1.41,0,0,0,.54-1.2C318.87,150.39,318.72,150.21,318.53,150.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.27,160.77a1.33,1.33,0,0,1,1.49,1.08c0,.61-.64,1.11-1.45,1.13s-1.48-.47-1.49-1.08S327.46,160.78,328.27,160.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,162.26c-.28-.27,0-.84.79-.9a1.26,1.26,0,0,1,1.27.54.46.46,0,0,1-.3.58c.18-.17.17-.44-.13-.64a1.43,1.43,0,0,0-1.32-.09C327.36,161.88,327.25,162.08,327.31,162.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.51,151.05a1.15,1.15,0,1,1,.61-1.73A1.31,1.31,0,0,1,327.51,151.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.51,149.28c.38.07.42.72-.18,1.18a1.26,1.26,0,0,1-1.36.24.46.46,0,0,1-.06-.65c-.06.24.1.46.46.46a1.45,1.45,0,0,0,1.16-.63C327.68,149.63,327.66,149.39,327.51,149.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,164.78a1.15,1.15,0,1,1-1.84,0A1.33,1.33,0,0,1,322.54,164.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85,165.33c-.05-.38.56-.62,1.18-.19s.77.89.65,1.22a.47.47,0,0,1-.6.26c.25,0,.4-.24.3-.58a1.46,1.46,0,0,0-1-.91C321.13,165.07,320.92,165.16,320.85,165.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82,154.12a2.25,2.25,0,1,1-2.86-.7A2.08,2.08,0,0,1,331.82,154.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,155.25c0,.69.68,1.36,1.72,1.19s1.9-1.55,1.23-2.26a1.68,1.68,0,0,1-1.22,1.63A1.27,1.27,0,0,1,328.28,155.25Z",
    style: {
      opacity: 0.1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccineDevelopmentAmico);
export default __webpack_public_path__ + "static/media/vaccine-development-amico.8030b02644c0a7af8287582885d32572.svg";
export { ForwardRef as ReactComponent };